(function() {
    'use strict';

    angular
        .module('portalApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ct.ui.router.extras',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'katex',
            'ui.tab.scroll',
            'angularMoment',
            'ui.bootstrap-slider',
            'chart.js',
            'ngFileSaver',
            'multipleDatePicker'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('YcChartTimeController', YcChartTimeController);

    YcChartTimeController.$inject = ['$state', 'DateUtils', 'YieldCurve', 'subscribedCountryList', 'ycmCurveSeries',
        'ycmBrekevenSRSeries'];

    function YcChartTimeController($state, DateUtils, YieldCurve, subscribedCountryList, ycmCurveSeries,
                                   ycmBrekevenSRSeries) {
        var vm = this;
        vm.ignoreTenors = ['4M'];
        vm.mainView = $state.params.mainView;
        vm.chartType = $state.params.chartType || 'maturity';
        vm.country = subscribedCountryList.find(function (c) {
            return (c.id == $state.params.countryId);
        });
        vm.allCurvesData = chartDataFromYcmSeries();
        vm.selectedTenors = [];
        vm.availableTenors = [];
        vm.selectedSR = [];
        vm.chartData = {
            chartId: "yc-ts-chart-" + vm.country.code,
            lineSeries: [],
            lineLegends: [],
            lineBands: []
        };
        vm.lineWidth = [];
        vm.irsCurveSelected = irsCurveSelected;
        vm.ccyCurveSelected = ccyCurveSelected;
        vm.zeroCurveSelected = zeroCurveSelected;
        vm.irsSharpeRatioSelected = irsSharpeRatioSelected;
        vm.onTenorPicked = onTenorPicked;
        vm.onTenorUnpicked = onTenorUnpicked;
        vm.onSharpeRatioPicked = onSharpeRatioPicked;
        vm.onSharpeRatioUnpicked = onSharpeRatioUnpicked;

        // by default select 1Y & 5Y tenors of IRS curve and only actual SR
        vm.defaultTenorPicks = ['1Y', '5Y'];
        vm.defaultSRPicks = ['actual'];
        irsCurveSelected();

        //***************************************************************
        function irsCurveSelected() {
            vm.curveType = "irs";
            vm.chartTitle = "IRS Yield Curve";
            vm.yAxisTitle = "Yield (% pa, quarterly simple)";
            vm.availableTenors = Object.keys(vm.allCurvesData.irs);
            vm.selectedTenors = [];
            vm.chartData.lineSeries = [];
            vm.chartData.lineLegends = [];
            vm.chartData.lineBands = [];
            vm.lineWidth = [];
            for (var i = 0; i < vm.defaultTenorPicks.length; i++) {
                onTenorPicked(vm.defaultTenorPicks[i]);
            }
        }

        function ccyCurveSelected() {
            vm.curveType = "ccy";
            vm.chartTitle = "Cross Currency Float-to-Fix Yield Curve";
            vm.yAxisTitle = "Yield (% pa, continuous)";
            vm.availableTenors = Object.keys(vm.allCurvesData.ccy);
            vm.selectedTenors = [];
            vm.chartData.lineSeries = [];
            vm.chartData.lineLegends = [];
            vm.chartData.lineBands = [];
            vm.lineWidth = [];
            for (var i = 0; i < vm.defaultTenorPicks.length; i++) {
                onTenorPicked(vm.defaultTenorPicks[i]);
            }
        }

        function zeroCurveSelected() {
            vm.curveType = "zero";
            vm.chartTitle = "Government Zero Curve";
            vm.yAxisTitle = "Yield (% pa, continuous)";
            vm.availableTenors = Object.keys(vm.allCurvesData.zero);
            vm.selectedTenors = [];
            vm.chartData.lineSeries = [];
            vm.chartData.lineLegends = [];
            vm.chartData.lineBands = [];
            vm.lineWidth = [];
            for (var i = 0; i < vm.defaultTenorPicks.length; i++) {
                onTenorPicked(vm.defaultTenorPicks[i]);
            }
        }

        function irsSharpeRatioSelected() {
            vm.curveType = "irsSr";
            vm.chartTitle = "Sharpe Ratios IRS";
            vm.yAxisTitle = "Fraction";
            vm.availableTenors = Object.keys(vm.allCurvesData.irsSr);
            vm.selectedTenors = [];
            vm.chartData.lineSeries = [];
            vm.chartData.lineLegends = [];
            vm.chartData.lineBands = [];
            vm.lineWidth = [];
            vm.selectedSR = angular.copy(vm.defaultSRPicks);
            for (var i = 0; i < vm.defaultTenorPicks.length; i++) {
                onTenorPicked(vm.defaultTenorPicks[i]);
            }
        }

        function onTenorPicked(tenorLabel) {
            if (vm.selectedTenors.includes(tenorLabel)) {
                onTenorUnpicked(tenorLabel);
            } else {
                vm.selectedTenors.push(tenorLabel);
                if (vm.curveType === 'irsSr') {
                    if (vm.selectedSR.includes('actual') && angular.isDefined(vm.allCurvesData.irsSr[tenorLabel])) {
                        vm.chartData.lineSeries.push(vm.allCurvesData.irsSr[tenorLabel]);
                        vm.chartData.lineLegends.push(tenorLabel + ' (actual)');
                        vm.chartData.lineBands.push(0);
                        vm.lineWidth.push(3);
                    }
                    if (vm.selectedSR.includes('break-even') && angular.isDefined(vm.allCurvesData.irsSr[tenorLabel])) {
                        vm.chartData.lineSeries.push(vm.allCurvesData.irsSrBreakeven[tenorLabel]);
                        vm.chartData.lineLegends.push(tenorLabel + ' (break-even)');
                        vm.chartData.lineBands.push(vm.allCurvesData.irsSrBreakevenStd[tenorLabel]);
                        vm.lineWidth.push(1.5);
                    }
                } else {
                    vm.chartData.lineSeries.push(vm.allCurvesData[vm.curveType][tenorLabel]);
                    vm.chartData.lineLegends.push(tenorLabel);
                    vm.chartData.lineBands.push(0);
                    vm.lineWidth.push(3);
                }
            }
        }

        function onTenorUnpicked(tenorLabel) {
            const tenorIx = vm.selectedTenors.findIndex(function (lb) {
                return lb === tenorLabel;
            });
            if (tenorIx > -1) {
                vm.selectedTenors.splice(tenorIx, 1);
            }
            var tenorLabelList = (vm.curveType === 'irsSr')
                ? [tenorLabel + ' (actual)', tenorLabel + ' (break-even)']
                : [tenorLabel];
            for (var i = 0; i < tenorLabelList.length; i++) {
                const thisTenorLabel = tenorLabelList[i];
                const curveIndex = vm.chartData.lineLegends
                    .findIndex(function (elem) {
                        return elem === thisTenorLabel;
                    });
                if (curveIndex > -1) {
                    //remove line from the chart
                    vm.chartData.lineSeries.splice(curveIndex, 1);
                    //remove line from the chart legend
                    vm.chartData.lineLegends.splice(curveIndex, 1);
                    // drop confidence bands width
                    vm.chartData.lineBands.splice(curveIndex, 1);
                    // drop line width
                    vm.lineWidth.splice(curveIndex, 1);
                }
            }
        }

        function onSharpeRatioPicked(sharpeRatioLabel) {
            var thisCurveType = (sharpeRatioLabel === 'actual')
                ? 'irsSr'
                : 'irsSrBreakeven';
            if (vm.selectedSR.includes(sharpeRatioLabel)) {
                onSharpeRatioUnpicked(sharpeRatioLabel);
            } else {
                vm.selectedSR.push(sharpeRatioLabel);
                for (var i = 0; i < vm.selectedTenors.length; i++) {
                    const thisTenorLabel = vm.selectedTenors[i];
                    if (angular.isDefined(vm.allCurvesData[thisCurveType][thisTenorLabel])) {
                        vm.chartData.lineSeries.push(vm.allCurvesData[thisCurveType][thisTenorLabel]);
                        vm.chartData.lineLegends.push(thisTenorLabel + ' (' + sharpeRatioLabel + ')');
                        vm.chartData.lineBands.push((sharpeRatioLabel === 'actual') ? 0 : vm.allCurvesData.irsSrBreakevenStd[thisTenorLabel]);
                        vm.lineWidth.push((sharpeRatioLabel === 'actual') ? 3 : 1.5);
                    }
                }
            }
        }

        function onSharpeRatioUnpicked(sharpeRatioLabel) {
            const srIx = vm.selectedSR.findIndex(function (lb) {
                return lb === sharpeRatioLabel;
            });
            if (srIx > -1) {
                vm.selectedSR.splice(srIx, 1);
            }
            for (var i = 0; i < vm.selectedTenors.length; i++) {
                const thisTenorLabel = vm.selectedTenors[i];
                var curveIndex = vm.chartData.lineLegends
                    .findIndex(function (elem) {
                        return elem === thisTenorLabel + ' (' + sharpeRatioLabel + ')';
                    });
                if (curveIndex > -1) {
                    //remove line from the chart
                    vm.chartData.lineSeries.splice(curveIndex, 1);
                    //remove line from the chart legend
                    vm.chartData.lineLegends.splice(curveIndex, 1);
                    // drop confidence bands width
                    vm.chartData.lineBands.splice(curveIndex, 1);
                    // drop line width
                    vm.lineWidth.splice(curveIndex, 1);
                }
            }
        }

        function chartDataFromYcmSeries() {
            var resData = {zero: {}, irs: {}, ccy: {}, irsSr: {}, irsSrBreakeven: {}, irsSrBreakevenStd: {}};
            const curves = {
                zero: 'gov_zero_curve',
                irs: 'irs_quarterly',
                ccy: 'ccy_continuous',
                irsSr: 'sharpe_ratio_irs'
            };
            for (var crv in curves) {
                const thisCrv = crv;
                const thisCrvIx = ycmCurveSeries.findIndex(function (el) {
                    return el.name === curves[thisCrv];
                });
                if (thisCrvIx > -1 && angular.isArray(ycmCurveSeries[thisCrvIx].data)) {
                    const thisSeriesList = ycmCurveSeries[thisCrvIx].data;
                    for (var i = 0; i < thisSeriesList.length; i++) {
                        const thisSeries = thisSeriesList[i];
                        // do not add series for ignored tenors
                        if (vm.ignoreTenors.includes(thisSeries.name)) {
                            continue;
                        }
                        const tsData = thisSeries.timeseriesData.filter(function (d) {
                            return d.value !== 'NaN';
                        });
                        // sort timeseries by dates
                        if (thisSeries.name && angular.isArray(tsData) && tsData.length > 0) {
                            resData[thisCrv][thisSeries.name] = tsData
                                .sort(function (a, b) {
                                    return new Date(a.date) - new Date(b.date);
                                });
                        }
                        // in case of CCY remove 5Y tenor before 2019-04-18 when we started publishing that
                        if (thisCrv === 'ccy' && thisSeries.name && thisSeries.name === '5Y') {
                            resData[thisCrv][thisSeries.name] = resData[thisCrv][thisSeries.name]
                                .filter(function (t) {
                                    return new Date(t.date) >= new Date('2019-04-18');
                                });
                        }
                    }
                }
            }
            // irsSrBreakeven series
            for (i = 0; i < ycmBrekevenSRSeries.length; i++) {
                const thisSeries = ycmBrekevenSRSeries[i];
                // do not add series for ignored tenors
                if (vm.ignoreTenors.includes(thisSeries.name)) {
                    continue;
                }
                const tsData = thisSeries.data.filter(function (d) {
                    return d.value !== 'NaN';
                });
                // sort timeseries by dates
                if (thisSeries.name && angular.isArray(tsData) && tsData.length > 0) {
                    resData.irsSrBreakeven[thisSeries.name] = tsData
                        .sort(function (a, b) {
                            return new Date(a.date) - new Date(b.date);
                        });
                }
            }
            // irsSrBreakevenStd
            const thisCrvIx = ycmCurveSeries.findIndex(function (el) {
                return el.name === 'sharpe_ratio_irs_breakeven_std';
            });
            if (thisCrvIx > -1 && angular.isArray(ycmCurveSeries[thisCrvIx].data)) {
                const thisSeriesList = ycmCurveSeries[thisCrvIx].data;
                for (i = 0; i < thisSeriesList.length; i++) {
                    const thisSeries = thisSeriesList[i];
                    // do not add series for ignored tenors
                    if (vm.ignoreTenors.includes(thisSeries.name)) {
                        continue;
                    }
                    const tsData = thisSeries.timeseriesData.filter(function (d) {
                        return d.value !== 'NaN';
                    });
                    // sort timeseries by dates and get the last value
                    if (thisSeries.name && angular.isArray(tsData) && tsData.length > 0) {
                        const thisValue = tsData
                            .sort(function (a, b) {
                                return new Date(a.date) - new Date(b.date);
                            })[tsData.length - 1].value;
                        resData.irsSrBreakevenStd[thisSeries.name] = thisValue || 0;
                    }
                }
            }
            return resData;
        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('YcChartMaturityController', YcChartMaturityController);

    YcChartMaturityController.$inject = ['$state', 'DateUtils', 'YieldCurve', 'subscribedCountryList', 'allYcmRounds'];

    function YcChartMaturityController($state, DateUtils, YieldCurve, subscribedCountryList, allYcmRounds) {
        var vm = this;
        vm.mainView = $state.params.mainView;
        vm.chartType = $state.params.chartType || 'maturity';
        vm.country = subscribedCountryList.find(function (c) {
            return (c.id == $state.params.countryId);
        });
        vm.allYcmRounds = allYcmRounds;
        vm.langKey = 'en';
        //convert available dates to Moment objects
        vm.availableDates = allYcmRounds.map(function (ycmr) {
            return moment(ycmr.created).set('hour', 12);
        });
        //sort available dates ascending and get the latest available date if any
        vm.lastAvailable = null;
        if (vm.availableDates && vm.availableDates.length > 0) {
            vm.availableDates.sort(function (a, b) {
                return a.utc() - b.utc();
            });
            vm.lastAvailable = vm.availableDates[vm.availableDates.length - 1];
        }
        vm.selectedDates = [];
        //switch to the month of the latest available date
        vm.activeMonth = vm.lastAvailable;
        //define default data set for the chart
        vm.chartData = {
            chartId: "yc-chart-" + vm.country.code,
            lineSeries: {irs: [], ccy: [], zero: [], irsSr: []},
            lineLegends: []
        };
        vm.curveType = "irs";
        vm.chartTitle = "IRS Yield Curve";
        vm.yAxisTitle = "Yield (% pa, quarterly simple)";
        vm.chartMinTenor = 0;
        vm.chartMaxTenor = 3653;
        vm.minSlider = 2;
        vm.maxSlider = 10;
        vm.sliderStep = 2;
        vm.curveRangeLimit = 10;
        vm.curveRangeModel = 10;
        //list all the methods
        vm.chartDataFromYcmResults = chartDataFromYcmResults;
        vm.clearDates = clearDates;
        vm.selectCurrent = selectCurrent;
        vm.onCurveRangeChanged = onCurveRangeChanged;
        vm.onCurveRangeSaved = onCurveRangeSaved;
        vm.onDaySelected = onDaySelected;
        vm.irsCurveSelected = irsCurveSelected;
        vm.ccyCurveSelected = ccyCurveSelected;
        vm.zeroCurveSelected = zeroCurveSelected;
        vm.irsSharpeRatioSelected = irsSharpeRatioSelected;
        vm.selectCurrent();

        //***************************************************************
        function irsCurveSelected() {
            if (vm.curveType === "ccy" && vm.curveRangeLimit === 5) {
                vm.chartMaxTenor = 3653;
                vm.curveRangeLimit = 10;
                vm.curveRangeModel = 10;
            }
            vm.curveType = "irs";
            vm.chartTitle = "IRS Yield Curve";
            vm.maxSlider = 10;
            vm.sliderStep = 2;
            vm.yAxisTitle = "Yield (% pa, quarterly simple)";
        }

        function ccyCurveSelected() {
            vm.curveType = "ccy";
            vm.chartTitle = "Cross Currency Float-to-Fix Yield Curve";
            vm.maxSlider = 5;
            vm.sliderStep = 1;
            vm.chartMaxTenor = Math.min(1827, vm.chartMaxTenor);
            vm.curveRangeLimit = Math.min(5, vm.curveRangeLimit);
            vm.curveRangeModel = Math.min(5, vm.curveRangeModel);
            vm.yAxisTitle = "Yield (% pa, continuous)";
        }

        function zeroCurveSelected() {
            if (vm.curveType === "ccy" && vm.curveRangeLimit === 5) {
                vm.chartMaxTenor = 3653;
                vm.curveRangeLimit = 10;
                vm.curveRangeModel = 10;
            }
            vm.curveType = "zero";
            vm.chartTitle = "Government Zero Curve";
            vm.maxSlider = 10;
            vm.sliderStep = 2;
            vm.yAxisTitle = "Yield (% pa, continuous)";
        }

        function irsSharpeRatioSelected() {
            if (vm.curveType === "ccy" && vm.curveRangeLimit === 5) {
                vm.chartMaxTenor = 3653;
                vm.curveRangeLimit = 10;
                vm.curveRangeModel = 10;
            }
            vm.curveType = "irsSr";
            vm.chartTitle = "Sharpe Ratios IRS";
            vm.maxSlider = 10;
            vm.sliderStep = 2;
            vm.yAxisTitle = "Fraction";
        }

        function onCurveRangeChanged() {
            vm.curveRangeLimit = Math.max(2, vm.curveRangeModel);
        }

        function onCurveRangeSaved() {
            vm.chartMaxTenor = vm.curveRangeLimit * 365 + Math.ceil(vm.curveRangeLimit / 4);
        }

        function onDaySelected(event, dateObj) {
            var unselected = dateObj.mdp.selected;
            var dateString = DateUtils.convertLocalDateToServer(dateObj.date.toDate());
            if (unselected) {
                var curveIndex = vm.chartData.lineLegends
                    .findIndex(function (elem) {
                        return elem === dateString;
                    });
                if (curveIndex > -1) {
                    //remove line from the chart
                    vm.chartData.lineSeries.irs.splice(curveIndex, 1);
                    vm.chartData.lineSeries.ccy.splice(curveIndex, 1);
                    vm.chartData.lineSeries.zero.splice(curveIndex, 1);
                    vm.chartData.lineSeries.irsSr.splice(curveIndex, 1);
                    //remove line from the chart legend
                    vm.chartData.lineLegends.splice(curveIndex, 1);
                }
            } else {
                var resIndex = vm.allYcmRounds.findIndex(function (ycmr) {
                    return dateString == ycmr.created;
                });
                if (resIndex > -1) {
                    //load curves data
                    YieldCurve
                        .query({
                            roundId: vm.allYcmRounds[resIndex].id,
                            actionCode: 'yo'
                        })
                        .$promise
                        .then(chartDataFromYcmResults)
                        .catch(function () {
                            return [];
                        });
                }
            }
        }

        function clearDates() {
            vm.chartData = {
                chartId: "yc_chart",
                lineSeries: {irs: [], ccy: [], zero: [], irsSr: []},
                lineLegends: []
            };
            vm.selectedDates = [];
        }

        /**
         * Adds latest available curve to the chart (if any)
         */
        function selectCurrent() {
            if (vm.lastAvailable && vm.selectedDates.findIndex(function (dt) {
                return dt === vm.lastAvailable;
            }) === -1) {
                vm.selectedDates.push(vm.lastAvailable);
                vm.activeMonth = vm.lastAvailable;
                onDaySelected([], {date: vm.lastAvailable, mdp: {selected: false}});
            }
        }

        /**
         * Converts YCM results to the input structure for yc-chart directive
         * @param ycmResults -- resulting array of curves
         */
        function chartDataFromYcmResults(ycmResults) {
            const curves = {
                zero: 'gov_zero_curve',
                irs: 'irs_quarterly',
                ccy: 'ccy_continuous',
                irsSr: 'sharpe_ratio_irs'
            };
            const curveNames = Object.keys(curves);
            var dateString = 'undefined';
            for (var i = 0; i < curveNames.length; i++) {
                const cName = curveNames[i];
                const res = ycmResults.find(function (el) {
                    return el.name === curves[cName];
                });
                if (angular.isUndefined(res) || angular.isUndefined(res.yieldCurveData)) {
                    vm.chartData.lineSeries[cName].push([]);
                } else {
                    vm.chartData.lineSeries[cName].push(res.yieldCurveData.map(reduceYcData));
                    dateString = res.date;
                }
            }
            vm.chartData.lineLegends.push(dateString);
        }

        /**
         * Slims down the object to contain only those fields needed for chart
         * @param ycData -- array of yield curve data points
         * @returns {{tenorDays: *, tenorLabel: *, value: *}}
         */
        function reduceYcData(ycData) {
            return {
                tenorDays: ycData.tenorDays,
                tenorLabel: ycData.tenorLabel,
                value: ycData.value
            };
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('YcChartController', YcChartController);

    YcChartController.$inject = ['$state', 'subscribedCountryList', 'latestYcmRound'];

    function YcChartController($state, subscribedCountryList, latestYcmRound) {
        var vm = this;
        vm.mainView = $state.params.mainView;
        vm.chartType = $state.params.chartType || 'maturity';
        vm.country = subscribedCountryList.find(function (c) {
            return (c.id == $state.params.countryId);
        });
        vm.latestYcmRound = latestYcmRound;
        vm.switchToTable = switchToTable;
        vm.onTabSelected = onTabSelected;

        //***************************************************************


        function onTabSelected(tabName) {
            $state.go('selectedCountry', {countryId: vm.country.id, mainView: 'yc-chart', chartType: tabName});
        }

        /**
         * Switches the main panel to the actual view
         */
        function switchToTable() {
            $state.go('selectedCountry', {countryId: vm.country.id, mainView: 'actual', chartType: null});
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('YcmCalculation', YcmCalculation);

    YcmCalculation.$inject = ['$resource'];

    function YcmCalculation($resource) {
        var resourceUrl = 'api/ycm-calculation/';

        return function (curveType, isAsync) {
            if (angular.isUndefined(isAsync)) {
                isAsync = false;
            }
            if (isAsync) {
                return 0;
            }
            return $resource(resourceUrl + curveType + '/', {}, {
                'calculate': {method: 'POST', isArray: true}
            });
        };
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('TimeSeriesData', TimeSeriesData);

    TimeSeriesData.$inject = ['$resource', 'DateUtils'];

    function TimeSeriesData ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('SummaryFile', SummaryFile);

    SummaryFile.$inject = ['$resource'];

    function SummaryFile($resource) {
        var resourceUrl = 'api/resources/summary-file';

        return $resource(resourceUrl, {}, {
            'download': {
                method: 'GET',
                responseType: "arraybuffer",
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('SubscribedCountries', SubscribedCountries);

    SubscribedCountries.$inject = ['$resource'];

    function SubscribedCountries ($resource) {
        var resourceUrl =  'api/subscribedCountries';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('SeriesExport', SeriesExport);

    SeriesExport.$inject = ['$resource'];

    function SeriesExport($resource) {
        var resourceUrl = 'api/timeseriesExport';
        return function (exportType) {
            if (exportType === 'excel') {
                return $resource(resourceUrl + '/excel/', {}, {
                    'query': {
                        method: 'GET',
                        responseType: "arraybuffer",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
            }
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ResourceLink', ResourceLink);

    ResourceLink.$inject = ['$resource'];

    function ResourceLink ($resource) {
        var resourceUrl =  'resource/round/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('FpasSeries', FpasSeries);

    FpasSeries.$inject = ['$resource', 'DateUtils'];

    function FpasSeries ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data/fpas';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('EwsSeries', EwsSeries);

    EwsSeries.$inject = ['$resource', 'DateUtils'];

    function EwsSeries ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data/ews';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('DataExport', DataExport);

    DataExport.$inject = ['$resource'];

    function DataExport($resource) {
        var resourceUrl = 'api/dataExport';
        return function (exportType) {
            if (exportType === 'excel') {
                return $resource(resourceUrl + '/excel/', {}, {
                    'query': {
                        method: 'GET',
                        responseType: "arraybuffer",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
            }
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CountryRiskAndRating', CountryRiskAndRating);

    CountryRiskAndRating.$inject = ['$resource'];

    function CountryRiskAndRating ($resource) {
        var resourceUrl =  'api/risk-and-rating';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CountryRisk', CountryRisk);

    CountryRisk.$inject = ['$resource'];

    function CountryRisk ($resource) {
        var resourceUrl =  'api/risks';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CountryRating', CountryRating);

    CountryRating.$inject = ['$resource'];

    function CountryRating ($resource) {
        var resourceUrl =  'api/rating';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CountryNote', CountryNote);

    CountryNote.$inject = ['$resource'];

    function CountryNote ($resource) {
        var resourceUrl =  'api/country-notes';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('VerifySubscription', VerifySubscription);

    VerifySubscription.$inject = ['$resource'];

    function VerifySubscription ($resource) {

        var resourceUrl =  'api/verify-subscription';

        return $resource(resourceUrl, {}, {
            'verify': {
                method: 'GET',
                isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('VerifyApplicationFeature', VerifyApplicationFeature);

    VerifyApplicationFeature.$inject = ['$resource'];

    function VerifyApplicationFeature ($resource) {

        var resourceUrl =  'api/verify-app-feature';

        return $resource(resourceUrl, {}, {
            'verify': {
                method: 'GET',
                isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('hasSubscription', hasSubscription);

    hasSubscription.$inject = ['VerifySubscription', 'Principal'];

    function hasSubscription(VerifySubscription, Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var applicationName = attrs.hasSubscription.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function () {

                    VerifySubscription.verify({applicationName:applicationName}).$promise
                        .then(function (result) {
                            if (result.data == true) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        })
                        .catch(function () {
                            setHidden();
                            // alert(result || 'Request failed');
                        });
                };

            if (applicationName.length > 0) {
                setHidden();

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility();
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('hasApplicationFeature', hasApplicationFeature);

    hasApplicationFeature.$inject = ['VerifyApplicationFeature', 'Principal'];

    function hasApplicationFeature(VerifyApplicationFeature, Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var applicationFeature = attrs.hasApplicationFeature.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function () {

                    VerifyApplicationFeature.verify({applicationFeature:applicationFeature}).$promise
                        .then(function (result) {
                            if (result.data == true) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        })
                        .catch(function () {
                            setHidden();
                            // alert(result || 'Request failed');
                        });
                };

            if (applicationFeature.length > 0) {
                setHidden();

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility();
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state -- redirect to home
                        $state.go('home');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('portalApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'Base64'];

    function AuthServerProvider ($http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires_at && token.expires_at > new Date().getTime();
        }

        function login (credentials) {
            var data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=my-secret-token-to-change-in-production&client_id=ycmportalapp';

            return $http.post('oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('ycmportalapp' + ':' + 'my-secret-token-to-change-in-production')
                }
            }).success(authSucess);

            function authSucess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                return response;
            }
        }

        function logout () {
            $http.post('api/logout').then(function() {
                delete $localStorage.authenticationToken;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        // public page (no login): IRS and cross-currency curves of all published countries
        $stateProvider.state('public-curves', {
            parent: 'app',
            url: '/curves',
            data: {
                authorities: [],
                pageTitle: 'publicCurves.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public-curves/public-curves.html',
                    controller: 'PublicCurvesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicCurves');
                    return $translate.refresh();
                }],
                publicCurves: ['$q', 'PublicCurves', function ($q, PublicCurves) {
                    return PublicCurves.get().$promise
                        .catch(function () {
                            return $q.when(null);
                        });
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('PublicCurves', PublicCurves);

    PublicCurves.$inject = ['$resource'];

    function PublicCurves($resource) {
        var resourceUrl = 'api/open/ycm/public-curves';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .controller('PublicCurvesController', PublicCurvesController);

    PublicCurvesController.$inject = ['DateUtils', 'publicCurves'];

    function PublicCurvesController(DateUtils, publicCurves) {
        var vm = this;

        vm.curves = publicCurves;
        // the date comes from the server (Prague); today's local date only if the curves could not be loaded
        vm.date = (publicCurves && publicCurves.date) ? DateUtils.convertLocalDateFromServer(publicCurves.date) : new Date();
        vm.conventionsUrl = 'content/pdf/EBRD curves conventions.pdf';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('main', {
                parent: 'home',
                url: 'overview/',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'main.pageTitle.overview'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/main/main.html',
                        controller: 'MainController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('main');
                        return $translate.refresh();
                    }],
                    // list of countries the current user is subscribed for
                    subscribedCountryList: ['SubscribedCountries', function (SubscribedCountries) {
                        return SubscribedCountries.query({}).$promise;
                    }],
                    // latest YCM rounds of all subscribed countries
                    latestYcmRoundList: ['$q', '$stateParams', 'Round', 'subscribedCountryList', function ($q, $stateParams, Round, subscribedCountryList) {
                        var promises = [];
                        for (var ix = 0; ix < subscribedCountryList.length; ix++) {
                            const thisIx = ix;
                            promises.push(Round.get({
                                "countryId": subscribedCountryList[ix].id,
                                "productCode": "YCM",
                                "applicationName": "ycm"
                            }).$promise
                                .catch(function () {
                                    return $q.when({
                                        countryId: subscribedCountryList[thisIx].id,
                                        countryName: subscribedCountryList[thisIx].name,
                                        created: null
                                    });
                                }));
                        }
                        return $q.all(promises);
                    }],
                    // resources for all the latest YCM rounds of all subscribed countries
                    latestYcmResourcesList: ['$q', '$stateParams', 'Resource', 'latestYcmRoundList', function ($q, $stateParams, Resource, latestYcmRoundList) {
                        var promises = [];
                        for (var ix = 0; ix < latestYcmRoundList.length; ix++) {
                            if (!latestYcmRoundList[ix].id) {
                                promises.push($q.when([]));
                                continue;
                            }
                            promises.push(Resource.query({
                                roundId: latestYcmRoundList[ix].id,
                                productCode: "YCM"
                            }).$promise
                                .catch(function () {
                                    return $q.when([]);
                                }));
                        }
                        return $q.all(promises);
                    }]
                }
            })
            .state('selectedCountry', {
                parent: 'main',
                url: 'country-page/{countryId}',
                data: {
                    pageTitle: 'main.pageTitle.countryPage'
                },
                params: {
                    countryId: null,
                    countryName: null,
                    mainView: 'actual',
                    chartType: null
                },
                views: {
                    'actual': {
                        templateUrl: 'app/actual/actual.html',
                        controller: 'ActualController',
                        controllerAs: 'vm',
                        resolve: {
                            latestYcmResources: ['$q', 'Resource', 'latestYcmRound', function ($q, Resource, latestYcmRound) {
                                if (latestYcmRound === null) {
                                    return $q.when([]);
                                }
                                return Resource
                                    .query({
                                        roundId: latestYcmRound.id,
                                        productCode: "YCM"
                                    })
                                    .$promise;
                            }],
                            latestYcmResults: ['$q', 'YieldCurve', 'latestYcmRound', function ($q, YieldCurve, latestYcmRound) {
                                if (latestYcmRound === null) {
                                    return $q.when([]);
                                }
                                return YieldCurve
                                    .query({
                                        roundId: latestYcmRound.id,
                                        actionCode: 'yo'
                                    })
                                    .$promise
                                    .catch(function () {
                                        return $q.when([]);
                                    });
                            }]
                        }
                    },
                    'yc-chart': {
                        templateUrl: 'app/yc-chart/yc-chart.html',
                        controller: 'YcChartController',
                        controllerAs: 'vm'
                    },
                    'yc-chart-maturity@selectedCountry': {
                        templateUrl: 'app/yc-chart/yc-chart-maturity.html',
                        controller: 'YcChartMaturityController',
                        controllerAs: 'vm'
                    },
                    'yc-chart-time@selectedCountry': {
                        templateUrl: 'app/yc-chart/yc-chart-time.html',
                        controller: 'YcChartTimeController',
                        controllerAs: 'vm',
                        resolve: {
                            ycmCurveSeries: ['$q', 'allYcmRounds', 'YieldCurve', function ($q, allYcmRounds, YieldCurve) {
                                const curves = [
                                    'gov_zero_curve',
                                    'irs_quarterly',
                                    'ccy_continuous',
                                    'sharpe_ratio_irs',
                                    'sharpe_ratio_irs_breakeven_std'
                                ];
                                // get the list of this country YCM round IDs
                                const roundIdList = allYcmRounds.map(function (ycmr) {
                                    return ycmr.id;
                                });
                                var promises = [];
                                for (var ix = 0; ix < curves.length; ix++) {
                                    const thisCurve = curves[ix];
                                    promises.push(
                                        YieldCurve.query({
                                            roundIdList: roundIdList,
                                            curveName: thisCurve,
                                            actionCode: 'yo',
                                            maxTenor: 3650
                                        }).$promise
                                            .then(function (response) {
                                                return $q.when({name: thisCurve, data: response});
                                            })
                                            .catch(function () {
                                                return $q.when({name: thisCurve, data: []});
                                            }));
                                }
                                return $q.all(promises);
                            }],
                            ycmBrekevenSRSeries: ['$q', 'latestYcmRound', 'TimeSeriesData', function ($q, latestYcmRound, TimeSeriesData) {
                                var tenorList = ['3M', '6M', '1Y', '2Y', '3Y', '4Y', '5Y'];
                                var promises = [];
                                for (var ix = 0; ix < tenorList.length; ix++) {
                                    const thisTenor = tenorList[ix];
                                    promises.push(
                                        TimeSeriesData.query({
                                            roundId: latestYcmRound.id,
                                            actionCode: 'yo',
                                            applicationVariable: 'sharpe_ratio_irs_breakeven_' + thisTenor,
                                            applicationId: 6,
                                            noDateLimit: true
                                        }).$promise
                                            .then(function (response) {
                                                return $q.when({name: thisTenor, data: response});
                                            })
                                            .catch(function () {
                                                return $q.when({name: thisTenor, data: []});
                                            }));
                                }
                                return $q.all(promises);
                            }]
                        }
                    },
                    'fpas': {
                        templateUrl: 'app/fpas/fpas.html',
                        controller: 'FpasController',
                        controllerAs: 'vm',
                        resolve: {
                            latestFullFpasResources: ['$q', 'Resource', 'latestFullFpasRound', function ($q, Resource, latestFullFpasRound) {
                                if (latestFullFpasRound === null) {
                                    return $q.when([]);
                                }
                                return Resource
                                    .query({
                                        roundId: latestFullFpasRound.id,
                                        productCode: "FPAS"
                                    })
                                    .$promise;
                            }],
                            latestFpasResources: ['$q', 'Resource', 'latestFpasRound', function ($q, Resource, latestFpasRound) {
                                if (latestFpasRound === null) {
                                    return $q.when([]);
                                }
                                return Resource
                                    .query({
                                        roundId: latestFpasRound.id,
                                        productCode: "FPAS",
                                        addCpiCsv: true
                                    })
                                    .$promise;
                            }],
                            allFpasResources: ['$q', 'Resource', 'allFpasRounds', function ($q, Resource, allFpasRounds) {
                                if (allFpasRounds === null || allFpasRounds.length === 0) {
                                    return $q.when([]);
                                }
                                var promises = [];
                                for (var ix = 0; ix < allFpasRounds.length; ix++) {
                                    promises.push(Resource
                                        .query({
                                            roundId: allFpasRounds[ix].id,
                                            productCode: "FPAS",
                                            addCpiCsv: true
                                        })
                                        .$promise);
                                }
                                return $q.all(promises);
                            }]
                        }
                    },
                    'archive': {
                        templateUrl: 'app/archive/archive.html',
                        controller: 'ArchiveController',
                        controllerAs: 'vm',
                        resolve: {
                            archiveResources: ['$q', 'Resource', 'allYcmRounds', function ($q, Resource, allYcmRounds) {
                                if (allYcmRounds === null || allYcmRounds.length === 0) {
                                    return $q.when([]);
                                }
                                var promises = [];
                                for (var ix = 0; ix < allYcmRounds.length; ix++) {
                                    promises.push(Resource
                                        .query({
                                            roundId: allYcmRounds[ix].id,
                                            productCode: "YCM"
                                        })
                                        .$promise);
                                }
                                return $q.all(promises);
                            }]
                        }
                    },
                    'country-note': {
                        templateUrl: 'app/country-note/country-note.html',
                        controller: 'CountryNoteController',
                        controllerAs: 'vm',
                        resolve: {
                            countryNotes: ['$q', '$stateParams', 'CountryNote', function ($q, $stateParams, CountryNote) {
                                return CountryNote.query({
                                    "countryId": $stateParams.countryId
                                }).$promise
                                    .catch(function () {
                                        return $q.when([]);
                                    });
                            }]
                        }
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', 'subscribedCountryList', '$stateParams', '$state',
                        function ($translate, $translatePartialLoader, subscribedCountryList, $stateParams, $state) {
                            $translatePartialLoader.addPart('country');
                            var countryObj = subscribedCountryList.find(function (c) {
                                return (c.id == $stateParams.countryId);
                            });
                            $stateParams.countryName = countryObj.name;
                            return $translate.refresh();
                        }],
                    latestYcmRound: ['$q', '$stateParams', 'Round', function ($q, $stateParams, Round) {
                        return Round.get({
                            "countryId": $stateParams.countryId,
                            "productCode": "YCM",
                            "applicationName": "ycm"
                        }).$promise
                            .catch(function () {
                                return $q.when({});
                            });
                    }],
                    allYcmRounds: ['$q', '$stateParams', 'Round', function ($q, $stateParams, Round) {
                        return Round.query({
                            "countryId": $stateParams.countryId,
                            "productCode": "YCM"
                        }).$promise
                            .catch(function () {
                                return $q.when([]);
                            });
                    }],
                    allFpasRounds: ['$q', '$stateParams', 'Round', function ($q, $stateParams, Round) {
                        return Round.query({
                            "countryId": $stateParams.countryId,
                            "productCode": "FPAS"
                        }).$promise
                            .catch(function () {
                                return $q.when([]);
                            });
                    }],
                    latestFullFpasRound: ['$q', '$stateParams', 'Round', function ($q, $stateParams, Round) {
                        return Round.get({
                            "countryId": $stateParams.countryId,
                            "productCode": "FPAS",
                            "applicationName": "fpas",
                            "typeFilter": "regular"
                        }).$promise
                            .catch(function () {
                                return $q.when({});
                            });
                    }],
                    latestFpasRound: ['$q', '$stateParams', 'Round', function ($q, $stateParams, Round) {
                        return Round.get({
                            "countryId": $stateParams.countryId,
                            "productCode": "FPAS",
                            "applicationName": "fpas"
                        }).$promise
                            .catch(function () {
                                return $q.when({});
                            });
                    }]
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$http', '$state', '$scope', '$window', '$uibModal', '$filter', 'Principal', 'Auth',
        'subscribedCountryList', 'latestYcmRoundList', 'latestYcmResourcesList', 'Resource', 'DataUtils',
        'SummaryFile'];

    function MainController($http, $state, $scope, $window, $uibModal, $filter, Principal, Auth,
        subscribedCountryList, latestYcmRoundList, latestYcmResourcesList, Resource, DataUtils,
        SummaryFile) {

        var vm = this;
        vm.$state = $state;
        //exclude external sector from the list of countries for the panel
        vm.subscribedCountryList = subscribedCountryList.filter(function (country) {
            return (country.id !== 73);
        });
        vm.latestYcmRoundList = latestYcmRoundList;
        vm.latestYcmResourcesList = latestYcmResourcesList.map(function (res) {
            var resNew = {roundId: -1, resList: []};
            if (res.length > 0) {
                resNew.roundId = angular.copy(res[0].roundId);
                resNew.resList = angular.copy(res);
            }
            return resNew;
        });

        vm.onCountrySelected = onCountrySelected;
        vm.showAcceptProtectionPolicy = showAcceptProtectionPolicy;
        vm.resourcesForRound = resourcesForRound;
        vm.downloadResource = downloadResource;
        vm.downloadSummary = downloadSummary;
        vm.verifyProtectionPolicyAcceptance = verifyProtectionPolicyAcceptance;

        vm.verifyProtectionPolicyAcceptance();

        function onCountrySelected(countryId) {
            // when switching between countries show the same "subpage" (mainView + chartType)
            // but when leaving from 'overview' always show the 'actual' mainView
            if (!$state.includes('selectedCountry')) {
                $state.go('selectedCountry', {
                    countryId: countryId,
                    mainView: 'actual',
                    chartType: null
                });
            } else {
                $state.go('selectedCountry', {
                    countryId: countryId,
                    mainView: $state.params.mainView,
                    chartType: $state.params.chartType
                });
            }
        }

        function resourcesForRound(id) {
            if (angular.isUndefined(id)) {
                return null;
            }
            var ix = vm.latestYcmResourcesList.findIndex(function (el) {
                return el.roundId === id;
            });
            if (ix === -1) {
                return null;
            }
            return vm.latestYcmResourcesList[ix].resList.map(function (res) {
                if (res.description.indexOf("YCM-YIELD-CURVE-SPREADSHEET") !== -1) {
                    res.ix = 0;
                    res.desc = "YCM Report Table";
                    res.ext = "csv";
                    res.icon = "fa fa-file-excel-o fa-fw";
                } else if (res.description.indexOf("YCM-DAILY-ZERO-CURVE-SPREADSHEET") !== -1) {
                    res.ix = 1;
                    res.desc = "Daily Zero Curve Table";
                    res.ext = "csv";
                    res.icon = "fa fa-file-excel-o fa-fw";
                } else if (res.description.indexOf("YCM-DAILY-CCY-CURVE-SPREADSHEET") !== -1) {
                    res.ix = 2;
                    res.desc = "Daily CCY Rates Table";
                    res.ext = "csv";
                    res.icon = "fa fa-file-excel-o fa-fw";
                } else if (res.description.indexOf("YCM-IRS-BREAKEVEN-SPREADSHEET") !== -1) {
                    res.ix = 3;
                    res.desc = "Historical Break-Even Table";
                    res.ext = "csv";
                    res.icon = "fa fa-file-excel-o fa-fw";
                } else {
                    res.ix = 4;
                    res.desc = "Unknown file";
                    res.ext = "";
                    res.icon = "fa fa-file-o fa-fw";
                }
                return res;
            });
        }

        /**
         * Triggers downloading -- either proper resource downloading from SVN or a data export
         * @param res   -- resource object
         * @param round -- round object
         */
        function downloadResource(res, round) {
            Resource
                .download({id: res.id, download: true})
                .$promise
                .then(function (response) {
                    var fileName = round.countryName + " -- " + res.desc + " ("
                        + $filter('date')(round.created, 'dd-MMM-yyyy')
                        + ")" + ((res.ext === "") ? "" : ("." + res.ext));
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName);
                });

        }

        function downloadSummary(provider) {
            SummaryFile
                .download({provider: provider})
                .$promise
                .then(function (response) {
                    var fileName = "YCM-OGResearch-"+ provider
                        //+ $filter('date')(new Date(), 'dd-MMM-yyyy')
                        +".csv";
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName);
                });

        }

        function verifyProtectionPolicyAcceptance() {
            $http({
                method: 'GET',
                url: '/api/user_acceptance?code=GDPR-text'
            }).then(function (response) {
                // this is ok
            }, function (response) {
                vm.showAcceptProtectionPolicy();
            });
        }

        function showAcceptProtectionPolicy() {
            $uibModal.open({
                templateUrl: 'app/admin/protection-policy/protection-policy.modal.html',
                controller: 'ProtectionPolicyModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerDisabled = response.swaggerDisabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('FooterService', FooterService);

    FooterService.$inject = ['$resource'];

    function FooterService ($resource) {
        var resourceUrl =  'api/open/app-version';

        return $resource(resourceUrl);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .controller('FooterController', FooterController);

    FooterController.$inject = ['$state', 'FooterService'];

    function FooterController($state, FooterService) {
        var vm = this;

        vm.$state = $state;
        vm.applicationVersion = "";
        vm.year = new Date().getFullYear();

        FooterService.get().$promise.then(function (response) {
            vm.applicationVersion = response.applicationVersion;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.
            state('home', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    },
                    'login-inline@home':{
                        templateUrl: 'app/components/login/login-inline.html',
                        controller: 'LoginInlineController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'DateUtils', 'PublicCurves'];

    function HomeController ($scope, Principal, LoginService, $state, DateUtils, PublicCurves) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.hasAnyAuthority = null;
        vm.login = LoginService.open;
        vm.register = register;
        // the public IRS and cross-currency curves (as on #/curves), loaded for anonymous visitors only; a failure shows
        // a notice and never holds up the sign-in box
        vm.curves = null;
        vm.curvesLoaded = false;
        vm.date = new Date();
        vm.conventionsUrl = 'content/pdf/EBRD curves conventions.pdf';
        var curvesRequested = false;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.hasAnyAuthority = Principal.hasAnyAuthority;
                if (vm.isAuthenticated()) {
                    $state.go('main');
                } else {
                    loadCurves();
                }
            });
        }

        function loadCurves() {
            if (curvesRequested) {
                return;
            }
            curvesRequested = true;
            PublicCurves.get().$promise.then(function (curves) {
                vm.curves = curves;
                // the date comes from the server (Prague), as on the public curves page
                if (curves && curves.date) {
                    vm.date = DateUtils.convertLocalDateFromServer(curves.date);
                }
            }).catch(function () {
                vm.curves = null;
            }).finally(function () {
                vm.curvesLoaded = true;
            });
        }


        function register () {
            $state.go('register');
        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('FpasController', FpasController);

    FpasController.$inject = ['$filter', '$state', 'subscribedCountryList', 'allFpasRounds', 'allFpasResources', 'latestFullFpasRound', 'latestFullFpasResources',
        'latestFpasRound', 'latestFpasResources', 'DataUtils', 'Resource'];

    function FpasController($filter, $state, subscribedCountryList, allFpasRounds, allFpasResources, latestFullFpasRound, latestFullFpasResources,
                            latestFpasRound, latestFpasResources, DataUtils, Resource) {
        var vm = this;
        vm.downloadResource = downloadResource;
        vm.country = subscribedCountryList.find(function (c) {
            return (c.id == $state.params.countryId);
        });
        vm.latestFpasRound = latestFpasRound;
        vm.latestFullFpasRound = latestFullFpasRound;
        vm.olderFpasRounds = allFpasRounds.filter(function (r) {
            return r.id !== vm.latestFpasRound.id;
        });
        vm.olderFpasCpiResource = [];
        for (var i = 0; i < vm.olderFpasRounds.length; i++) {
            const rnd = vm.olderFpasRounds[i];
            const resIx = allFpasResources.findIndex(function (rs) {
                return rs && rs.length && rs[0].roundId === rnd.id;
            });
            var thisCpiResource = null;
            if (resIx !== -1) {
                const cpiResIndex = allFpasResources[resIx].findIndex(function (el) {
                    return el.filename.indexOf("monthly_cpi") !== -1;
                });
                if (cpiResIndex !== -1) {
                    thisCpiResource = angular.copy(allFpasResources[resIx][cpiResIndex]);
                    thisCpiResource.desc = 'Monthly CPI Data';
                    thisCpiResource.ext = "csv";
                }
            }
            vm.olderFpasCpiResource.push(thisCpiResource);
        }
        vm.cpiArchiveOpen = false;
        // if round is not found (doesn't exist or not subscribed) => stop here
        if (latestFullFpasRound !== null && !angular.equals(latestFullFpasRound, {})) {
            // pre-process the resources (add descriptions, icon types, ordering etc.)
            vm.fpasResources = latestFullFpasResources.map(function (res) {
                if (res.filename.indexOf("presentation") !== -1) {
                    res.ix = 3;
                    res.desc = "Presentation";
                    res.ext = "pdf";
                    res.icon = "fa fa-file-pdf-o fa-fw";
                } else if (res.filename.indexOf("screening") !== -1) {
                    res.ix = 2;
                    res.desc = "Data Screening Report";
                    res.ext = "pdf";
                    res.icon = "fa fa-file-pdf-o fa-fw";
                } else if (res.filename.indexOf("short") !== -1) {
                    res.ix = 0;
                    res.desc = "Forecast Summary";
                    res.ext = "pdf";
                    res.icon = "fa fa-file-pdf-o fa-fw";
                } else {
                    res.ix = 4;
                    res.desc = "Unknown file";
                    res.ext = "";
                    res.icon = "fa fa-file-o fa-fw";
                }
                return res;
            });
        }
        const cpiResIndex = latestFpasResources.findIndex(function (el) {
            return el.filename.indexOf("monthly_cpi") !== -1;
        });
        vm.cpiResource = null;
        if (cpiResIndex !== -1) {
            vm.cpiResource = latestFpasResources[cpiResIndex];
            vm.cpiResource.desc = 'Monthly CPI Data';
            vm.cpiResource.ext = "csv";
        }

        /**
         * Triggers downloading -- either proper resource downloading from SVN or a data export
         * @param res -- resource object
         */
        function downloadResource(res, thisRound) {
            Resource
                .download({id: res.id, download: true})
                .$promise
                .then(function (response) {
                    var fileName = vm.country.name + " -- " + res.desc + " ("
                        + $filter('date')(thisRound.created, 'dd-MMM-yyyy')
                        + ")" + ((res.ext === "") ? "" : ("." + res.ext));
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName);
                });

        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('YieldCurveData', YieldCurveData);

    YieldCurveData.$inject = ['$resource', 'DateUtils'];

    function YieldCurveData($resource, DateUtils) {
        var resourceUrl = 'api/yield-curve-data/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.yieldCurveDate = DateUtils.convertDateTimeFromServer(data.yieldCurveDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('YieldCurve', YieldCurve);

    YieldCurve.$inject = ['$resource', 'DateUtils'];

    function YieldCurve($resource, DateUtils) {
        var resourceUrl = 'api/yield-curve/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserGroupDialogController', UserGroupDialogController);

    UserGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserGroup'];

    function UserGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UserGroup) {
        var vm = this;

        vm.userGroup = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userGroup.id !== null) {
                UserGroup.update(vm.userGroup, onSaveSuccess, onSaveError);
            } else {
                UserGroup.save(vm.userGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:userGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserGroupDetailController', UserGroupDetailController);

    UserGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'UserGroup'];

    function UserGroupDetailController($scope, $rootScope, $stateParams, entity, UserGroup) {
        var vm = this;

        vm.userGroup = entity;

        var unsubscribe = $rootScope.$on('portalApp:userGroupUpdate', function(event, result) {
            vm.userGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserGroupDeleteController',UserGroupDeleteController);

    UserGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserGroup'];

    function UserGroupDeleteController($uibModalInstance, entity, UserGroup) {
        var vm = this;

        vm.userGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-group', {
            parent: 'entity',
            url: '/user-group?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.userGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-group/user-groups.html',
                    controller: 'UserGroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-group-detail', {
            parent: 'entity',
            url: '/user-group/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.userGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-group/user-group-detail.html',
                    controller: 'UserGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserGroup', function($stateParams, UserGroup) {
                    return UserGroup.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('user-group.new', {
            parent: 'user-group',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-group/user-group-dialog.html',
                    controller: 'UserGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-group', null, { reload: true });
                }, function() {
                    $state.go('user-group');
                });
            }]
        })
        .state('user-group.edit', {
            parent: 'user-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-group/user-group-dialog.html',
                    controller: 'UserGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserGroup', function(UserGroup) {
                            return UserGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-group', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-group.delete', {
            parent: 'user-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-group/user-group-delete-dialog.html',
                    controller: 'UserGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserGroup', function(UserGroup) {
                            return UserGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-group', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('UserGroup', UserGroup);

    UserGroup.$inject = ['$resource'];

    function UserGroup ($resource) {
        var resourceUrl =  'api/user-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('UserGroupSearch', UserGroupSearch);

    UserGroupSearch.$inject = ['$resource'];

    function UserGroupSearch($resource) {
        var resourceUrl =  'api/_search/user-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserGroupController', UserGroupController);

    UserGroupController.$inject = ['$scope', '$state', 'UserGroup', 'UserGroupSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function UserGroupController ($scope, $state, UserGroup, UserGroupSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                UserGroupSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                UserGroup.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.userGroups = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TranslationDialogController', TranslationDialogController);

    TranslationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Translation'];

    function TranslationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Translation) {
        var vm = this;

        vm.translation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.translation.id !== null) {
                Translation.update(vm.translation, onSaveSuccess, onSaveError);
            } else {
                Translation.save(vm.translation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:translationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TranslationDetailController', TranslationDetailController);

    TranslationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Translation'];

    function TranslationDetailController($scope, $rootScope, $stateParams, entity, Translation) {
        var vm = this;

        vm.translation = entity;

        var unsubscribe = $rootScope.$on('portalApp:translationUpdate', function(event, result) {
            vm.translation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TranslationDeleteController',TranslationDeleteController);

    TranslationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Translation'];

    function TranslationDeleteController($uibModalInstance, entity, Translation) {
        var vm = this;

        vm.translation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Translation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('translation', {
            parent: 'entity',
            url: '/translation',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.translation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translation/translations.html',
                    controller: 'TranslationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('translation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('translation-detail', {
            parent: 'entity',
            url: '/translation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.translation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translation/translation-detail.html',
                    controller: 'TranslationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('translation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Translation', function($stateParams, Translation) {
                    return Translation.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('translation.new', {
            parent: 'translation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/translation/translation-dialog.html',
                    controller: 'TranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                keyPhrase: null,
                                languageKey: null,
                                translation: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('translation', null, { reload: true });
                }, function() {
                    $state.go('translation');
                });
            }]
        })
        .state('translation.edit', {
            parent: 'translation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/translation/translation-dialog.html',
                    controller: 'TranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Translation', function(Translation) {
                            return Translation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('translation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('translation.delete', {
            parent: 'translation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/translation/translation-delete-dialog.html',
                    controller: 'TranslationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Translation', function(Translation) {
                            return Translation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('translation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Translation', Translation);

    Translation.$inject = ['$resource'];

    function Translation ($resource) {
        var resourceUrl =  'api/translations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('TranslationSearch', TranslationSearch);

    TranslationSearch.$inject = ['$resource'];

    function TranslationSearch($resource) {
        var resourceUrl =  'api/_search/translations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TranslationController', TranslationController);

    TranslationController.$inject = ['$scope', '$state', 'Translation', 'TranslationSearch'];

    function TranslationController ($scope, $state, Translation, TranslationSearch) {
        var vm = this;

        vm.translations = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Translation.query(function(result) {
                vm.translations = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            TranslationSearch.query({query: vm.searchQuery}, function(result) {
                vm.translations = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDataDialogController', TimeseriesDataDialogController);

    TimeseriesDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'TimeseriesData', 'Timeseries', 'Revision'];

    function TimeseriesDataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, TimeseriesData, Timeseries, Revision) {
        var vm = this;

        vm.timeseriesData = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.timeseries = Timeseries.query();
        vm.revisions = Revision.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.timeseriesData.id !== null) {
                TimeseriesData.update(vm.timeseriesData, onSaveSuccess, onSaveError);
            } else {
                TimeseriesData.save(vm.timeseriesData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:timeseriesDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
/*
        vm.setObject_values = function ($file, timeseriesData) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        timeseriesData.object_values = base64Data;
                        timeseriesData.object_valuesContentType = $file.type;
                    });
                });
            }
        };
*/
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDataDetailController', TimeseriesDataDetailController);

    TimeseriesDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'TimeseriesData', 'Timeseries', 'Revision'];

    function TimeseriesDataDetailController($scope, $rootScope, $stateParams, DataUtils, entity, TimeseriesData, Timeseries, Revision) {
        var vm = this;

        vm.timeseriesData = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('portalApp:timeseriesDataUpdate', function(event, result) {
            vm.timeseriesData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDataDeleteController',TimeseriesDataDeleteController);

    TimeseriesDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'TimeseriesData'];

    function TimeseriesDataDeleteController($uibModalInstance, entity, TimeseriesData) {
        var vm = this;

        vm.timeseriesData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TimeseriesData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('timeseries-data', {
            parent: 'entity',
            url: '/timeseries-data',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseriesData.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries-data/timeseries-data.html',
                    controller: 'TimeseriesDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseriesData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('timeseries-data-detail', {
            parent: 'entity',
            url: '/timeseries-data/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseriesData.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-detail.html',
                    controller: 'TimeseriesDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseriesData');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TimeseriesData', function($stateParams, TimeseriesData) {
                    return TimeseriesData.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('timeseries-data.new', {
            parent: 'timeseries-data',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-dialog.html',
                    controller: 'TimeseriesDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                period: null,
                                date: null,
                                value: null,
                                object_count: null,
                                object_type: null,
                                object_values: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('timeseries-data', null, { reload: true });
                }, function() {
                    $state.go('timeseries-data');
                });
            }]
        })
        .state('timeseries-data.edit', {
            parent: 'timeseries-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-dialog.html',
                    controller: 'TimeseriesDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TimeseriesData', function(TimeseriesData) {
                            return TimeseriesData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries-data', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('timeseries-data.delete', {
            parent: 'timeseries-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-delete-dialog.html',
                    controller: 'TimeseriesDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TimeseriesData', function(TimeseriesData) {
                            return TimeseriesData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries-data', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('TimeseriesData', TimeseriesData);

    TimeseriesData.$inject = ['$resource', 'DateUtils'];

    function TimeseriesData ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('TimeseriesDataSearch', TimeseriesDataSearch);

    TimeseriesDataSearch.$inject = ['$resource'];

    function TimeseriesDataSearch($resource) {
        var resourceUrl =  'api/_search/timeseries-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDataController', TimeseriesDataController);

    TimeseriesDataController.$inject = ['$scope', '$state', 'DataUtils', 'TimeseriesData', 'TimeseriesDataSearch', 'ParseLinks', 'AlertService'];

    function TimeseriesDataController ($scope, $state, DataUtils, TimeseriesData, TimeseriesDataSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.timeseriesData = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                TimeseriesDataSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TimeseriesData.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.timeseriesData.push(data[i]);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.timeseriesData = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.timeseriesData = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.timeseriesData = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDialogController', TimeseriesDialogController);

    TimeseriesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Timeseries', 'Country', 'Frequency', 'TimeseriesData'];

    function TimeseriesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Timeseries, Country, Frequency, TimeseriesData) {
        var vm = this;

        vm.timeseries = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query();
        vm.frequencies = Frequency.query();
        vm.timeseriesdata = TimeseriesData.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.timeseries.id !== null) {
                Timeseries.update(vm.timeseries, onSaveSuccess, onSaveError);
            } else {
                Timeseries.save(vm.timeseries, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:timeseriesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDetailController', TimeseriesDetailController);

    TimeseriesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Timeseries', 'Country', 'Frequency', 'TimeseriesData'];

    function TimeseriesDetailController($scope, $rootScope, $stateParams, entity, Timeseries, Country, Frequency, TimeseriesData) {
        var vm = this;

        vm.timeseries = entity;

        var unsubscribe = $rootScope.$on('portalApp:timeseriesUpdate', function(event, result) {
            vm.timeseries = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDeleteController',TimeseriesDeleteController);

    TimeseriesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Timeseries'];

    function TimeseriesDeleteController($uibModalInstance, entity, Timeseries) {
        var vm = this;

        vm.timeseries = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Timeseries.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('timeseries', {
            parent: 'entity',
            url: '/timeseries',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseries.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries/timeseries.html',
                    controller: 'TimeseriesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseries');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('timeseries-detail', {
            parent: 'entity',
            url: '/timeseries/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseries.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries/timeseries-detail.html',
                    controller: 'TimeseriesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseries');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Timeseries', function($stateParams, Timeseries) {
                    return Timeseries.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('timeseries.new', {
            parent: 'timeseries',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries/timeseries-dialog.html',
                    controller: 'TimeseriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('timeseries', null, { reload: true });
                }, function() {
                    $state.go('timeseries');
                });
            }]
        })
        .state('timeseries.edit', {
            parent: 'timeseries',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries/timeseries-dialog.html',
                    controller: 'TimeseriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Timeseries', function(Timeseries) {
                            return Timeseries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('timeseries.delete', {
            parent: 'timeseries',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries/timeseries-delete-dialog.html',
                    controller: 'TimeseriesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Timeseries', function(Timeseries) {
                            return Timeseries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Timeseries', Timeseries);

    Timeseries.$inject = ['$resource'];

    function Timeseries ($resource) {
        var resourceUrl =  'api/timeseries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('TimeseriesSearch', TimeseriesSearch);

    TimeseriesSearch.$inject = ['$resource'];

    function TimeseriesSearch($resource) {
        var resourceUrl =  'api/_search/timeseries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesController', TimeseriesController);

    TimeseriesController.$inject = ['$scope', '$state', 'Timeseries', 'TimeseriesSearch', 'ParseLinks', 'AlertService'];

    function TimeseriesController ($scope, $state, Timeseries, TimeseriesSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.timeseries = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                TimeseriesSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Timeseries.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.timeseries.push(data[i]);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.timeseries = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.timeseries = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.timeseries = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SubscriptionDialogController', SubscriptionDialogController);

    SubscriptionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Subscription', 'UserGroup', 'Application', 'Country'];

    function SubscriptionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Subscription, UserGroup, Application, Country) {
        var vm = this;

        vm.subscription = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.usergroups = UserGroup.query();
        vm.applications = Application.query();
        vm.countries = Country.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.subscription.id !== null) {
                Subscription.update(vm.subscription, onSaveSuccess, onSaveError);
            } else {
                Subscription.save(vm.subscription, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:subscriptionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SubscriptionDetailController', SubscriptionDetailController);

    SubscriptionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Subscription', 'UserGroup', 'Application', 'Country'];

    function SubscriptionDetailController($scope, $rootScope, $stateParams, entity, Subscription, UserGroup, Application, Country) {
        var vm = this;

        vm.subscription = entity;

        var unsubscribe = $rootScope.$on('portalApp:subscriptionUpdate', function(event, result) {
            vm.subscription = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SubscriptionDeleteController',SubscriptionDeleteController);

    SubscriptionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Subscription'];

    function SubscriptionDeleteController($uibModalInstance, entity, Subscription) {
        var vm = this;

        vm.subscription = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Subscription.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subscription', {
            parent: 'entity',
            url: '/subscription?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.subscription.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription/subscriptions.html',
                    controller: 'SubscriptionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subscription');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('subscription-detail', {
            parent: 'entity',
            url: '/subscription/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.subscription.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription/subscription-detail.html',
                    controller: 'SubscriptionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subscription');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Subscription', function($stateParams, Subscription) {
                    return Subscription.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('subscription.new', {
            parent: 'subscription',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-dialog.html',
                    controller: 'SubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startDate: null,
                                endDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: true });
                }, function() {
                    $state.go('subscription');
                });
            }]
        })
        .state('subscription.edit', {
            parent: 'subscription',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-dialog.html',
                    controller: 'SubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Subscription', function(Subscription) {
                            return Subscription.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscription.delete', {
            parent: 'subscription',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-delete-dialog.html',
                    controller: 'SubscriptionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Subscription', function(Subscription) {
                            return Subscription.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Subscription', Subscription);

    Subscription.$inject = ['$resource', 'DateUtils'];

    function Subscription ($resource, DateUtils) {
        var resourceUrl =  'api/subscriptions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('SubscriptionSearch', SubscriptionSearch);

    SubscriptionSearch.$inject = ['$resource'];

    function SubscriptionSearch($resource) {
        var resourceUrl =  'api/_search/subscriptions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SubscriptionController', SubscriptionController);

    SubscriptionController.$inject = ['$scope', '$state', 'Subscription', 'SubscriptionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SubscriptionController ($scope, $state, Subscription, SubscriptionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SubscriptionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Subscription.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.subscriptions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SmootherMultiplierDialogController', SmootherMultiplierDialogController);

    SmootherMultiplierDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SmootherMultiplier', 'ModelSymbol', 'Timeseries'];

    function SmootherMultiplierDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SmootherMultiplier, ModelSymbol, Timeseries) {
        var vm = this;

        vm.smootherMultiplier = entity;
        vm.clear = clear;
        vm.save = save;
        vm.modelsymbols = ModelSymbol.query({filter: 'smoothermultiplier-is-null'});
        $q.all([vm.smootherMultiplier.$promise, vm.modelsymbols.$promise]).then(function() {
            if (!vm.smootherMultiplier.modelSymbolId) {
                return $q.reject();
            }
            return ModelSymbol.get({id : vm.smootherMultiplier.modelSymbolId}).$promise;
        }).then(function(modelSymbol) {
            vm.modelsymbols.push(modelSymbol);
        });
        vm.timeseriess = Timeseries.query({filter: 'smoothermultiplier-is-null'});
        $q.all([vm.smootherMultiplier.$promise, vm.timeseriess.$promise]).then(function() {
            if (!vm.smootherMultiplier.timeseriesId) {
                return $q.reject();
            }
            return Timeseries.get({id : vm.smootherMultiplier.timeseriesId}).$promise;
        }).then(function(timeseries) {
            vm.timeseries.push(timeseries);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.smootherMultiplier.id !== null) {
                SmootherMultiplier.update(vm.smootherMultiplier, onSaveSuccess, onSaveError);
            } else {
                SmootherMultiplier.save(vm.smootherMultiplier, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:smootherMultiplierUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SmootherMultiplierDetailController', SmootherMultiplierDetailController);

    SmootherMultiplierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SmootherMultiplier', 'ModelSymbol', 'Timeseries'];

    function SmootherMultiplierDetailController($scope, $rootScope, $stateParams, entity, SmootherMultiplier, ModelSymbol, Timeseries) {
        var vm = this;

        vm.smootherMultiplier = entity;

        var unsubscribe = $rootScope.$on('portalApp:smootherMultiplierUpdate', function(event, result) {
            vm.smootherMultiplier = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SmootherMultiplierDeleteController',SmootherMultiplierDeleteController);

    SmootherMultiplierDeleteController.$inject = ['$uibModalInstance', 'entity', 'SmootherMultiplier'];

    function SmootherMultiplierDeleteController($uibModalInstance, entity, SmootherMultiplier) {
        var vm = this;

        vm.smootherMultiplier = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SmootherMultiplier.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('smoother-multiplier', {
            parent: 'entity',
            url: '/smoother-multiplier',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.smootherMultiplier.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multipliers.html',
                    controller: 'SmootherMultiplierController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smootherMultiplier');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('smoother-multiplier-detail', {
            parent: 'entity',
            url: '/smoother-multiplier/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.smootherMultiplier.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-detail.html',
                    controller: 'SmootherMultiplierDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smootherMultiplier');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SmootherMultiplier', function($stateParams, SmootherMultiplier) {
                    return SmootherMultiplier.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('smoother-multiplier.new', {
            parent: 'smoother-multiplier',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-dialog.html',
                    controller: 'SmootherMultiplierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('smoother-multiplier', null, { reload: true });
                }, function() {
                    $state.go('smoother-multiplier');
                });
            }]
        })
        .state('smoother-multiplier.edit', {
            parent: 'smoother-multiplier',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-dialog.html',
                    controller: 'SmootherMultiplierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SmootherMultiplier', function(SmootherMultiplier) {
                            return SmootherMultiplier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('smoother-multiplier', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('smoother-multiplier.delete', {
            parent: 'smoother-multiplier',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-delete-dialog.html',
                    controller: 'SmootherMultiplierDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SmootherMultiplier', function(SmootherMultiplier) {
                            return SmootherMultiplier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('smoother-multiplier', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('SmootherMultiplier', SmootherMultiplier);

    SmootherMultiplier.$inject = ['$resource'];

    function SmootherMultiplier ($resource) {
        var resourceUrl =  'api/smoother-multipliers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('SmootherMultiplierSearch', SmootherMultiplierSearch);

    SmootherMultiplierSearch.$inject = ['$resource'];

    function SmootherMultiplierSearch($resource) {
        var resourceUrl =  'api/_search/smoother-multipliers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SmootherMultiplierController', SmootherMultiplierController);

    SmootherMultiplierController.$inject = ['$scope', '$state', 'SmootherMultiplier', 'SmootherMultiplierSearch'];

    function SmootherMultiplierController ($scope, $state, SmootherMultiplier, SmootherMultiplierSearch) {
        var vm = this;

        vm.smootherMultipliers = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            SmootherMultiplier.query(function(result) {
                vm.smootherMultipliers = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SmootherMultiplierSearch.query({query: vm.searchQuery}, function(result) {
                vm.smootherMultipliers = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RoundDialogController', RoundDialogController);

    RoundDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Round', 'Product', 'Country', 'Model'];

    function RoundDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Round, Product, Country, Model) {
        var vm = this;

        vm.round = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.products = Product.query();
        vm.countries = Country.query();
        vm.models = Model.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.round.id !== null) {
                Round.update(vm.round, onSaveSuccess, onSaveError);
            } else {
                Round.save(vm.round, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:roundUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.lastHist = false;
        vm.datePickerOpenStatus.lastFore = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RoundDetailController', RoundDetailController);

    RoundDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Round', 'Product', 'Country', 'Model'];

    function RoundDetailController($scope, $rootScope, $stateParams, entity, Round, Product, Country, Model) {
        var vm = this;

        vm.round = entity;

        var unsubscribe = $rootScope.$on('portalApp:roundUpdate', function(event, result) {
            vm.round = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RoundDeleteController',RoundDeleteController);

    RoundDeleteController.$inject = ['$uibModalInstance', 'entity', 'Round'];

    function RoundDeleteController($uibModalInstance, entity, Round) {
        var vm = this;

        vm.round = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Round.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('round', {
            parent: 'entity',
            url: '/round',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.round.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/round/rounds.html',
                    controller: 'RoundController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('round');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('round-detail', {
            parent: 'entity',
            url: '/round/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.round.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/round/round-detail.html',
                    controller: 'RoundDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('round');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Round', function($stateParams, Round) {
                    return Round.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('round.new', {
            parent: 'round',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/round/round-dialog.html',
                    controller: 'RoundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                roundCode: null,
                                blacklisted: null,
                                created: null,
                                lastHist: null,
                                lastFore: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('round', null, { reload: true });
                }, function() {
                    $state.go('round');
                });
            }]
        })
        .state('round.edit', {
            parent: 'round',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/round/round-dialog.html',
                    controller: 'RoundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Round', function(Round) {
                            return Round.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('round', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('round.delete', {
            parent: 'round',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/round/round-delete-dialog.html',
                    controller: 'RoundDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Round', function(Round) {
                            return Round.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('round', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Round', Round);

    Round.$inject = ['$resource', 'DateUtils'];

    function Round ($resource, DateUtils) {
        var resourceUrl =  'api/rounds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertLocalDateFromServer(data.created);
                        data.lastHist = DateUtils.convertLocalDateFromServer(data.lastHist);
                        data.lastFore = DateUtils.convertLocalDateFromServer(data.lastFore);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.created = DateUtils.convertLocalDateToServer(data.created);
                    data.lastHist = DateUtils.convertLocalDateToServer(data.lastHist);
                    data.lastFore = DateUtils.convertLocalDateToServer(data.lastFore);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.created = DateUtils.convertLocalDateToServer(data.created);
                    data.lastHist = DateUtils.convertLocalDateToServer(data.lastHist);
                    data.lastFore = DateUtils.convertLocalDateToServer(data.lastFore);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('RoundSearch', RoundSearch);

    RoundSearch.$inject = ['$resource'];

    function RoundSearch($resource) {
        var resourceUrl =  'api/_search/rounds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RoundController', RoundController);

    RoundController.$inject = ['$scope', '$state', 'Round', 'RoundSearch', 'ParseLinks', 'AlertService'];

    function RoundController ($scope, $state, Round, RoundSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.rounds = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                RoundSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Round.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.rounds.push(data[i]);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.rounds = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.rounds = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.rounds = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RevisionDialogController', RevisionDialogController);

    RevisionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Revision'];

    function RevisionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Revision) {
        var vm = this;

        vm.revision = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.revision.id !== null) {
                Revision.update(vm.revision, onSaveSuccess, onSaveError);
            } else {
                Revision.save(vm.revision, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:revisionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RevisionDetailController', RevisionDetailController);

    RevisionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Revision'];

    function RevisionDetailController($scope, $rootScope, $stateParams, entity, Revision) {
        var vm = this;

        vm.revision = entity;

        var unsubscribe = $rootScope.$on('portalApp:revisionUpdate', function(event, result) {
            vm.revision = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RevisionDeleteController',RevisionDeleteController);

    RevisionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Revision'];

    function RevisionDeleteController($uibModalInstance, entity, Revision) {
        var vm = this;

        vm.revision = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Revision.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('revision', {
            parent: 'entity',
            url: '/revision',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.revision.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/revision/revisions.html',
                    controller: 'RevisionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('revision');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('revision-detail', {
            parent: 'entity',
            url: '/revision/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.revision.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/revision/revision-detail.html',
                    controller: 'RevisionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('revision');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Revision', function($stateParams, Revision) {
                    return Revision.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('revision.new', {
            parent: 'revision',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/revision/revision-dialog.html',
                    controller: 'RevisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('revision', null, { reload: true });
                }, function() {
                    $state.go('revision');
                });
            }]
        })
        .state('revision.edit', {
            parent: 'revision',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/revision/revision-dialog.html',
                    controller: 'RevisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Revision', function(Revision) {
                            return Revision.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('revision', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('revision.delete', {
            parent: 'revision',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/revision/revision-delete-dialog.html',
                    controller: 'RevisionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Revision', function(Revision) {
                            return Revision.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('revision', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Revision', Revision);

    Revision.$inject = ['$resource'];

    function Revision ($resource) {
        var resourceUrl =  'api/revisions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('RevisionSearch', RevisionSearch);

    RevisionSearch.$inject = ['$resource'];

    function RevisionSearch($resource) {
        var resourceUrl =  'api/_search/revisions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RevisionController', RevisionController);

    RevisionController.$inject = ['$scope', '$state', 'Revision', 'RevisionSearch', 'ParseLinks', 'AlertService'];

    function RevisionController ($scope, $state, Revision, RevisionSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.revisions = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                RevisionSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Revision.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.revisions.push(data[i]);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.revisions = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.revisions = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.revisions = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultSeriesDialogController', ResultSeriesDialogController);

    ResultSeriesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'ResultSeries', 'Result', 'Timeseries'];

    function ResultSeriesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, ResultSeries, Result, Timeseries) {
        var vm = this;

        vm.resultSeries = entity;
        vm.clear = clear;
        vm.save = save;
        vm.results = Result.query();
        vm.timeseriess = Timeseries.query({filter: 'resultseries-is-null'});
        $q.all([vm.resultSeries.$promise, vm.timeseriess.$promise]).then(function() {
            if (!vm.resultSeries.timeseriesId) {
                return $q.reject();
            }
            return Timeseries.get({id : vm.resultSeries.timeseriesId}).$promise;
        }).then(function(timeseries) {
            vm.timeseries.push(timeseries);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.resultSeries.id !== null) {
                ResultSeries.update(vm.resultSeries, onSaveSuccess, onSaveError);
            } else {
                ResultSeries.save(vm.resultSeries, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:resultSeriesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultSeriesDetailController', ResultSeriesDetailController);

    ResultSeriesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ResultSeries', 'Result', 'Timeseries'];

    function ResultSeriesDetailController($scope, $rootScope, $stateParams, entity, ResultSeries, Result, Timeseries) {
        var vm = this;

        vm.resultSeries = entity;

        var unsubscribe = $rootScope.$on('portalApp:resultSeriesUpdate', function(event, result) {
            vm.resultSeries = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultSeriesDeleteController',ResultSeriesDeleteController);

    ResultSeriesDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResultSeries'];

    function ResultSeriesDeleteController($uibModalInstance, entity, ResultSeries) {
        var vm = this;

        vm.resultSeries = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResultSeries.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('result-series', {
            parent: 'entity',
            url: '/result-series?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultSeries.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-series/result-series.html',
                    controller: 'ResultSeriesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultSeries');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('result-series-detail', {
            parent: 'entity',
            url: '/result-series/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultSeries.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-series/result-series-detail.html',
                    controller: 'ResultSeriesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultSeries');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ResultSeries', function($stateParams, ResultSeries) {
                    return ResultSeries.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('result-series.new', {
            parent: 'result-series',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-series/result-series-dialog.html',
                    controller: 'ResultSeriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('result-series', null, { reload: true });
                }, function() {
                    $state.go('result-series');
                });
            }]
        })
        .state('result-series.edit', {
            parent: 'result-series',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-series/result-series-dialog.html',
                    controller: 'ResultSeriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ResultSeries', function(ResultSeries) {
                            return ResultSeries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-series', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('result-series.delete', {
            parent: 'result-series',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-series/result-series-delete-dialog.html',
                    controller: 'ResultSeriesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ResultSeries', function(ResultSeries) {
                            return ResultSeries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-series', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ResultSeries', ResultSeries);

    ResultSeries.$inject = ['$resource'];

    function ResultSeries ($resource) {
        var resourceUrl =  'api/result-series/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ResultSeriesSearch', ResultSeriesSearch);

    ResultSeriesSearch.$inject = ['$resource'];

    function ResultSeriesSearch($resource) {
        var resourceUrl =  'api/_search/result-series/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultSeriesController', ResultSeriesController);

    ResultSeriesController.$inject = ['$scope', '$state', 'ResultSeries', 'ResultSeriesSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ResultSeriesController ($scope, $state, ResultSeries, ResultSeriesSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ResultSeriesSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ResultSeries.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.resultSeries = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportDialogController', ResultReportDialogController);

    ResultReportDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ResultReport', 'Result'];

    function ResultReportDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ResultReport, Result) {
        var vm = this;

        vm.resultReport = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.results = Result.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.resultReport.id !== null) {
                ResultReport.update(vm.resultReport, onSaveSuccess, onSaveError);
            } else {
                ResultReport.save(vm.resultReport, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:resultReportUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setReportPdf = function ($file, resultReport) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        resultReport.reportPdf = base64Data;
                        resultReport.reportPdfContentType = $file.type;
                    });
                });
            }
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportDetailController', ResultReportDetailController);

    ResultReportDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'ResultReport', 'Result'];

    function ResultReportDetailController($scope, $rootScope, $stateParams, DataUtils, entity, ResultReport, Result) {
        var vm = this;

        vm.resultReport = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('portalApp:resultReportUpdate', function(event, result) {
            vm.resultReport = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportDeleteController',ResultReportDeleteController);

    ResultReportDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResultReport'];

    function ResultReportDeleteController($uibModalInstance, entity, ResultReport) {
        var vm = this;

        vm.resultReport = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResultReport.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('result-report', {
            parent: 'entity',
            url: '/result-report',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-report/result-reports.html',
                    controller: 'ResultReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('result-report-detail', {
            parent: 'entity',
            url: '/result-report/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultReport.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-report/result-report-detail.html',
                    controller: 'ResultReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultReport');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ResultReport', function($stateParams, ResultReport) {
                    return ResultReport.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('result-report.new', {
            parent: 'result-report',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-report/result-report-dialog.html',
                    controller: 'ResultReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reportText: null,
                                reportPdf: null,
                                reportPdfContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('result-report', null, { reload: true });
                }, function() {
                    $state.go('result-report');
                });
            }]
        })
        .state('result-report.edit', {
            parent: 'result-report',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-report/result-report-dialog.html',
                    controller: 'ResultReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ResultReport', function(ResultReport) {
                            return ResultReport.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('result-report.delete', {
            parent: 'result-report',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-report/result-report-delete-dialog.html',
                    controller: 'ResultReportDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ResultReport', function(ResultReport) {
                            return ResultReport.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ResultReport', ResultReport);

    ResultReport.$inject = ['$resource'];

    function ResultReport ($resource) {
        var resourceUrl =  'api/result-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ResultReportSearch', ResultReportSearch);

    ResultReportSearch.$inject = ['$resource'];

    function ResultReportSearch($resource) {
        var resourceUrl =  'api/_search/result-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportController', ResultReportController);

    ResultReportController.$inject = ['$scope', '$state', 'DataUtils', 'ResultReport', 'ResultReportSearch'];

    function ResultReportController ($scope, $state, DataUtils, ResultReport, ResultReportSearch) {
        var vm = this;

        vm.resultReports = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.search = search;

        loadAll();

        function loadAll() {
            ResultReport.query(function(result) {
                vm.resultReports = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ResultReportSearch.query({query: vm.searchQuery}, function(result) {
                vm.resultReports = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultDialogController', ResultDialogController);

    ResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Result', 'Revision', 'Round'];

    function ResultDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Result, Revision, Round) {
        var vm = this;

        vm.result = entity;
        vm.clear = clear;
        vm.save = save;
        vm.revisions = Revision.query();
        vm.rounds = Round.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.result.id !== null) {
                Result.update(vm.result, onSaveSuccess, onSaveError);
            } else {
                Result.save(vm.result, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:resultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultDetailController', ResultDetailController);

    ResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Result', 'Revision', 'Round'];

    function ResultDetailController($scope, $rootScope, $stateParams, entity, Result, Revision, Round) {
        var vm = this;

        vm.result = entity;

        var unsubscribe = $rootScope.$on('portalApp:resultUpdate', function(event, result) {
            vm.result = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultDeleteController',ResultDeleteController);

    ResultDeleteController.$inject = ['$uibModalInstance', 'entity', 'Result'];

    function ResultDeleteController($uibModalInstance, entity, Result) {
        var vm = this;

        vm.result = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Result.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('result', {
            parent: 'entity',
            url: '/result',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.result.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result/results.html',
                    controller: 'ResultController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('result');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('result-detail', {
            parent: 'entity',
            url: '/result/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.result.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result/result-detail.html',
                    controller: 'ResultDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('result');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Result', function($stateParams, Result) {
                    return Result.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('result.new', {
            parent: 'result',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result/result-dialog.html',
                    controller: 'ResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                actionCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('result', null, { reload: true });
                }, function() {
                    $state.go('result');
                });
            }]
        })
        .state('result.edit', {
            parent: 'result',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result/result-dialog.html',
                    controller: 'ResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Result', function(Result) {
                            return Result.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('result.delete', {
            parent: 'result',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result/result-delete-dialog.html',
                    controller: 'ResultDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Result', function(Result) {
                            return Result.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Result', Result);

    Result.$inject = ['$resource'];

    function Result ($resource) {
        var resourceUrl =  'api/results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ResultSearch', ResultSearch);

    ResultSearch.$inject = ['$resource'];

    function ResultSearch($resource) {
        var resourceUrl =  'api/_search/results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultController', ResultController);

    ResultController.$inject = ['$scope', '$state', 'Result', 'ResultSearch', 'ParseLinks', 'AlertService'];

    function ResultController ($scope, $state, Result, ResultSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.results = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ResultSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Result.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.results.push(data[i]);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.results = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.results = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.results = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResourceDialogController', ResourceDialogController);

    ResourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Resource', 'Round', 'ResourceKey'];

    function ResourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Resource, Round, ResourceKey) {
        var vm = this;

        vm.resource = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rounds = Round.query();
        vm.resourcekeys = ResourceKey.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.resource.id !== null) {
                Resource.update(vm.resource, onSaveSuccess, onSaveError);
            } else {
                Resource.save(vm.resource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:resourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResourceDetailController', ResourceDetailController);

    ResourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Resource', 'Round', 'ResourceKey'];

    function ResourceDetailController($scope, $rootScope, $stateParams, entity, Resource, Round, ResourceKey) {
        var vm = this;

        vm.resource = entity;

        var unsubscribe = $rootScope.$on('portalApp:resourceUpdate', function(event, result) {
            vm.resource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResourceDeleteController',ResourceDeleteController);

    ResourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Resource'];

    function ResourceDeleteController($uibModalInstance, entity, Resource) {
        var vm = this;

        vm.resource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Resource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('resource', {
            parent: 'entity',
            url: '/resource',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/resource/resources.html',
                    controller: 'ResourceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('resource-detail', {
            parent: 'entity',
            url: '/resource/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/resource/resource-detail.html',
                    controller: 'ResourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resource');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Resource', function($stateParams, Resource) {
                    return Resource.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('resource.new', {
            parent: 'resource',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/resource/resource-dialog.html',
                    controller: 'ResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                url: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('resource', null, { reload: true });
                }, function() {
                    $state.go('resource');
                });
            }]
        })
        .state('resource.edit', {
            parent: 'resource',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/resource/resource-dialog.html',
                    controller: 'ResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Resource', function(Resource) {
                            return Resource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('resource', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('resource.delete', {
            parent: 'resource',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/resource/resource-delete-dialog.html',
                    controller: 'ResourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Resource', function(Resource) {
                            return Resource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('resource', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Resource', Resource);

    Resource.$inject = ['$resource'];

    function Resource ($resource) {
        var resourceUrl =  'api/resources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download': {
                method: 'GET',
                responseType: "arraybuffer",
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ResourceSearch', ResourceSearch);

    ResourceSearch.$inject = ['$resource'];

    function ResourceSearch($resource) {
        var resourceUrl =  'api/_search/resources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResourceController', ResourceController);

    ResourceController.$inject = ['$scope', '$state', 'Resource', 'ResourceSearch'];

    function ResourceController ($scope, $state, Resource, ResourceSearch) {
        var vm = this;

        vm.resources = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Resource.query(function(result) {
                vm.resources = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ResourceSearch.query({query: vm.searchQuery}, function(result) {
                vm.resources = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Product'];

    function ProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Product) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:productUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Product'];

    function ProductDetailController($scope, $rootScope, $stateParams, entity, Product) {
        var vm = this;

        vm.product = entity;

        var unsubscribe = $rootScope.$on('portalApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($uibModalInstance, entity, Product) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product', {
            parent: 'entity',
            url: '/product',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/products.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-detail', {
            parent: 'entity',
            url: '/product/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.product.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-detail.html',
                    controller: 'ProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product', function($stateParams, Product) {
                    return Product.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('product.new', {
            parent: 'product',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('product');
                });
            }]
        })
        .state('product.edit', {
            parent: 'product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.delete', {
            parent: 'product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-delete-dialog.html',
                    controller: 'ProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Product', Product);

    Product.$inject = ['$resource'];

    function Product ($resource) {
        var resourceUrl =  'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ProductSearch', ProductSearch);

    ProductSearch.$inject = ['$resource'];

    function ProductSearch($resource) {
        var resourceUrl =  'api/_search/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$scope', '$state', 'Product', 'ProductSearch'];

    function ProductController ($scope, $state, Product, ProductSearch) {
        var vm = this;

        vm.products = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Product.query(function(result) {
                vm.products = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProductSearch.query({query: vm.searchQuery}, function(result) {
                vm.products = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelSymbolDialogController', ModelSymbolDialogController);

    ModelSymbolDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ModelSymbol', 'Model', 'SbNtfVariable', 'SbNtfExcludedShock', 'SmootherMultiplier'];

    function ModelSymbolDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ModelSymbol, Model, SbNtfVariable, SbNtfExcludedShock, SmootherMultiplier) {
        var vm = this;

        vm.modelSymbol = entity;
        vm.clear = clear;
        vm.save = save;
        vm.models = Model.query();
        vm.sbntfvariables = SbNtfVariable.query();
        vm.sbntfexcludedshocks = SbNtfExcludedShock.query();
        vm.smoothermultipliers = SmootherMultiplier.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modelSymbol.id !== null) {
                ModelSymbol.update(vm.modelSymbol, onSaveSuccess, onSaveError);
            } else {
                ModelSymbol.save(vm.modelSymbol, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:modelSymbolUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelSymbolDetailController', ModelSymbolDetailController);

    ModelSymbolDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ModelSymbol', 'Model', 'SbNtfVariable', 'SbNtfExcludedShock', 'SmootherMultiplier'];

    function ModelSymbolDetailController($scope, $rootScope, $stateParams, entity, ModelSymbol, Model, SbNtfVariable, SbNtfExcludedShock, SmootherMultiplier) {
        var vm = this;

        vm.modelSymbol = entity;

        var unsubscribe = $rootScope.$on('portalApp:modelSymbolUpdate', function(event, result) {
            vm.modelSymbol = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelSymbolDeleteController',ModelSymbolDeleteController);

    ModelSymbolDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModelSymbol'];

    function ModelSymbolDeleteController($uibModalInstance, entity, ModelSymbol) {
        var vm = this;

        vm.modelSymbol = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ModelSymbol.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model-symbol', {
            parent: 'entity',
            url: '/model-symbol?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelSymbol.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-symbol/model-symbols.html',
                    controller: 'ModelSymbolController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelSymbol');
                    $translatePartialLoader.addPart('modelSymbolType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-symbol-detail', {
            parent: 'entity',
            url: '/model-symbol/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelSymbol.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-symbol/model-symbol-detail.html',
                    controller: 'ModelSymbolDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelSymbol');
                    $translatePartialLoader.addPart('modelSymbolType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ModelSymbol', function($stateParams, ModelSymbol) {
                    return ModelSymbol.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('model-symbol.new', {
            parent: 'model-symbol',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-symbol/model-symbol-dialog.html',
                    controller: 'ModelSymbolDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                unit: null,
                                label: null,
                                latexAlias: null,
                                isAdditive: null,
                                isMeasurement: null,
                                value: null,
                                valueTrend: null,
                                symbolType: null,
                                labelShort: null,
                                shock_peer_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model-symbol', null, { reload: true });
                }, function() {
                    $state.go('model-symbol');
                });
            }]
        })
        .state('model-symbol.edit', {
            parent: 'model-symbol',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-symbol/model-symbol-dialog.html',
                    controller: 'ModelSymbolDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ModelSymbol', function(ModelSymbol) {
                            return ModelSymbol.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-symbol', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model-symbol.delete', {
            parent: 'model-symbol',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-symbol/model-symbol-delete-dialog.html',
                    controller: 'ModelSymbolDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModelSymbol', function(ModelSymbol) {
                            return ModelSymbol.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-symbol', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ModelSymbol', ModelSymbol);

    ModelSymbol.$inject = ['$resource'];

    function ModelSymbol ($resource) {
        var resourceUrl =  'api/model-symbols/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ModelSymbolSearch', ModelSymbolSearch);

    ModelSymbolSearch.$inject = ['$resource'];

    function ModelSymbolSearch($resource) {
        var resourceUrl =  'api/_search/model-symbols/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelSymbolController', ModelSymbolController);

    ModelSymbolController.$inject = ['$scope', '$state', 'ModelSymbol', 'ModelSymbolSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ModelSymbolController ($scope, $state, ModelSymbol, ModelSymbolSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ModelSymbolSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ModelSymbol.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.modelSymbols = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelEquationDialogController', ModelEquationDialogController);

    ModelEquationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ModelEquation', 'Model'];

    function ModelEquationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ModelEquation, Model) {
        var vm = this;

        vm.modelEquation = entity;
        vm.clear = clear;
        vm.save = save;
        vm.models = Model.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modelEquation.id !== null) {
                ModelEquation.update(vm.modelEquation, onSaveSuccess, onSaveError);
            } else {
                ModelEquation.save(vm.modelEquation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:modelEquationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelEquationDetailController', ModelEquationDetailController);

    ModelEquationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ModelEquation', 'Model'];

    function ModelEquationDetailController($scope, $rootScope, $stateParams, entity, ModelEquation, Model) {
        var vm = this;

        vm.modelEquation = entity;

        var unsubscribe = $rootScope.$on('portalApp:modelEquationUpdate', function(event, result) {
            vm.modelEquation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelEquationDeleteController',ModelEquationDeleteController);

    ModelEquationDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModelEquation'];

    function ModelEquationDeleteController($uibModalInstance, entity, ModelEquation) {
        var vm = this;

        vm.modelEquation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ModelEquation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model-equation', {
            parent: 'entity',
            url: '/model-equation?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelEquation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-equation/model-equations.html',
                    controller: 'ModelEquationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelEquation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-equation-detail', {
            parent: 'entity',
            url: '/model-equation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelEquation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-equation/model-equation-detail.html',
                    controller: 'ModelEquationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelEquation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ModelEquation', function($stateParams, ModelEquation) {
                    return ModelEquation.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('model-equation.new', {
            parent: 'model-equation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-equation/model-equation-dialog.html',
                    controller: 'ModelEquationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                expression: null,
                                label: null,
                                isMeasurement: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model-equation', null, { reload: true });
                }, function() {
                    $state.go('model-equation');
                });
            }]
        })
        .state('model-equation.edit', {
            parent: 'model-equation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-equation/model-equation-dialog.html',
                    controller: 'ModelEquationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ModelEquation', function(ModelEquation) {
                            return ModelEquation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-equation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model-equation.delete', {
            parent: 'model-equation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-equation/model-equation-delete-dialog.html',
                    controller: 'ModelEquationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModelEquation', function(ModelEquation) {
                            return ModelEquation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-equation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ModelEquation', ModelEquation);

    ModelEquation.$inject = ['$resource'];

    function ModelEquation ($resource) {
        var resourceUrl =  'api/model-equations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ModelEquationSearch', ModelEquationSearch);

    ModelEquationSearch.$inject = ['$resource'];

    function ModelEquationSearch($resource) {
        var resourceUrl =  'api/_search/model-equations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelEquationController', ModelEquationController);

    ModelEquationController.$inject = ['$scope', '$state', 'ModelEquation', 'ModelEquationSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ModelEquationController ($scope, $state, ModelEquation, ModelEquationSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ModelEquationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ModelEquation.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.modelEquations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelDialogController', ModelDialogController);

    ModelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Model', 'Frequency', 'Round', 'ModelEquation', 'ModelSymbol'];

    function ModelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Model, Frequency, Round, ModelEquation, ModelSymbol) {
        var vm = this;

        vm.model = entity;
        vm.clear = clear;
        vm.save = save;
        vm.frequencies = Frequency.query();
        vm.rounds = Round.query({filter: 'model-is-null'});
        $q.all([vm.model.$promise, vm.rounds.$promise]).then(function() {
            if (!vm.model.roundId) {
                return $q.reject();
            }
            return Round.get({id : vm.model.roundId}).$promise;
        }).then(function(round) {
            vm.rounds.push(round);
        });
        vm.modelequations = ModelEquation.query();
        vm.modelsymbols = ModelSymbol.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.model.id !== null) {
                Model.update(vm.model, onSaveSuccess, onSaveError);
            } else {
                Model.save(vm.model, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:modelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelDetailController', ModelDetailController);

    ModelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Model', 'Frequency', 'Round', 'ModelEquation', 'ModelSymbol'];

    function ModelDetailController($scope, $rootScope, $stateParams, entity, Model, Frequency, Round, ModelEquation, ModelSymbol) {
        var vm = this;

        vm.model = entity;

        var unsubscribe = $rootScope.$on('portalApp:modelUpdate', function(event, result) {
            vm.model = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelDeleteController',ModelDeleteController);

    ModelDeleteController.$inject = ['$uibModalInstance', 'entity', 'Model'];

    function ModelDeleteController($uibModalInstance, entity, Model) {
        var vm = this;

        vm.model = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Model.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model', {
            parent: 'entity',
            url: '/model',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.model.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model/models.html',
                    controller: 'ModelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('model');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-detail', {
            parent: 'entity',
            url: '/model/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.model.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model/model-detail.html',
                    controller: 'ModelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('model');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Model', function($stateParams, Model) {
                    return Model.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('model.new', {
            parent: 'model',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model/model-dialog.html',
                    controller: 'ModelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                isLinear: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model', null, { reload: true });
                }, function() {
                    $state.go('model');
                });
            }]
        })
        .state('model.edit', {
            parent: 'model',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model/model-dialog.html',
                    controller: 'ModelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Model', function(Model) {
                            return Model.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model.delete', {
            parent: 'model',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model/model-delete-dialog.html',
                    controller: 'ModelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Model', function(Model) {
                            return Model.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Model', Model);

    Model.$inject = ['$resource'];

    function Model ($resource) {
        var resourceUrl =  'api/models/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ModelSearch', ModelSearch);

    ModelSearch.$inject = ['$resource'];

    function ModelSearch($resource) {
        var resourceUrl =  'api/_search/models/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelController', ModelController);

    ModelController.$inject = ['$scope', '$state', 'Model', 'ModelSearch'];

    function ModelController ($scope, $state, Model, ModelSearch) {
        var vm = this;

        vm.models = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Model.query(function(result) {
                vm.models = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ModelSearch.query({query: vm.searchQuery}, function(result) {
                vm.models = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('FrequencyDialogController', FrequencyDialogController);

    FrequencyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Frequency'];

    function FrequencyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Frequency) {
        var vm = this;

        vm.frequency = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.frequency.id !== null) {
                Frequency.update(vm.frequency, onSaveSuccess, onSaveError);
            } else {
                Frequency.save(vm.frequency, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:frequencyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('FrequencyDetailController', FrequencyDetailController);

    FrequencyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Frequency'];

    function FrequencyDetailController($scope, $rootScope, $stateParams, entity, Frequency) {
        var vm = this;

        vm.frequency = entity;

        var unsubscribe = $rootScope.$on('portalApp:frequencyUpdate', function(event, result) {
            vm.frequency = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('FrequencyDeleteController',FrequencyDeleteController);

    FrequencyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Frequency'];

    function FrequencyDeleteController($uibModalInstance, entity, Frequency) {
        var vm = this;

        vm.frequency = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Frequency.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frequency', {
            parent: 'entity',
            url: '/frequency',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.frequency.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequency/frequencies.html',
                    controller: 'FrequencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequency');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('frequency-detail', {
            parent: 'entity',
            url: '/frequency/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.frequency.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequency/frequency-detail.html',
                    controller: 'FrequencyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequency');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Frequency', function($stateParams, Frequency) {
                    return Frequency.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('frequency.new', {
            parent: 'frequency',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequency/frequency-dialog.html',
                    controller: 'FrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('frequency', null, { reload: true });
                }, function() {
                    $state.go('frequency');
                });
            }]
        })
        .state('frequency.edit', {
            parent: 'frequency',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequency/frequency-dialog.html',
                    controller: 'FrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Frequency', function(Frequency) {
                            return Frequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequency', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequency.delete', {
            parent: 'frequency',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequency/frequency-delete-dialog.html',
                    controller: 'FrequencyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Frequency', function(Frequency) {
                            return Frequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequency', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Frequency', Frequency);

    Frequency.$inject = ['$resource'];

    function Frequency ($resource) {
        var resourceUrl =  'api/frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('FrequencySearch', FrequencySearch);

    FrequencySearch.$inject = ['$resource'];

    function FrequencySearch($resource) {
        var resourceUrl =  'api/_search/frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('FrequencyController', FrequencyController);

    FrequencyController.$inject = ['$scope', '$state', 'Frequency', 'FrequencySearch'];

    function FrequencyController ($scope, $state, Frequency, FrequencySearch) {
        var vm = this;

        vm.frequencies = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Frequency.query(function(result) {
                vm.frequencies = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            FrequencySearch.query({query: vm.searchQuery}, function(result) {
                vm.frequencies = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyJournalDialogController', CurrencyJournalDialogController);

    CurrencyJournalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CurrencyJournal', 'Currency', 'Country'];

    function CurrencyJournalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CurrencyJournal, Currency, Country) {
        var vm = this;

        vm.currencyJournal = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.currencies = Currency.query();
        vm.countries = Country.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.currencyJournal.id !== null) {
                CurrencyJournal.update(vm.currencyJournal, onSaveSuccess, onSaveError);
            } else {
                CurrencyJournal.save(vm.currencyJournal, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:currencyJournalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.activeFrom = false;
        vm.datePickerOpenStatus.activeUntil = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyJournalDetailController', CurrencyJournalDetailController);

    CurrencyJournalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CurrencyJournal', 'Currency', 'Country'];

    function CurrencyJournalDetailController($scope, $rootScope, $stateParams, entity, CurrencyJournal, Currency, Country) {
        var vm = this;

        vm.currencyJournal = entity;

        var unsubscribe = $rootScope.$on('portalApp:currencyJournalUpdate', function(event, result) {
            vm.currencyJournal = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyJournalDeleteController',CurrencyJournalDeleteController);

    CurrencyJournalDeleteController.$inject = ['$uibModalInstance', 'entity', 'CurrencyJournal'];

    function CurrencyJournalDeleteController($uibModalInstance, entity, CurrencyJournal) {
        var vm = this;

        vm.currencyJournal = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CurrencyJournal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('currency-journal', {
            parent: 'entity',
            url: '/currency-journal',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.currencyJournal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/currency-journal/currency-journals.html',
                    controller: 'CurrencyJournalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currencyJournal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('currency-journal-detail', {
            parent: 'entity',
            url: '/currency-journal/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.currencyJournal.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/currency-journal/currency-journal-detail.html',
                    controller: 'CurrencyJournalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currencyJournal');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CurrencyJournal', function($stateParams, CurrencyJournal) {
                    return CurrencyJournal.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('currency-journal.new', {
            parent: 'currency-journal',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency-journal/currency-journal-dialog.html',
                    controller: 'CurrencyJournalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                activeFrom: null,
                                activeUntil: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('currency-journal', null, { reload: true });
                }, function() {
                    $state.go('currency-journal');
                });
            }]
        })
        .state('currency-journal.edit', {
            parent: 'currency-journal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency-journal/currency-journal-dialog.html',
                    controller: 'CurrencyJournalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CurrencyJournal', function(CurrencyJournal) {
                            return CurrencyJournal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency-journal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('currency-journal.delete', {
            parent: 'currency-journal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency-journal/currency-journal-delete-dialog.html',
                    controller: 'CurrencyJournalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CurrencyJournal', function(CurrencyJournal) {
                            return CurrencyJournal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency-journal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CurrencyJournal', CurrencyJournal);

    CurrencyJournal.$inject = ['$resource', 'DateUtils'];

    function CurrencyJournal ($resource, DateUtils) {
        var resourceUrl =  'api/currency-journals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.activeFrom = DateUtils.convertLocalDateFromServer(data.activeFrom);
                        data.activeUntil = DateUtils.convertLocalDateFromServer(data.activeUntil);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.activeFrom = DateUtils.convertLocalDateToServer(data.activeFrom);
                    data.activeUntil = DateUtils.convertLocalDateToServer(data.activeUntil);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.activeFrom = DateUtils.convertLocalDateToServer(data.activeFrom);
                    data.activeUntil = DateUtils.convertLocalDateToServer(data.activeUntil);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('CurrencyJournalSearch', CurrencyJournalSearch);

    CurrencyJournalSearch.$inject = ['$resource'];

    function CurrencyJournalSearch($resource) {
        var resourceUrl =  'api/_search/currency-journals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyJournalController', CurrencyJournalController);

    CurrencyJournalController.$inject = ['$scope', '$state', 'CurrencyJournal', 'CurrencyJournalSearch'];

    function CurrencyJournalController ($scope, $state, CurrencyJournal, CurrencyJournalSearch) {
        var vm = this;
        
        vm.currencyJournals = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            CurrencyJournal.query(function(result) {
                vm.currencyJournals = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            CurrencyJournalSearch.query({query: vm.searchQuery}, function(result) {
                vm.currencyJournals = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyDialogController', CurrencyDialogController);

    CurrencyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Currency'];

    function CurrencyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Currency) {
        var vm = this;

        vm.currency = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.currency.id !== null) {
                Currency.update(vm.currency, onSaveSuccess, onSaveError);
            } else {
                Currency.save(vm.currency, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:currencyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyDetailController', CurrencyDetailController);

    CurrencyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Currency'];

    function CurrencyDetailController($scope, $rootScope, $stateParams, entity, Currency) {
        var vm = this;

        vm.currency = entity;

        var unsubscribe = $rootScope.$on('portalApp:currencyUpdate', function(event, result) {
            vm.currency = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyDeleteController',CurrencyDeleteController);

    CurrencyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Currency'];

    function CurrencyDeleteController($uibModalInstance, entity, Currency) {
        var vm = this;

        vm.currency = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Currency.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('currency', {
            parent: 'entity',
            url: '/currency',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.currency.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/currency/currencies.html',
                    controller: 'CurrencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currency');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('currency-detail', {
            parent: 'entity',
            url: '/currency/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.currency.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/currency/currency-detail.html',
                    controller: 'CurrencyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currency');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Currency', function($stateParams, Currency) {
                    return Currency.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('currency.new', {
            parent: 'currency',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency/currency-dialog.html',
                    controller: 'CurrencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('currency', null, { reload: true });
                }, function() {
                    $state.go('currency');
                });
            }]
        })
        .state('currency.edit', {
            parent: 'currency',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency/currency-dialog.html',
                    controller: 'CurrencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Currency', function(Currency) {
                            return Currency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('currency.delete', {
            parent: 'currency',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency/currency-delete-dialog.html',
                    controller: 'CurrencyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Currency', function(Currency) {
                            return Currency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Currency', Currency);

    Currency.$inject = ['$resource'];

    function Currency ($resource) {
        var resourceUrl =  'api/currencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('CurrencySearch', CurrencySearch);

    CurrencySearch.$inject = ['$resource'];

    function CurrencySearch($resource) {
        var resourceUrl =  'api/_search/currencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyController', CurrencyController);

    CurrencyController.$inject = ['$scope', '$state', 'Currency', 'CurrencySearch'];

    function CurrencyController ($scope, $state, Currency, CurrencySearch) {
        var vm = this;
        
        vm.currencies = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Currency.query(function(result) {
                vm.currencies = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            CurrencySearch.query({query: vm.searchQuery}, function(result) {
                vm.currencies = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Country'];

    function CountryDetailController($scope, $rootScope, $stateParams, entity, Country) {
        var vm = this;

        vm.country = entity;

        var unsubscribe = $rootScope.$on('portalApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'entity',
            url: '/country',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.country.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-detail', {
            parent: 'entity',
            url: '/country/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.country.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-detail.html',
                    controller: 'CountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('CountrySearch', CountrySearch);

    CountrySearch.$inject = ['$resource'];

    function CountrySearch($resource) {
        var resourceUrl =  'api/_search/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['$scope', '$state', 'Country', 'CountrySearch', 'ParseLinks', 'AlertService'];

    function CountryController ($scope, $state, Country, CountrySearch, ParseLinks, AlertService) {
        var vm = this;

        vm.countries = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CountrySearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Country.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.countries.push(data[i]);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.countries = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.countries = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.countries = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationJournal', ApplicationJournal);

    ApplicationJournal.$inject = ['$resource'];

    function ApplicationJournal ($resource) {
        var resourceUrl =  'api/application-journals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureUserGroupMapDialogController', ApplicationFeatureUserGroupMapDialogController);

    ApplicationFeatureUserGroupMapDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationFeatureUserGroupMap', 'UserGroup', 'ApplicationFeature'];

    function ApplicationFeatureUserGroupMapDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationFeatureUserGroupMap, UserGroup, ApplicationFeature) {
        var vm = this;

        vm.userGroups = null;
        vm.applicationFeatures = null;
        vm.applicationFeatureUserGroupMap = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        UserGroup.query(function (userGroups) {
            vm.userGroups = userGroups.map(function(obj){return obj.name});
        });

        ApplicationFeature.query(function (applicationFeatures) {
            vm.applicationFeatures = applicationFeatures; //.map(function(obj){return obj.name});
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.applicationFeatureUserGroupMap.id !== null) {
                ApplicationFeatureUserGroupMap.update(vm.applicationFeatureUserGroupMap, onSaveSuccess, onSaveError);
            } else {
                ApplicationFeatureUserGroupMap.save(vm.applicationFeatureUserGroupMap, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:applicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureUserGroupMapDetailController', ApplicationFeatureUserGroupMapDetailController);

    ApplicationFeatureUserGroupMapDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ApplicationFeatureUserGroupMap'];

    function ApplicationFeatureUserGroupMapDetailController($scope, $rootScope, $stateParams, entity, ApplicationFeatureUserGroupMap) {
        var vm = this;

        vm.applicationFeatureUserGroupMap = entity;

        var unsubscribe = $rootScope.$on('portalApp:applicationUpdate', function(event, result) {
            vm.applicationFeatureUserGroupMap = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureUserGroupMapDeleteController',ApplicationFeatureUserGroupMapDeleteController);

    ApplicationFeatureUserGroupMapDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationFeatureUserGroupMap'];

    function ApplicationFeatureUserGroupMapDeleteController($uibModalInstance, entity, ApplicationFeatureUserGroupMap) {
        var vm = this;

        vm.applicationFeatureUserGroupMap = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApplicationFeatureUserGroupMap.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-feature-user-group-map', {
            parent: 'entity',
            url: '/application-feature-user-group-map',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureUserGroupMap.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map.html',
                    controller: 'ApplicationFeatureUserGroupMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureUserGroupMap');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-feature-user-group-map-detail', {
            parent: 'entity',
            url: '/application-feature-user-group-map/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureUserGroupMap.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-detail.html',
                    controller: 'ApplicationFeatureUserGroupMapDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureUserGroupMap');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationFeatureUserGroupMap', function($stateParams, ApplicationFeatureUserGroupMap) {
                    return ApplicationFeatureUserGroupMap.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('application-feature-user-group-map.new', {
            parent: 'application-feature-user-group-map',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-dialog.html',
                    controller: 'ApplicationFeatureUserGroupMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-feature-user-group-map', null, { reload: true });
                }, function() {
                    $state.go('application-feature-user-group-map');
                });
            }]
        })
        .state('application-feature-user-group-map.edit', {
            parent: 'application-feature-user-group-map',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-dialog.html',
                    controller: 'ApplicationFeatureUserGroupMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationFeatureUserGroupMap', function(ApplicationFeatureUserGroupMap) {
                            return ApplicationFeatureUserGroupMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-user-group-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-feature-user-group-map.delete', {
            parent: 'application-feature-user-group-map',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-user-group-map/application-feature-user-group-map-delete-dialog.html',
                    controller: 'ApplicationFeatureUserGroupMapDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationFeatureUserGroupMap', function(ApplicationFeatureUserGroupMap) {
                            return ApplicationFeatureUserGroupMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-user-group-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationFeatureUserGroupMap', ApplicationFeatureUserGroupMap);

    ApplicationFeatureUserGroupMap.$inject = ['$resource'];

    function ApplicationFeatureUserGroupMap ($resource) {
        var resourceUrl =  'api/application-feature-user-group-maps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ApplicationFeatureUserGroupMapSearch', ApplicationFeatureUserGroupMapSearch);

    ApplicationFeatureUserGroupMapSearch.$inject = ['$resource'];

    function ApplicationFeatureUserGroupMapSearch($resource) {
        var resourceUrl =  'api/_search/application-feature-user-group-maps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureUserGroupMapController', ApplicationFeatureUserGroupMapController);

    ApplicationFeatureUserGroupMapController.$inject = ['$scope', '$state', 'ApplicationFeatureUserGroupMap', 'ApplicationFeatureUserGroupMapSearch'];

    function ApplicationFeatureUserGroupMapController ($scope, $state, ApplicationFeatureUserGroupMap, ApplicationFeatureUserGroupMapSearch) {
        var vm = this;

        vm.applications = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            ApplicationFeatureUserGroupMap.query(function(result) {
                vm.applications = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ApplicationFeatureUserGroupMapSearch.query({query: vm.searchQuery}, function(result) {
                vm.applications = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureEntityMapDialogController', ApplicationFeatureEntityMapDialogController);

    ApplicationFeatureEntityMapDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationFeatureEntityMap', 'ApplicationFeature'];

    function ApplicationFeatureEntityMapDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationFeatureEntityMap, ApplicationFeature) {
        var vm = this;

        vm.applicationFeatures = null;
        vm.applicationFeatureEntityMap = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        ApplicationFeature.query(function (applicationFeatures) {
            vm.applicationFeatures = applicationFeatures; //.map(function(obj){return obj.name});
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.applicationFeatureEntityMap.id !== null) {
                ApplicationFeatureEntityMap.update(vm.applicationFeatureEntityMap, onSaveSuccess, onSaveError);
            } else {
                ApplicationFeatureEntityMap.save(vm.applicationFeatureEntityMap, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:applicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureEntityMapDetailController', ApplicationFeatureEntityMapDetailController);

    ApplicationFeatureEntityMapDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ApplicationFeatureEntityMap'];

    function ApplicationFeatureEntityMapDetailController($scope, $rootScope, $stateParams, entity, ApplicationFeatureEntityMap) {
        var vm = this;

        vm.applicationFeatureEntityMap = entity;

        var unsubscribe = $rootScope.$on('portalApp:applicationUpdate', function(event, result) {
            vm.applicationFeatureEntityMap = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureEntityMapDeleteController',ApplicationFeatureEntityMapDeleteController);

    ApplicationFeatureEntityMapDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationFeatureEntityMap'];

    function ApplicationFeatureEntityMapDeleteController($uibModalInstance, entity, ApplicationFeatureEntityMap) {
        var vm = this;

        vm.applicationFeatureEntityMap = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApplicationFeatureEntityMap.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-feature-entity-map', {
            parent: 'entity',
            url: '/application-feature-entity-map',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureEntityMap.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map.html',
                    controller: 'ApplicationFeatureEntityMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureEntityMap');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-feature-entity-map-detail', {
            parent: 'entity',
            url: '/application-feature-entity-map/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeatureEntityMap.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-detail.html',
                    controller: 'ApplicationFeatureEntityMapDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeatureEntityMap');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationFeatureEntityMap', function($stateParams, ApplicationFeatureEntityMap) {
                    return ApplicationFeatureEntityMap.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('application-feature-entity-map.new', {
            parent: 'application-feature-entity-map',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-dialog.html',
                    controller: 'ApplicationFeatureEntityMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-feature-entity-map', null, { reload: true });
                }, function() {
                    $state.go('application-feature-entity-map');
                });
            }]
        })
        .state('application-feature-entity-map.edit', {
            parent: 'application-feature-entity-map',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-dialog.html',
                    controller: 'ApplicationFeatureEntityMapDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationFeatureEntityMap', function(ApplicationFeatureEntityMap) {
                            return ApplicationFeatureEntityMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-entity-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-feature-entity-map.delete', {
            parent: 'application-feature-entity-map',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature-entity-map/application-feature-entity-map-delete-dialog.html',
                    controller: 'ApplicationFeatureEntityMapDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationFeatureEntityMap', function(ApplicationFeatureEntityMap) {
                            return ApplicationFeatureEntityMap.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature-entity-map', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationFeatureEntityMap', ApplicationFeatureEntityMap);

    ApplicationFeatureEntityMap.$inject = ['$resource'];

    function ApplicationFeatureEntityMap ($resource) {
        var resourceUrl =  'api/application-feature-entity-maps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ApplicationFeatureEntityMapSearch', ApplicationFeatureEntityMapSearch);

    ApplicationFeatureEntityMapSearch.$inject = ['$resource'];

    function ApplicationFeatureEntityMapSearch($resource) {
        var resourceUrl =  'api/_search/application-feature-entity-maps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureEntityMapController', ApplicationFeatureEntityMapController);

    ApplicationFeatureEntityMapController.$inject = ['$scope', '$state', 'ApplicationFeatureEntityMap', 'ApplicationFeatureEntityMapSearch'];

    function ApplicationFeatureEntityMapController ($scope, $state, ApplicationFeatureEntityMap, ApplicationFeatureEntityMapSearch) {
        var vm = this;

        vm.applications = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            ApplicationFeatureEntityMap.query(function(result) {
                vm.applications = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ApplicationFeatureEntityMapSearch.query({query: vm.searchQuery}, function(result) {
                vm.applications = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureDialogController', ApplicationFeatureDialogController);

    ApplicationFeatureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationFeature'];

    function ApplicationFeatureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationFeature) {
        var vm = this;

        vm.applicationFeature = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.applicationFeature.id !== null) {
                ApplicationFeature.update(vm.applicationFeature, onSaveSuccess, onSaveError);
            } else {
                ApplicationFeature.save(vm.applicationFeature, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:applicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureDetailController', ApplicationFeatureDetailController);

    ApplicationFeatureDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ApplicationFeature'];

    function ApplicationFeatureDetailController($scope, $rootScope, $stateParams, entity, ApplicationFeature) {
        var vm = this;

        vm.applicationFeature = entity;

        var unsubscribe = $rootScope.$on('portalApp:applicationUpdate', function(event, result) {
            vm.applicationFeature = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureDeleteController',ApplicationFeatureDeleteController);

    ApplicationFeatureDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationFeature'];

    function ApplicationFeatureDeleteController($uibModalInstance, entity, ApplicationFeature) {
        var vm = this;

        vm.applicationFeature = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApplicationFeature.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-feature', {
            parent: 'entity',
            url: '/application-feature',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeature.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature/application-features.html',
                    controller: 'ApplicationFeatureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeature');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-feature-detail', {
            parent: 'entity',
            url: '/application-feature/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeature.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature/application-feature-detail.html',
                    controller: 'ApplicationFeatureDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeature');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationFeature', function($stateParams, ApplicationFeature) {
                    return ApplicationFeature.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('application-feature.new', {
            parent: 'application-feature',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature/application-feature-dialog.html',
                    controller: 'ApplicationFeatureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-feature', null, { reload: true });
                }, function() {
                    $state.go('application-feature');
                });
            }]
        })
        .state('application-feature.edit', {
            parent: 'application-feature',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature/application-feature-dialog.html',
                    controller: 'ApplicationFeatureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationFeature', function(ApplicationFeature) {
                            return ApplicationFeature.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-feature.delete', {
            parent: 'application-feature',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature/application-feature-delete-dialog.html',
                    controller: 'ApplicationFeatureDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationFeature', function(ApplicationFeature) {
                            return ApplicationFeature.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationFeature', ApplicationFeature);

    ApplicationFeature.$inject = ['$resource'];

    function ApplicationFeature ($resource) {
        var resourceUrl =  'api/application-features/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ApplicationFeatureSearch', ApplicationFeatureSearch);

    ApplicationFeatureSearch.$inject = ['$resource'];

    function ApplicationFeatureSearch($resource) {
        var resourceUrl =  'api/_search/application-features/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureController', ApplicationFeatureController);

    ApplicationFeatureController.$inject = ['$scope', '$state', 'ApplicationFeature', 'ApplicationFeatureSearch'];

    function ApplicationFeatureController ($scope, $state, ApplicationFeature, ApplicationFeatureSearch) {
        var vm = this;

        vm.applications = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            ApplicationFeature.query(function(result) {
                vm.applications = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ApplicationFeatureSearch.query({query: vm.searchQuery}, function(result) {
                vm.applications = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationDialogController', ApplicationDialogController);

    ApplicationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Application'];

    function ApplicationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Application) {
        var vm = this;

        vm.application = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.application.id !== null) {
                Application.update(vm.application, onSaveSuccess, onSaveError);
            } else {
                Application.save(vm.application, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:applicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationDetailController', ApplicationDetailController);

    ApplicationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Application'];

    function ApplicationDetailController($scope, $rootScope, $stateParams, entity, Application) {
        var vm = this;

        vm.application = entity;

        var unsubscribe = $rootScope.$on('portalApp:applicationUpdate', function(event, result) {
            vm.application = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationDeleteController',ApplicationDeleteController);

    ApplicationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Application'];

    function ApplicationDeleteController($uibModalInstance, entity, Application) {
        var vm = this;

        vm.application = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Application.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application', {
            parent: 'entity',
            url: '/application',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.application.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application/applications.html',
                    controller: 'ApplicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('application');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-detail', {
            parent: 'entity',
            url: '/application/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.application.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application/application-detail.html',
                    controller: 'ApplicationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('application');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Application', function($stateParams, Application) {
                    return Application.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('application.new', {
            parent: 'application',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application/application-dialog.html',
                    controller: 'ApplicationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application', null, { reload: true });
                }, function() {
                    $state.go('application');
                });
            }]
        })
        .state('application.edit', {
            parent: 'application',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application/application-dialog.html',
                    controller: 'ApplicationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Application', function(Application) {
                            return Application.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application.delete', {
            parent: 'application',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application/application-delete-dialog.html',
                    controller: 'ApplicationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Application', function(Application) {
                            return Application.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Application', Application);

    Application.$inject = ['$resource'];

    function Application ($resource) {
        var resourceUrl =  'api/applications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ApplicationSearch', ApplicationSearch);

    ApplicationSearch.$inject = ['$resource'];

    function ApplicationSearch($resource) {
        var resourceUrl =  'api/_search/applications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationController', ApplicationController);

    ApplicationController.$inject = ['$scope', '$state', 'Application', 'ApplicationSearch'];

    function ApplicationController ($scope, $state, Application, ApplicationSearch) {
        var vm = this;

        vm.applications = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Application.query(function(result) {
                vm.applications = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ApplicationSearch.query({query: vm.searchQuery}, function(result) {
                vm.applications = result;
            });
        }    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('CountryNoteController', CountryNoteController);

    CountryNoteController.$inject = ['$filter', '$state', 'countryNotes'];

    function CountryNoteController($filter, $state, countryNotes) {

        var vm = this;

        // vm.country = subscribedCountryList.find(function (c) {
        //     return (c.id == $state.params.countryId);
        // });

        vm.countryNotes = countryNotes;
    }
})();



;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .directive('yieldCurveChart', yieldCurveChart);

    yieldCurveChart.$inject = ['$window', 'yieldCurveChartConfig', 'DateUtils', 'OgrChart'];

    function yieldCurveChart($window, yieldCurveChartConfig, DateUtils, OgrChart) {
        // Generates chart for one or more timeseries
        // Usage:
        //  <div data-yield-curve-chart chart-data="vm.chartData">
        //  <div data-yield-curve-chart chart-data="vm.chartData" line-style="vm.lineStyle">
        //  <div data-yield-curve-chart chart-data="vm.chartData" min-tenor="vm.minimumTenorDays">
        //  <div data-yield-curve-chart chart-data="vm.chartData" max-tenor="vm.maximumTenorDays">
        //  <div data-yield-curve-chart chart-data="vm.chartData" curve-type="vm.curveType">
        // Input structure:
        //  vm.chartData = {
        //      chartId: "someId",
        //      title: "some title",
        //      lineSeries: {
        //          irs: [
        //              [
        //                  {tenorLabel: String, tenorDays: Int, value: Double},
        //                  ...
        //              ],
        //              ...
        //          ],
        //          ccy: [
        //              [
        //                  {tenorLabel: String, tenorDays: Int, value: Double},
        //                  ...
        //              ],
        //              ...
        //          ],
        //          zero: [
        //              [
        //                  {tenorLabel: String, tenorDays: Int, value: Double},
        //                  ...
        //              ],
        //              ...
        //          ]
        //      },
        //      lineLegends: [String, String, ... ]
        //  }
        //  vm.lineStyle = [
        //      {
        //          width: 2,
        //          color: '#3734FF',
        //          dashSetting: [<dashWidth>,<emptySpaceWidth>],
        //          markerSize: 2,
        //      },
        //      ...
        //  ]

        var directive = {
            link: linkFunc,
            restrict: 'A',
            scope: {
                chartData: '<',
                lineStyle: '<',
                curveType: '<',
                minTenor: '<',
                maxTenor: '<',
                yAxisTitle: '<',
                langKey: '<'
            }
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.addClass('yieldCurveChart');
            element.attr('id', scope.chartData.chartId);

            makeChart();

            scope.$watch('chartData', updateChart, true);
            scope.$watch('lineStyle', updateChart, true);
            scope.$watch('curveType', updateChart, true);
            scope.$watch('minTenor', updateChart, true);
            scope.$watch('maxTenor', updateChart, true);
            scope.$watch('yAxisTitle', updateChart, true);
            scope.$watch('langKey', updateChart, true);
            //some responsiveness here: when window was resized - recalculate
            // height of the chart based on the parent height
            var win = angular.element($window);
            win.bind("resize", updateChart);
            element.on('$destroy', function () {
                win.unbind("resize", updateChart);
            });

            function updateChart() {
                //unbind this function before removing the chart
                win.unbind("resize", updateChart);
                OgrChart.destroy(element);
                element.empty();
                makeChart();
                win.bind("resize", updateChart);
            }

            function makeChart() {
                // console.log('here!');
                //load defaults
                var chartObject = angular.copy(yieldCurveChartConfig.yieldCurveChartDefaults.chartObject);
                var defaultLineStyles = angular.copy(yieldCurveChartConfig.yieldCurveChartDefaults.lineStyles);
                var xTicksTranslations = angular.copy(yieldCurveChartConfig.yieldCurveChartDefaults.xTicksTranslations);
                // //get chart title from chartData
                // chartObject.title.text = angular.copy(scope.chartData.title);

                //get Y-axis title
                var yAxisTitle = angular.copy(scope.yAxisTitle);

                //get lines' legends from chartData
                var lineLegends = angular.copy(scope.chartData.lineLegends);

                //try getting lines' styles from lineStyle
                var lineStyles = angular.copy(scope.lineStyle);

                //try getting type of the curve from curveType or set it to zero-curve by default
                var curveType = angular.copy(scope.curveType);
                if (!curveType) {
                    curveType = 'zero';
                }

                //get lines' series from chartData
                var lineData;
                lineData = angular.copy(scope.chartData.lineSeries[curveType]);
                lineData.map(function (el) {
                    return el.sort(function (a, b) {
                        return parseFloat(a.tenorDays) - parseFloat(b.tenorDays);
                    });
                });

                //try getting minimum tenor from minTenor
                var minTenor = angular.copy(scope.minTenor);

                //try getting maximum tenor from maxTenor
                var maxTenor = angular.copy(scope.maxTenor);

                //try getting language key and use EN by default
                var langKey = angular.copy(scope.langKey);
                if (!langKey) {
                    langKey = 'en';
                }

                //update chart height based on the height of the parent element
                // console.log(element.parent().height());
                chartObject.height = element.parent().height() - 10;

                //if there was an error don't try to build a chart
                if (lineData === null) {
                    element.append('<p>Unable to plot the chart</p>');
                    return;
                }

                //if there's no line styles provided fill them in with the default line styles
                var ix;
                if (lineData.length > 0 && (!lineStyles || lineStyles.length === 0)) {
                    lineStyles = [];
                    for (ix = 0; ix < Math.min(7, lineData.length); ix++) {
                        lineStyles.push(defaultLineStyles.predefined[ix]);
                    }
                }

                //if line data is empty show the "Empty" message
                if (lineData.length === 0) {
                    chartObject.placeholder.show = true;
                    chartObject.xAxis.show = false;
                    chartObject.yAxis.show = false;
                    chartObject.xAxis.grid = false;
                    chartObject.yAxis.grid = false;
                    chartObject.series = [];
                    chartObject.legend.show = false;
                } else {
                    chartObject.placeholder.show = false;
                    chartObject.xAxis.show = true;
                    chartObject.yAxis.show = true;
                    chartObject.xAxis.grid = true;
                    chartObject.yAxis.grid = true;
                    chartObject.series = [];
                    chartObject.legend.show = true;
                }
                //cut the range of all chart series
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        if (minTenor) {
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint)) {
                                    return false;
                                }
                                return parseFloat(dataPoint.tenorDays) >= minTenor;
                            });
                        }
                        if (maxTenor) {
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint)) {
                                    return false;
                                }
                                return parseFloat(dataPoint.tenorDays) <= maxTenor;
                            });
                        }
                    }
                }
                //fill in series of chartObject with the lines' data
                var minValue = Number.MAX_VALUE;
                var maxValue = -Number.MAX_VALUE;
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        //construct array of the series points
                        var dataPoints = [];
                        var isLeadingNan = true;
                        for (var jx = 0; jx < lineData[ix].length; jx++) {
                            if (lineData[ix][jx].tenorDays == 0) {
                                continue;
                            }
                            var xNum = parseFloat(lineData[ix][jx].tenorDays);
                            var yNum = parseFloat(lineData[ix][jx].value);
                            if (isNaN(yNum)) {
                                yNum = null;
                                if (isLeadingNan) continue;
                            } else {
                                isLeadingNan = false;
                                minValue = Math.min(minValue, yNum);
                                maxValue = Math.max(maxValue, yNum);
                            }
                            var translatedText = lineData[ix][jx].tenorLabel;
                            if (angular.isDefined(xTicksTranslations[lineData[ix][jx].tenorLabel]) && angular.isDefined(xTicksTranslations[lineData[ix][jx].tenorLabel][langKey]))
                                translatedText = xTicksTranslations[lineData[ix][jx].tenorLabel][langKey];
                            dataPoints.push({
                                x: xNum,
                                y: yNum,
                                text: translatedText
                            });
                        }
                        //use default line style if number of lines is higher the number of predefined lines in config
                        if (lineStyles.length < ix + 1) {
                            lineStyles.push(defaultLineStyles.new);
                        }
                        //use default legend if lineLegends array is shorter
                        var lineName = "";
                        if (!lineLegends || lineLegends.length < ix + 1) {
                            lineName = "curve" + (ix + 1);
                        } else {
                            lineName = lineLegends[ix];
                        }
                        //add series to the chart structure
                        chartObject.series.push({
                            kind: 'line',
                            color: lineStyles[ix].color,
                            lineWidth: lineStyles[ix].width,
                            marker: {show: true, size: lineStyles[ix].markerSize},
                            dash: lineStyles[ix].dashSetting,
                            points: dataPoints,
                            label: lineName
                        });
                    }
                }
                // change chart X-axis interval if chartMaxTenor is lower than 2Y
                if (maxTenor !== 731) {
                    chartObject.xAxis.step = 365;
                    if (maxTenor > 7305) {
                        chartObject.xAxis.step = 730;
                    }
                } else {
                    chartObject.xAxis.step = 90;
                }
                chartObject.xAxis.max = maxTenor;
                // adjust Y-axis range to be tight
                if (lineData.length > 0) {
                    chartObject.yAxis.min = Math.floor(minValue * 10) / 10 - 0.1;
                    chartObject.yAxis.max = Math.ceil(maxValue * 10) / 10 + 0.1;
                }
                //assign Y-axis title
                chartObject.yAxis.title.text = yAxisTitle;

                // console.log(chartObject);
                //generate the chart from prepared object
                OgrChart.render(element, angular.copy(chartObject));
            }
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .constant('yieldCurveChartConstants', {
            'lineColorSet': [
                '#46b44f',
                '#356581',
                '#ff8400',
                '#8b4513',
                '#e52b50',
                '#8b92a1',
                '#ffd700'
            ]
        });
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .provider('yieldCurveChartConfig', yieldCurveChartConfig);

    // configuration
    yieldCurveChartConfig.$inject = ['yieldCurveChartConstants'];
    function yieldCurveChartConfig(yieldCurveChartConstants) {
        this.yieldCurveChartDefaultObject = {
            height: 250,
            xAxis: {
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                show: true, // to be changed for empty charts
                grid: true,
                scale: 'linear',
                min: 0,
                step: 365,
                formatLabel: tenorLabel
            },
            yAxis: {
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                title: {
                    show: true,
                    text: 'Yield (%, annually compounded)',
                    font: {
                        size: "12px",
                        fontFamily: "Helvetica",
                        color: "#1e2834"
                    }
                },
                show: true, // to be changed for empty charts
                grid: true
            },
            seriesStyle: {
                defaultOpacity: 0.75,
                hoverOpacity: 1
            },
            //Series are to be filled in the app
            series: [],
            //vertical tracker line with a tooltip per series
            tracker: true,
            legend: {
                show: true,
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                }
            },
            placeholder: {
                show: false, // to be changed for empty charts
                text: "Empty",
                fontSize: "28px",
                opacity: 0.2
            },
            tooltipText: tooltipText
        };

        this.yieldCurveChartDefaultLineStyles = {
            predefined: [ //todo: only six lines are predefined so far, will see if more is needed
                {
                    width: 3,
                    color: yieldCurveChartConstants.lineColorSet[0],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: yieldCurveChartConstants.lineColorSet[1],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: yieldCurveChartConstants.lineColorSet[2],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: yieldCurveChartConstants.lineColorSet[3],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: yieldCurveChartConstants.lineColorSet[4],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: yieldCurveChartConstants.lineColorSet[5],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: yieldCurveChartConstants.lineColorSet[6],
                    dashSetting: [1, 0],
                    markerSize: 2
                }
            ],
            new: {
                width: 3,
                color: null, //will be picked automatically
                dashSetting: [1, 0],
                markerSize: 2
            }
        };

        this.xTicksTranslations = {
            "today": {en: "today", fr: "aujourd'hui"},
            "1 day": {en: "1 day", fr: "1 jour"},
            "1 week": {en: "1 week", fr: "1 semaine"},
            "2 weeks": {en: "2 weeks", fr: "2 semaines"},
            "3 weeks": {en: "3 weeks", fr: "3 semaines"},
            "1 month": {en: "1 month", fr: "1 mois"},
            "2 months": {en: "2 months", fr: "2 mois"},
            "1 quarter": {en: "1 quarter", fr: "1 trimestre"},
            "2 quarters": {en: "2 quarters", fr: "2 trimestres"},
            "3 quarters": {en: "3 quarters", fr: "3 trimestres"},
            "1 year": {en: "1 year", fr: "1 an"},
            "5 quarters": {en: "5 quarters", fr: "5 trimestres"},
            "6 quarters": {en: "6 quarters", fr: "6 trimestres"},
            "7 quarters": {en: "7 quarters", fr: "7 trimestres"},
            "2 years": {en: "2 years", fr: "2 ans"},
            "3 years": {en: "3 years", fr: "3 ans"},
            "4 years": {en: "4 years", fr: "4 ans"},
            "5 years": {en: "5 years", fr: "5 ans"},
            "6 years": {en: "6 years", fr: "6 ans"},
            "7 years": {en: "7 years", fr: "7 ans"},
            "8 years": {en: "8 years", fr: "8 ans"},
            "9 years": {en: "9 years", fr: "9 ans"},
            "10 years": {en: "10 years", fr: "10 ans"},
            "11 years": {en: "11 years", fr: "11 ans"},
            "12 years": {en: "12 years", fr: "12 ans"},
            "13 years": {en: "13 years", fr: "13 ans"},
            "14 years": {en: "14 years", fr: "14 ans"},
            "15 years": {en: "15 years", fr: "15 ans"},
            "16 years": {en: "16 years", fr: "16 ans"},
            "17 years": {en: "17 years", fr: "17 ans"},
            "18 years": {en: "18 years", fr: "18 ans"},
            "19 years": {en: "19 years", fr: "19 ans"},
            "20 years": {en: "20 years", fr: "20 ans"},
            "21 years": {en: "21 years", fr: "21 ans"},
            "22 years": {en: "22 years", fr: "22 ans"},
            "23 years": {en: "23 years", fr: "23 ans"},
            "24 years": {en: "24 years", fr: "24 ans"},
            "25 years": {en: "25 years", fr: "25 ans"},
            "26 years": {en: "26 years", fr: "26 ans"},
            "27 years": {en: "27 years", fr: "27 ans"},
            "28 years": {en: "28 years", fr: "28 ans"},
            "29 years": {en: "29 years", fr: "29 ans"},
            "30 years": {en: "30 years", fr: "30 ans"}
        };

        this.$get = function () {
            return {
                yieldCurveChartDefaults: {
                    chartObject: this.yieldCurveChartDefaultObject,
                    lineStyles: this.yieldCurveChartDefaultLineStyles,
                    xTicksTranslations: this.xTicksTranslations
                }
            };
        };

        function tooltipText(point) {
            //reformat Y number up to 4th precision point
            return point.text + " : " + point.y.toPrecision(4);
        }

        // X axis labels: tenor in days -> years ("1Y") or, for steps below a year, days ("90D")
        function tenorLabel(label) {
            var unit = (label.step >= 365) ? 365 : 1;
            var unitLetter = (unit === 365) ? "Y" : "D";
            return (label.text == "0")
                ? "" // show "" for the zero tenor
                : parseFloat(label.text) / unit + unitLetter;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .directive('ycTable', ycTable);

    ycTable.$inject = ['$filter', 'ycTableConstants', 'TimeseriesUtils', 'DataUtils'];

    function ycTable($filter, ycTableConstants, TimeseriesUtils, DataUtils) {
        // Generates table for one or more rows
        // Usage:
        //  <div data-stat-table table-data="vm.tableData"
        //       orig-data="vm.origTableData"
        //       data-show-units-col="true"
        //       data-show-units-row="true"
        //       data-country-name="countryName"
        //       data-switch-to-chart="vm.switchToChart"
        //       data-recalculate-fun="vm.recalculate"
        //       data-tenor-state="vm.tenorState">
        // Input structure:
        //  vm.tableData = {
        //      tableId: "someId",
        //      hideTenors: [Double, Double, ...],
        //      rowIds: [ "1st id", "2nd id", ... ],
        //      rowHeaders: [ "1st header", "2nd header", ... ],
        //      rowTooltips: ["1st tooltip", "2nd tooltip"],
        //      rowUnits: [ "1st unit", "2nd unit", ... ],
        //      rows: [
        //          {
        //              "tenorLabel": {
        //                  value: Double,
        //                  isEditable: Boolean,
        //                  isLastInBlock: Boolean
        //              },
        //              ...
        //          },
        //          ...
        //      ]
        //  }
        //
        //  vm.tenorState = {
        //      "tenorLabel": {
        //          recalculated: Boolean,
        //          calculating: Boolean,
        //          failed: Boolean
        //      },
        //      ...
        //  }
        var directive = {
            restrict: 'A',
            templateUrl: 'app/components/yc-table/yc-table.html',
            scope: {
                tableData: '=',
                origData: '<',
                showUnitsCol: '<',
                showUnitsRow: '<',
                countryName: '<',
                switchToChart: '=',
                recalculateFun: '=',
                tenorState: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            // assign ID to the main directive element
            element.attr('id', scope.tableData.tableId);

            // define variables and functions in the scope of this directive
            scope.activeTenors = ycTableConstants.tenorList.labels;
            scope.someTenorsHidden = false;
            scope.descHidden = true;
            scope.hiddenTenorsDefined = (angular.isDefined(scope.tableData.hideTenors)
                && angular.isArray(scope.tableData.hideTenors)
                && scope.tableData.hideTenors.length > 0);
            scope.noRecalculate = (scope.recalculateFun == null);
            scope.exportToCsv = exportToCsv;
            scope.resetTable = resetTable;
            scope.recalculate = recalculate;
            scope.toggleTenors = toggleTenors;
            scope.toggleDesc = toggleDesc;
            scope.getModifiedTenors = getModifiedTenors;
            scope.getNotRecalculatedTenors = getNotRecalculatedTenors;
            scope.onYcInputChanged = onYcInputChanged;

            // hide some tenor columns if requested so
            scope.toggleTenors();

            // recalculate the curves based on user-supplied Sharpe Ratios
            function recalculate() {
                if (scope.noRecalculate) {
                    return;
                }
                const zcRowIx = scope.tableData.rowIds.findIndex(function (rid) {
                    return rid === 'sharpe_ratio_zc';
                });
                if (zcRowIx > -1) {
                    const tenors = scope.getNotRecalculatedTenors();
                    const values = [];
                    for (var i = 0; i < tenors.length; i++) {
                        const thisTenor = tenors[i];
                        values.push(scope.tableData.rows[zcRowIx][thisTenor].value);
                    }
                    scope.recalculateFun(tenors, values);
                }
            }

            function onYcInputChanged(rowIx, colIx) {
                const thisTenorLabel = scope.activeTenors[colIx];
                scope.tenorState[thisTenorLabel].recalculated = false;
                scope.tenorState[thisTenorLabel].failed = false;
            }

            // returns the list of tenors where user has modified a zero-coupon SR
            function getModifiedTenors() {
                try {
                    const zcRowIx = scope.tableData.rowIds.findIndex(function (rid) {
                        return rid === 'sharpe_ratio_zc';
                    });
                    // unlikely case, but let's keep it safe
                    if (zcRowIx === -1) {
                        return [];
                    }
                    return ycTableConstants.tenorList.labels.filter(function (lab) {
                        const thisTabValue = scope.tableData.rows[zcRowIx][lab].value;
                        const origTabValue = scope.origData.rows[zcRowIx][lab].value;
                        return thisTabValue !== origTabValue;
                    });
                } catch (e) {
                    return [];
                }

            }

            // returns the list of tenors where user has modified a zero-coupon SR
            // and for which he did not run the re-calculation yet
            function getNotRecalculatedTenors() {
                try {
                    return ycTableConstants.tenorList.labels.filter(function (lab) {
                        return !scope.tenorState[lab].recalculated;
                    });
                } catch (e) {
                    return [];
                }
            }

            // auxiliary function saving the content to CSV file
            function exportToCsv() {
                var fileName = scope.countryName + " -- YCM Report Table (exported on "
                    + $filter('date')(new Date(), 'dd-MMM-yyyy') + ").csv";
                var tableCsvContent = ['Description', 'Unit']
                    .concat(ycTableConstants.tenorList.labels)
                    .join(',');
                tableCsvContent += '\n';
                for (var rx = 0; rx < scope.tableData.rows.length; rx++) {
                    var thisRow = [];
                    // add "description" cell
                    if (angular.isArray(scope.tableData.rowHeaders)
                        && angular.isDefined(scope.tableData.rowHeaders[rx])) {
                        thisRow.push(scope.tableData.rowHeaders[rx]);
                    } else {
                        thisRow.push('');
                    }
                    // add "units" cell
                    if (angular.isArray(scope.tableData.rowUnits)
                        && angular.isDefined(scope.tableData.rowUnits[rx])) {
                        thisRow.push('"' + scope.tableData.rowUnits[rx].toString() + '"');
                    } else {
                        thisRow.push('');
                    }
                    // add "value" cells for all tenors
                    for (var lx = 0; lx < ycTableConstants.tenorList.labels.length; lx++) {
                        var val = scope.tableData.rows[rx][ycTableConstants.tenorList.labels[lx]].value;
                        if (val !== '') {
                            val = Math.round(val * 1000) / 1000;
                        }
                        thisRow.push(val);
                    }
                    // add new row to the table variable
                    tableCsvContent += thisRow.join(',');
                    tableCsvContent += '\n';
                }

                // save file
                DataUtils.saveFile('text/csv', tableCsvContent, fileName);
            }

            // auxiliary function resetting table to its original state
            function resetTable(){
                scope.tableData = angular.copy(scope.origData);
                scope.tenorState = ycTableConstants.tenorList.labels.reduce(function (accum, tLab) {
                    accum[tLab] = {
                        recalculated: true,
                        calculating: false,
                        failed: false
                    };
                    return accum;
                }, {});
            }

            // auxiliary function toggling the hidden tenor columns
            function toggleTenors() {
                scope.someTenorsHidden = !scope.someTenorsHidden;
                if (scope.someTenorsHidden && scope.hiddenTenorsDefined) {
                    scope.activeTenors = [];
                    for (var lx = 0; lx < ycTableConstants.tenorList.values.length; lx++) {
                        const thisTenor = ycTableConstants.tenorList.values[lx];
                        var thisIx = scope.tableData.hideTenors.findIndex(function (el) {
                            return el === thisTenor;
                        });
                        if (thisIx === -1) {
                            scope.activeTenors.push(ycTableConstants.tenorList.labels[lx]);
                        }
                    }
                } else {
                    scope.activeTenors = ycTableConstants.tenorList.labels;
                }
            }

            // auxiliary function toggling the descriptions of rows
            function toggleDesc() {
                scope.descHidden = !scope.descHidden;
            }
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .constant('ycTableConstants', {
            'tenorList': {
                values: [1, 7, Math.floor(365 / 12), Math.floor(365 / 6), Math.floor(365 / 4),
                    Math.floor(365 / 2), 365, 365 * 2, 365 * 3, 365 * 4, 365 * 5, 365 * 6, 365 * 7, 365 * 8,
                    365 * 9, 365 * 10],
                labels: ['1D', '1W', '1M', '2M', '3M', '6M', '1Y', '2Y', '3Y', '4Y', '5Y', '6Y',
                    '7Y', '8Y', '9Y', '10Y']
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }

            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('TimeseriesUtils', TimeseriesUtils);

    TimeseriesUtils.$inject = ['$filter', 'DateUtils'];

    function TimeseriesUtils($filter, DateUtils) {

        var service = {
            parseTsDate: parseTsDate,
            getTsDatePattern: getTsDatePattern,
            getMaxDate: getMaxDate,
            seriesToChartSeries: seriesToChartSeries,
            convertDateToTsDate: convertDateToTsDate
        };

        return service;

        /*computes date number from the IRIS date string*/
        function parseTsDate(dateString, frequency) {
            var pattern;
            switch (frequency) {
                case 1:
                    pattern = /(\d{2}|\d{4})y?.*/i;
                    break;
                case 4:
                    pattern = /(\d{2}|\d{4})q(\d{1,2})/i;
                    break;
                case 12:
                    pattern = /(\d{2}|\d{4})m(\d{1,2})/i;
                    break;
                case 365:
                    return DateUtils.convertLocalDateFromServer(dateString);
            }
            var y = parseInt(dateString.replace(pattern, "$1"));
            var p = (frequency == 1) ? 1 : parseInt(dateString.replace(pattern, "$2"));
            var m = (frequency == 1) ? 0 : (frequency == 4) ? p * 3 - 3 : p - 1;

            if (y >= 70 && y < 100) {
                y += 1900;
            }
            if (y < 70) {
                y += 2000;
            }

            return new Date(y, m, 1);
        }

        /*converts Date object to the IRIS date string formatted according to the dateFormat*/
        function convertDateToTsDate(dateObj, frequency, dateFormat) {
            if (typeof (dateObj) == 'string')
                dateObj = new Date(dateObj);
            if (frequency == 365) {
                return $filter('date')(dateObj, dateFormat);
            }
            var y = dateObj.getFullYear();
            var m = dateObj.getMonth();
            var p = ((frequency == 1) ? 1 : (frequency == 4) ? Math.ceil((m + 1) / 3) : m + 1).toString();
            var freqLetter = (frequency == 1) ? 'y' : (frequency == 4) ? 'q' : 'm';
            var dateString = dateFormat;
            var hasFreqLetter = (dateString.search(/f/i) !== -1);
            var hasMonthName = (dateString.search(/mmm/i) !== -1);
            dateString = dateString.replace(/yyyy/i, y.toString());
            dateString = dateString.replace(/yy/i, y.toString().slice(-2));
            dateString = dateString.replace(/f/, freqLetter);
            dateString = dateString.replace(/F/, freqLetter.toUpperCase());
            dateString = dateString.replace(/pp/i, p.length == 1 ? '0' + p : p);
            dateString = dateString.replace(/p/i, p);
            // month names
            var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];
            dateString = dateString.replace(/Mmmm/, monthNames[m]);
            dateString = dateString.replace(/mmmm/, monthNames[m].toLowerCase());
            dateString = dateString.replace(/MMMM/, monthNames[m].toUpperCase());
            dateString = dateString.replace(/Mmm/, monthNames[m].slice(0, 3));
            dateString = dateString.replace(/mmm/, monthNames[m].toLowerCase().slice(0, 3));
            dateString = dateString.replace(/MMM/, monthNames[m].toUpperCase().slice(0, 3));
            dateString = dateString.replace(/mm/i, (m <= 8) ? '0' + (m + 1).toString() : (m + 1).toString());
            if ((frequency !== 12 || !hasFreqLetter) && !hasMonthName) {
                dateString = dateString.replace(/m/i, (m + 1).toString());
            }

            return dateString;
        }

        /*computes date string pattern from the IRIS date string*/
        function getTsDatePattern(dateString, frequency) {
            var pattern = /(\d{2}|\d{4})m(\d{1,2})/i;
            var y = "Y".repeat(dateString.replace(pattern, "$1").length);
            var m = "P".repeat(dateString.replace(pattern, "$2").length);

            return y + "F" + m;
        }

        /*computes maximum date from the current period string
         and number of months from now*/
        function getMaxDate(currentPeriod, monthsFromNow) {
            //convert current date string to js Date()
            var currentDate = parseTsDate(currentPeriod);
            //maximum year is the current year plus number
            // of full years in the number of months after
            // adding figure from the config
            var maxYear = currentDate.getFullYear()
                + Math.floor((monthsFromNow + (currentDate.getMonth() + 1)) / 12);
            //maximum month is the reminder after subtracting
            // full years from the sum of the current month
            // and the figure from config
            var maxMonth = (currentDate.getMonth() + monthsFromNow) % 11;
            return new Date(maxYear, maxMonth, currentDate.getDate());
        }

        /*cuts time series to fir the [minDate,maxDate] interval and converts it to
         the array of objects with two fields: 'time' and 'value' */
        function seriesToChartSeries(series, minDate, maxDate) {
            var chartSeries = [];

            angular.forEach(series, function (value, key) {
                var time = parseTsDate(key);
                if (time >= minDate && time <= maxDate) {
                    chartSeries.push({
                        time: time,
                        value: value
                    });
                }
            });

            return chartSeries;
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('portalApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20 + 1)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('portalApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window', 'FileSaver', 'Blob'];

    function DataUtils($window, FileSaver, Blob) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            saveFile: saveFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function saveFile(type, data, fileName) {
            var blobData = new Blob([data], {type: type});
            FileSaver.saveAs(blobData, fileName);
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('portalApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('LoginInlineController', LoginInlineController);

    LoginInlineController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function LoginInlineController ($rootScope, $state, $timeout, Auth) {
        var vm = this;

        vm.authenticationError = false;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'cs',
            'ru'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20,
            'userGroupSelectionItemsPerPage': 100
        });
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .directive('inputRounding', inputRounding);

    inputRounding.$inject = ['$filter', '$locale'];

    function inputRounding($filter, $locale) {
        var directive = {
            terminal: true,
            restrict: 'A',
            require: '?ngModel',
            scope: {
                decimals: '<',
                hideZero: '<'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            // number of decimals to round the number to
            var decimals = 2;
            if (angular.isDefined(scope.decimals)) {
                decimals = angular.copy(scope.decimals);
            }
            // whether to hide zeros or not
            var hideZero = false;
            if (angular.isDefined(scope.hideZero)) {
                hideZero = scope.hideZero;
            }

            if (!ngModel)
                return; // do nothing if no ng-model

            // function to do the rounding
            var roundMe = function (number) {
                if (number) {
                    return $filter('number')(number, decimals);
                }
                return number;
            };

            // Listen for change events to enable binding
            element.bind('blur', function () {
                element.val(roundMe(ngModel.$modelValue));
            });

            // push a formatter so the model knows how to render
            ngModel.$formatters.push(function (value) {
                if (value) {
                    return roundMe(value);
                }
                else if (value === 0 && !hideZero) {
                    return value;
                }
            });

            // push a parser to remove any special rendering and make sure the inputted number is rounded
            ngModel.$parsers.push(function (value) {
                return value;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('OgrChart', OgrChart);

    OgrChart.$inject = ['$window', '$document', 'chartConstants'];

    /**
     * OgrChart: OGResearch's SVG line chart renderer.
     *
     * The renderer draws a chart spec:
     *   height         chart height in px (default 250)
     *   title          {text, show, font: {size, fontFamily, fontWeight, color}}  -- centred above the plot
     *   xAxis          {show, font, grid, scale: 'category'|'linear', min, max, step,
     *                   labelOverlap: 'hide' (default: overlapping labels are left out) | 'wrap' (moved to a
     *                   further row below),
     *                   shading: [{from, to, color, opacity, onTop}]   -- shaded x ranges (category indexes or
     *                   values), behind the series or, with onTop, over them
     *                   formatLabel: function ({text, value, step}) -> label text}
     *   yAxis          {show, font, grid, min, max, step, title: {show, text, font}}
     *   series         [{kind: 'line'|'band', label, color, lineWidth, dash ([dash, gap] or 'dash,gap'),
     *                    marker: {show, size}, hidden, edgeColor, tooltipFont,
     *                    spline: true -> a line is drawn as a natural cubic spline through its points,
     *                    points: [{x, y, text}] for lines, [{x, upper, lower}] for bands,
     *                    axisOnly: true -> the series only supplies x categories (never drawn or tracked)}]
     *   seriesStyle    {defaultOpacity: of every series when not hovered (default 1),
     *                   hoverOpacity: of the series under the pointer (unset: no hover effect)}
     *   legend         {show, font, clickToHide (default true: clicking an item hides/shows its series)}
     *                  -- a line series is shown as a ring on a line, or just the line when it has no markers
     *   tracker        true: vertical tracker line with a tooltip per series follows the pointer
     *   tooltipText    function (point, defaultText) -> tooltip text ('<br/>' separates lines)
     *   placeholder    {show, text, fontSize, opacity}  -- text centred over the plot in place of a chart, e.g. "Empty"
     *   animate        true: the lines are drawn in from the left and their markers pop up one by one
     *
     * A chart without any points keeps a plain grid (axes hidden) or its bare axes (axes shown).
     */
    function OgrChart($window, $document, chartConstants) {
        var SVG_NS = 'http://www.w3.org/2000/svg';
        var measureNode = null; // hidden DOM element used for tooltip text measurement
        var measureCache = {};  // tooltip text sizes by font + text (measuring forces a browser layout)
        var measureCacheSize = 0;

        var TRACKER = {
            guideColor: 'Black',     // vertical line under the pointer
            guideWidth: 1,
            markerSize: 10,          // marker drawn on each tracked point
            markerRingWidth: 3,
            markerFill: 'white',
            font: {size: '12px', fontFamily: 'Segoe UI', fontStyle: 'normal', fontWeight: 'normal'}, // tooltip font
            textColor: '#ffffff',
            textMargin: 4,           // tooltip text to box edge
            pointGap: 16,            // point to the near box edge
            stackGap: 8,             // between stacked boxes
            clearanceTop: 3,         // stacked boxes keep this far from the plot top
            clearanceBottom: 4,      // ... and from the plot bottom
            sideRoom: 2,             // a box goes left of its point before the right side gets this many boxes tight
            boxOpacity: 1,
            boxRadius: 3,
            arrowSize: 5
        };

        var STYLE = {
            gridColor: '#DFDFDF',
            axisColor: '#8E8E8E',
            areaBorderColor: 'Gray',
            areaBorderWidth: 0.5,
            xTickSize: 5,
            yTickSize: 6,
            defaultFont: {size: '12px', fontFamily: 'Helvetica', color: '#1e2834'},
            titleFont: {size: '16px', fontFamily: 'Helvetica', color: '#1e2834'},
            padding: 20,
            titleGap: 10,                // between the title and the plot
            titleBaselineShift: 5,       // title baseline below the middle of its line
            yAxisBand: 26,               // left of the plot besides the Y labels: padding, gap, ticks and axis line
            yTitleBand: 37,              // extra room for a Y axis title
            xAxisBand: 26,               // below the plot besides the X labels: axis line, ticks, gap, padding
            xLabelOffset: 10.5,          // plot bottom to the top of the first X label row
            legendFrame: 2,              // added to the legend height below the plot
            emptyMargin: 26,
            labelGap: 2,                 // least space between two X labels, and to the chart's right edge
            // labelOverlap 'wrap': label rows kept below the plot by chart width (the first entry the width reaches),
            // so charts side by side keep the same plot height
            wrapRows: [{minWidth: 400, rows: 1}, {minWidth: 230, rows: 2}, {minWidth: 0, rows: 3}],
            emptyGrid: {columns: 7, rows: 6},  // grid of a chart without points and axes
            emptyAxisSteps: 6,           // ticks on the bare X axis of a chart without points
            // animate
            drawInMs: 2000,              // lines are drawn in from the left over this time
            markerPopMs: 200,            // each marker grows to full size in this time
            // legend geometry
            legendItemSize: 9,
            legendSymbolRing: 3,         // line series symbol: ring radius
            legendSymbolReach: 7,        // line series symbol: half of its total width
            legendSymbolStroke: 2,       // line series symbol: stroke width
            legendItemPadding: 10,
            legendElementSpacing: 10,
            legendSideMargin: 21,        // free space left and right of the widest legend row
            legendBottomGap: 16,         // gap between the legend box and the svg bottom
            xIntervalPx: 62.5,           // aimed-for pixels between two X axis ticks
            minTickGapPx: 5,             // a configured step giving ticks closer than this is ignored
            yIntervalPx: 100 / 3,        // aimed-for pixels between two Y axis ticks
            // colours for series that do not set their own
            fallbackColors: chartConstants.lineColorSet
        };

        var service = {
            render: render,
            destroy: destroy
        };

        return service;

        //************************************************************************************
        // public API
        //************************************************************************************

        /**
         * Removes a chart previously rendered into the element (if any).
         */
        function destroy(element) {
            var el = element[0] || element;
            var state = el.__ogrChart;
            if (state) {
                if (state.stopTracker) {
                    state.stopTracker();
                }
                if (state.stopAnimation) {
                    state.stopAnimation();
                }
                if (state.svg && state.svg.parentNode) {
                    state.svg.parentNode.removeChild(state.svg);
                }
                if (state.overlay && state.overlay.parentNode) {
                    state.overlay.parentNode.removeChild(state.overlay);
                }
                delete el.__ogrChart;
            }
        }

        /**
         * Renders the chart described by spec into the element.
         */
        function render(element, spec) {
            var el = element[0] || element;
            destroy(element);

            var width = el.clientWidth || angular.element(el).width() || 0;
            var height = parseFloat(spec.height) || 250;
            if (!(width > 0) || !(height > 0)) {
                return;
            }

            var model = buildModel(spec, width, height);
            var svg = createEl('svg', {width: width, height: height});
            svg.style.width = width + 'px';
            svg.style.height = height + 'px';
            svg.style.display = 'block';
            svg.style.margin = '0 auto';
            svg.setAttribute('class', 'ogr-chart');

            drawArea(svg, model);
            drawTitle(svg, model);
            drawGrid(svg, model);
            drawClip(svg, model);
            drawShading(svg, model, false);
            drawSeries(svg, model);
            drawAxes(svg, model);
            drawShading(svg, model, true);
            drawLegend(svg, model);

            el.style.position = el.style.position || 'relative';
            el.appendChild(svg);

            var overlay = drawPlaceholder(el, model);

            el.__ogrChart = {svg: svg, overlay: overlay, model: model};
            bindLegend(el, model, spec);
            if (model.hasData && model.tracker) {
                el.__ogrChart.stopTracker = bindTracker(el, svg, model);
            }
            if (model.hasData && model.animate) {
                el.__ogrChart.stopAnimation = drawIn(model);
            }
        }

        /* legend.clickToHide (default true): clicking an item flips that series' hidden flag and redraws the
           whole chart; hidden series keep their legend slot, drawn in gray */
        function bindLegend(el, model, spec) {
            if (!model.legendItems || model.legend.clickToHide === false) {
                return;
            }
            angular.forEach(model.legendItems, function (item) {
                if (item.series.axisOnly) {
                    return;
                }
                item.node.addEventListener('click', function () {
                    var raw = spec.series[item.series.index];
                    raw.hidden = !raw.hidden;
                    render(el, spec);
                });
            });
        }

        //************************************************************************************
        // model
        //************************************************************************************

        function buildModel(spec, width, height) {
            var xAxis = spec.xAxis || {};
            var yAxis = spec.yAxis || {};
            var legend = spec.legend || {};
            var title = spec.title || {};

            var seriesStyle = spec.seriesStyle || {};
            var series = normalizeSeries(spec.series || [], angular.isDefined(seriesStyle.defaultOpacity) ? seriesStyle.defaultOpacity : 1);
            var hasData = series.some(function (s) {
                return s.points.length > 0;
            });

            var model = {
                width: width,
                height: height,
                series: series,
                hasData: hasData,
                axesVisible: hasData && xAxis.show !== false && yAxis.show !== false,
                // series without any points: the axes stay, without labels
                bareAxes: !hasData && series.length > 0 && xAxis.show !== false && yAxis.show !== false,
                xAxis: xAxis,
                yAxis: yAxis,
                xFont: fontOf(xAxis.font),
                yFont: fontOf(yAxis.font),
                titleText: title.show !== false && title.text ? String(title.text) : '',
                titleFont: fontOf(title.font, STYLE.titleFont),
                labelOverlap: xAxis.labelOverlap === 'wrap' ? 'wrap' : 'hide',
                animate: spec.animate === true,
                legend: legend,
                legendVisible: hasData && legend.show === true,
                legendFont: fontOf(legend.font),
                placeholder: spec.placeholder || {},
                tracker: spec.tracker === true,
                hoverOpacity: seriesStyle.hoverOpacity,
                tooltipText: spec.tooltipText,
                isCategory: xAxis.scale === 'category'
            };

            computeXScale(model);
            computeYScale(model);
            computeLayout(model);
            return model;
        }

        function normalizeSeries(rawSeries, opacity) {
            var result = [];
            for (var i = 0; i < rawSeries.length; i++) {
                var s = rawSeries[i];
                if (!s || !angular.isArray(s.points)) {
                    continue;
                }
                var kind = s.kind === 'band' ? 'band' : 'line';
                var points = s.points.map(function (p) {
                    return (kind === 'band')
                        ? {x: p.x, upper: toNumberOrNull(p.upper), lower: toNumberOrNull(p.lower), text: p.text}
                        : {x: p.x, y: toNumberOrNull(p.y), text: p.text};
                });
                result.push({
                    index: i,
                    kind: kind,
                    label: angular.isDefined(s.label) ? String(s.label) : '',
                    color: s.color || STYLE.fallbackColors[i % STYLE.fallbackColors.length],
                    axisOnly: s.axisOnly === true,
                    hidden: s.hidden === true,
                    lineWidth: angular.isDefined(s.lineWidth) ? s.lineWidth : 2,
                    dash: s.dash,
                    spline: s.spline === true,
                    opacity: opacity,
                    marker: s.marker || {},
                    edgeColor: s.edgeColor,
                    tooltipFont: s.tooltipFont || {},
                    points: points
                });
            }
            return result;
        }

        function computeXScale(model) {
            var xAxis = model.xAxis;
            var i, j, s;
            if (model.isCategory) {
                // categories in order of first appearance across the series
                var categories = [];
                var index = {};
                for (i = 0; i < model.series.length; i++) {
                    s = model.series[i];
                    for (j = 0; j < s.points.length; j++) {
                        var key = String(s.points[j].x);
                        if (!index.hasOwnProperty(key)) {
                            index[key] = categories.length;
                            categories.push(key);
                        }
                        s.points[j].xIndex = index[key];
                    }
                }
                model.categories = categories;
                var gaps = Math.max(categories.length - 1, 0);
                // the label spacing is judged on the chart width inside the padding
                var labelSpan = model.width - 2 * STYLE.padding;
                var interval = usableStep(Math.ceil(xAxis.step), gaps, model.width) || categoryInterval(gaps, labelSpan);
                var ticks = [];
                for (i = 0; i < categories.length; i += interval) {
                    ticks.push({value: i, text: categories[i]});
                }
                model.xTicks = ticks;
                model.xMin = 0;
                model.xMax = Math.max(categories.length - 1, 0);
            } else {
                var dataMin = Number.POSITIVE_INFINITY, dataMax = Number.NEGATIVE_INFINITY;
                for (i = 0; i < model.series.length; i++) {
                    s = model.series[i];
                    for (j = 0; j < s.points.length; j++) {
                        var xv = parseFloat(s.points[j].x);
                        if (!isNaN(xv)) {
                            dataMin = Math.min(dataMin, xv);
                            dataMax = Math.max(dataMax, xv);
                        }
                    }
                }
                if (!isFinite(dataMin)) {
                    dataMin = 0;
                    dataMax = 1;
                }
                var min = finiteOr(xAxis.min, dataMin);
                var max = finiteOr(xAxis.max, dataMax);
                if (max <= min) {
                    max = min + 1;
                }
                var step = usableStep(xAxis.step, max - min, model.width) || numericNiceInterval(max - min, model.width, true);
                var xTicks = [];
                for (var v = min, k = 0; v <= max + step * 1e-6; k++, v = min + k * step) {
                    xTicks.push({value: v, text: formatNumber(v)});
                }
                model.xMin = min;
                model.xMax = max;
                model.xInterval = step;
                model.xTicks = xTicks;
            }
            // X labels can be reformatted by the spec
            if (angular.isFunction(xAxis.formatLabel)) {
                angular.forEach(model.xTicks, function (tick) {
                    tick.text = String(xAxis.formatLabel({text: tick.text, value: tick.value, step: model.xInterval}));
                });
            }
        }

        function computeYScale(model) {
            var yAxis = model.yAxis;
            var dataMin = Number.POSITIVE_INFINITY, dataMax = Number.NEGATIVE_INFINITY;
            for (var i = 0; i < model.series.length; i++) {
                var s = model.series[i];
                if (s.axisOnly || s.hidden) {
                    continue;
                }
                for (var j = 0; j < s.points.length; j++) {
                    var p = s.points[j];
                    var vals = (s.kind === 'band') ? [p.upper, p.lower] : [p.y];
                    for (var k = 0; k < vals.length; k++) {
                        if (vals[k] !== null && !isNaN(vals[k])) {
                            dataMin = Math.min(dataMin, vals[k]);
                            dataMax = Math.max(dataMax, vals[k]);
                        }
                    }
                }
            }
            if (!isFinite(dataMin)) {
                dataMin = 0;
                dataMax = 1;
            }
            var min = finiteOr(yAxis.min, dataMin);
            var max = finiteOr(yAxis.max, dataMax);
            if (max <= min) {
                max = min + 1;
                min = min - 1;
            }
            model.yMin = min;
            model.yMax = max;
        }

        function computeLayout(model) {
            var pad = STYLE.padding;
            model.titleSize = model.titleText ? measureDom(model.titleText, model.titleFont) : null;
            var top = pad + (model.titleSize ? model.titleSize.height + STYLE.titleGap : 0);
            var left, right = pad, bottom;
            var yTitleVisible = model.axesVisible && model.yAxis.title && model.yAxis.title.show !== false
                && model.yAxis.title.text;
            model.legendBox = model.legendVisible ? layoutLegend(model) : null;
            var legendBand = model.legendBox ? model.legendBox.height + STYLE.legendFrame : 0;
            model.legendBand = legendBand;
            model.yTicks = [];

            if (!model.axesVisible) {
                left = STYLE.emptyMargin;
                bottom = STYLE.emptyMargin + legendBand;
            } else {
                // Y step from the tallest the plot can be (from its top down to the padding)
                var plotHeight = model.height - top - pad - legendBand;
                var interval = usableStep(model.yAxis.step, model.yMax - model.yMin, plotHeight)
                    || numericNiceInterval(model.yMax - model.yMin, plotHeight, false);
                // ticks start at the axis minimum, one step apart; each value is rounded to the step's decimals
                // (at least one) so float noise never reaches a label
                var decimals = Math.max(1, decimalsOf(interval));
                var stepCount = Math.floor((model.yMax - model.yMin) / interval + 1e-9);
                for (var k = 0; k <= stepCount; k++) {
                    var v = parseFloat((model.yMin + k * interval).toFixed(decimals));
                    if (v >= model.yMin && v <= model.yMax) {
                        model.yTicks.push({value: v, text: formatNumber(v)});
                    }
                }
                model.yInterval = interval;
                var labelWidth = 0;
                angular.forEach(model.yTicks, function (tick) {
                    labelWidth = Math.max(labelWidth, measureDom(tick.text, model.yFont).width);
                });
                left = STYLE.yAxisBand + labelWidth + (yTitleVisible ? STYLE.yTitleBand : 0);

                // X labels: their rows are known once the plot's horizontal extent is
                var rowHeight = 0;
                angular.forEach(model.xTicks, function (tick) {
                    tick.size = measureDom(tick.text, model.xFont);
                    rowHeight = Math.max(rowHeight, tick.size.height);
                });
                model.xRowHeight = rowHeight;
                var plotWidth = model.width - right - left;
                var rowsUsed = arrangeXLabels(model, left, plotWidth);
                model.xRows = model.labelOverlap === 'wrap' ? Math.max(rowsUsed, wrapRowsFor(model.width)) : 1;
                bottom = STYLE.xAxisBand + model.xRows * rowHeight + legendBand;
            }

            model.plot = {
                left: left,
                top: top,
                right: model.width - right,
                bottom: model.height - bottom
            };
            model.plot.width = model.plot.right - model.plot.left;
            model.plot.height = model.plot.bottom - model.plot.top;
            model.yTitleVisible = yTitleVisible;
            if (model.axesVisible) {
                placeXLabels(model);
            }
        }

        /* X labels, centred under their ticks (on the whole pixel left of the tick) and kept inside the chart,
           must stay labelGap apart: 'hide' leaves out a label that would come closer to the previous shown one,
           'wrap' puts it into the first row where it keeps that gap. Returns the number of label rows. */
        function arrangeXLabels(model, plotLeft, plotWidth) {
            var span = model.xMax - model.xMin;
            var rowEnds = [];
            angular.forEach(model.xTicks, function (tick) {
                var ratio = span > 0 ? (tick.value - model.xMin) / span : 0.5;
                var width = tick.size.width;
                var x = Math.min(Math.floor(plotLeft + ratio * plotWidth) - width / 2, model.width - STYLE.labelGap - width);
                var row = 0;
                if (model.labelOverlap === 'wrap') {
                    while (row < rowEnds.length && rowEnds[row] + STYLE.labelGap > x) {
                        row++;
                    }
                } else if (rowEnds.length > 0 && rowEnds[0] + STYLE.labelGap > x) {
                    tick.hidden = true;
                }
                tick.row = row;
                tick.labelX = x;
                if (!tick.hidden && tick.text !== '') {
                    rowEnds[row] = x + width;
                }
            });
            return Math.max(rowEnds.length, 1);
        }

        function wrapRowsFor(chartWidth) {
            for (var i = 0; i < STYLE.wrapRows.length; i++) {
                if (chartWidth >= STYLE.wrapRows[i].minWidth) {
                    return STYLE.wrapRows[i].rows;
                }
            }
            return 1;
        }

        /* X label rows below the plot */
        function placeXLabels(model) {
            var firstRow = Math.floor(model.plot.bottom) + STYLE.xLabelOffset;
            angular.forEach(model.xTicks, function (tick) {
                tick.label = {x: tick.labelX, y: firstRow + (tick.row + 0.5) * model.xRowHeight, anchor: 'start'};
            });
        }

        //************************************************************************************
        // scales & helpers
        //************************************************************************************

        function xToPx(model, value) {
            var span = model.xMax - model.xMin;
            var ratio = span > 0 ? (value - model.xMin) / span : 0.5;
            return model.plot.left + ratio * model.plot.width;
        }

        function yToPx(model, value) {
            var span = model.yMax - model.yMin;
            var ratio = span > 0 ? (value - model.yMin) / span : 0.5;
            return model.plot.bottom - ratio * model.plot.height;
        }

        function pointX(model, point) {
            return xToPx(model, model.isCategory ? point.xIndex : parseFloat(point.x));
        }

        /* 1px lines are drawn on pixel centres: vertical ones on the pixel at or right of the position,
           horizontal ones on the pixel at or above it */
        function crispUp(v) {
            return Math.ceil(v) + 0.5;
        }

        function crispDown(v) {
            return Math.floor(v) + 0.5;
        }

        /* how many intervals fit on an axis of this pixel length (at least one) */
        function intervalBudget(axisLength, horizontal) {
            return Math.max(axisLength / (horizontal ? STYLE.xIntervalPx : STYLE.yIntervalPx), 1);
        }

        /* tick step for a numeric axis: the smallest of 1, 2, 5, 10 x 10^n that keeps the number of intervals
           within the budget */
        function numericNiceInterval(span, axisLength, horizontal) {
            if (!(span > 0)) {
                return 1;
            }
            var budget = intervalBudget(axisLength, horizontal);
            var magnitude = Math.pow(10, Math.floor(Math.log(span / budget) / Math.LN10));
            var steps = [magnitude, 2 * magnitude, 5 * magnitude, 10 * magnitude];
            var pick = 0;
            while (pick < steps.length - 1 && span / steps[pick] > budget) {
                pick++;
            }
            return steps[pick];
        }

        /* a configured tick step, or null when it cannot be used: not a positive finite number, or so small
           that the ticks would be closer than minTickGapPx on an axis of axisLength pixels */
        function usableStep(step, span, axisLength) {
            if (!isFiniteNumber(step) || step <= 0) {
                return null;
            }
            return (span / step > axisLength / STYLE.minTickGapPx) ? null : step;
        }

        function isFiniteNumber(v) {
            return angular.isNumber(v) && isFinite(v);
        }

        /* a configured axis limit, or the fallback when it is not a finite number */
        function finiteOr(value, fallback) {
            return isFiniteNumber(value) ? value : fallback;
        }

        /* category axis: label every n-th category so the labels fit the budget */
        function categoryInterval(categoryGaps, axisLength) {
            return Math.max(1, Math.floor(categoryGaps / intervalBudget(axisLength, true)));
        }

        /* number -> label text without floating point noise */
        function formatNumber(v) {
            return String(parseFloat(Number(v).toFixed(10)));
        }

        /* number of decimal places needed to write the value exactly (max 10) */
        function decimalsOf(v) {
            var text = formatNumber(v);
            var dot = text.indexOf('.');
            return dot < 0 ? 0 : text.length - dot - 1;
        }

        function toNumberOrNull(v) {
            if (v === null || angular.isUndefined(v)) {
                return null;
            }
            var n = parseFloat(v);
            return isNaN(n) ? null : n;
        }

        function fontOf(font, defaults) {
            font = font || {};
            defaults = defaults || STYLE.defaultFont;
            return {
                size: font.size || defaults.size,
                fontFamily: font.fontFamily || defaults.fontFamily,
                fontWeight: font.fontWeight,
                color: font.color || defaults.color
            };
        }

        function createEl(tag, attrs) {
            var node = $document[0].createElementNS(SVG_NS, tag);
            setAttrs(node, attrs);
            return node;
        }

        function setAttrs(node, attrs) {
            if (attrs) {
                for (var key in attrs) {
                    if (attrs.hasOwnProperty(key) && angular.isDefined(attrs[key]) && attrs[key] !== null) {
                        node.setAttribute(key, attrs[key]);
                    }
                }
            }
            return node;
        }

        function textEl(text, attrs, font) {
            var node = createEl('text', attrs);
            node.setAttribute('fill', font.color);
            node.setAttribute('font-size', font.size);
            node.setAttribute('font-family', font.fontFamily);
            node.setAttribute('font-weight', font.fontWeight || 'normal');
            node.textContent = text;
            return node;
        }

        /* series.dash: [dash, gap] or 'dash,gap' */
        function seriesDash(s) {
            if (!s.dash) {
                return null;
            }
            var parts = String(s.dash).split(',').map(function (p) {
                return parseFloat(p);
            });
            // "1,0" means a solid line
            if (parts.length < 2 || parts[1] === 0) {
                return null;
            }
            return parts.join(',');
        }

        //************************************************************************************
        // drawing
        //************************************************************************************

        /* xAxis.shading: shaded x ranges, behind the series or (onTop) over them, clipped to the plot */
        function drawShading(svg, model, onTop) {
            var shades = (model.xAxis.shading || []).filter(function (shade) {
                return shade && !!shade.onTop === onTop;
            });
            if (!model.hasData || shades.length === 0) {
                return;
            }
            var g = createEl('g', {'class': 'ogr-chart-shading', 'clip-path': 'url(#' + model.clipId + ')'});
            for (var i = 0; i < shades.length; i++) {
                var shade = shades[i];
                var from = model.isCategory ? shade.from : parseFloat(shade.from);
                var to = model.isCategory ? shade.to : parseFloat(shade.to);
                if (!angular.isNumber(from) || !angular.isNumber(to) || from < 0 || to < 0) {
                    continue;
                }
                var x1 = xToPx(model, Math.min(from, to));
                var x2 = xToPx(model, Math.max(from, to));
                g.appendChild(createEl('rect', {
                    x: x1, y: model.plot.top, width: Math.max(x2 - x1, 0), height: model.plot.height,
                    fill: shade.color || '#aea', 'fill-opacity': angular.isDefined(shade.opacity) ? shade.opacity : 0.25,
                    stroke: 'none'
                }));
            }
            svg.appendChild(g);
        }

        /* X positions of the vertical grid lines / X ticks and Y positions of the horizontal grid lines / Y ticks:
           those of the axis ticks, or for a chart without points the bare axis steps or the plain grid */
        function gridLines(model) {
            var plot = model.plot;
            var i;
            var lines = {x: [], y: []};
            if (model.axesVisible) {
                lines.x = model.xTicks.map(function (tick) {
                    return crispUp(xToPx(model, tick.value));
                });
                lines.y = model.yTicks.map(function (tick) {
                    return crispDown(yToPx(model, tick.value));
                });
            } else if (model.bareAxes) {
                for (i = 0; i <= STYLE.emptyAxisSteps; i++) {
                    lines.x.push(crispUp(plot.left + i / STYLE.emptyAxisSteps * plot.width));
                }
            } else if (!model.hasData) {
                // columns: a line through the middle of each; rows: a line between each two
                var grid = STYLE.emptyGrid;
                for (i = 0; i < grid.columns; i++) {
                    lines.x.push(crispUp(plot.left + (i + 0.5) / grid.columns * plot.width));
                }
                for (i = 1; i < grid.rows; i++) {
                    lines.y.push(crispDown(plot.bottom - i / grid.rows * plot.height));
                }
            }
            return lines;
        }

        /* grid lines; none is drawn over the plot border */
        function drawGrid(svg, model) {
            var plot = model.plot;
            var lines = gridLines(model);
            var left = crispDown(plot.left), right = crispDown(plot.right);
            var top = crispDown(plot.top), bottom = crispDown(plot.bottom);
            var d;
            if (model.xAxis.grid !== false) {
                d = '';
                angular.forEach(lines.x, function (x) {
                    if (Math.abs(x - left) >= 1 && Math.abs(x - right) >= 1) {
                        d += 'M ' + x + ' ' + bottom + ' L ' + x + ' ' + top + ' ';
                    }
                });
                if (d) {
                    svg.appendChild(createEl('path', {
                        d: d, fill: 'none', stroke: STYLE.gridColor, 'stroke-width': 1, 'class': 'ogr-chart-xgrid'
                    }));
                }
            }
            if (model.yAxis.grid !== false) {
                d = '';
                angular.forEach(lines.y, function (y) {
                    if (Math.abs(y - top) >= 1 && Math.abs(y - bottom) >= 1) {
                        d += 'M ' + left + ' ' + y + ' L ' + right + ' ' + y + ' ';
                    }
                });
                if (d) {
                    svg.appendChild(createEl('path', {
                        d: d, fill: 'none', stroke: STYLE.gridColor, 'stroke-width': 1, 'class': 'ogr-chart-ygrid'
                    }));
                }
            }
        }

        function drawArea(svg, model) {
            var plot = model.plot;
            svg.appendChild(createEl('rect', {
                x: plot.left, y: plot.top, width: plot.width, height: plot.height,
                fill: 'transparent', stroke: STYLE.areaBorderColor, 'stroke-width': STYLE.areaBorderWidth,
                'class': 'ogr-chart-area'
            }));
        }

        /* title: centred over the plot, in the band above it */
        function drawTitle(svg, model) {
            if (!model.titleSize) {
                return;
            }
            svg.appendChild(textEl(model.titleText, {
                x: (model.plot.left + model.plot.right) / 2,
                y: STYLE.padding + model.titleSize.height / 2 + STYLE.titleBaselineShift,
                'text-anchor': 'middle', 'class': 'ogr-chart-title'
            }, model.titleFont));
        }

        /* clip path of the plot, used by the series, the shading and the tracker */
        function drawClip(svg, model) {
            var plot = model.plot;
            model.clipId = 'ogr-chart-clip-' + Math.random().toString(36).slice(2, 10);
            model.defs = createEl('defs');
            var clip = createEl('clipPath', {id: model.clipId});
            clip.appendChild(createEl('rect', {x: plot.left, y: plot.top, width: plot.width, height: plot.height}));
            model.defs.appendChild(clip);
            svg.appendChild(model.defs);
        }

        /* each series, followed by its markers (drawn opaque over the line); with animate every series also
           gets its own clip rectangle that drawIn widens from the left */
        function drawSeries(svg, model) {
            if (!model.hasData) {
                return;
            }
            var plot = model.plot;
            var g = createEl('g', {'clip-path': 'url(#' + model.clipId + ')', 'class': 'ogr-chart-series'});
            for (var i = 0; i < model.series.length; i++) {
                var s = model.series[i];
                if (s.points.length === 0 || s.axisOnly || s.hidden) {
                    continue;
                }
                var node = (s.kind === 'band') ? drawBand(model, s) : drawLine(model, s);
                if (!node) {
                    continue;
                }
                s.node = node;
                var holder = node;
                if (model.animate) {
                    var revealId = model.clipId + '-' + i;
                    var reveal = createEl('clipPath', {id: revealId});
                    s.revealRect = createEl('rect', {x: plot.left, y: plot.top, width: plot.width, height: plot.height});
                    reveal.appendChild(s.revealRect);
                    model.defs.appendChild(reveal);
                    holder = createEl('g', {'clip-path': 'url(#' + revealId + ')'});
                    holder.appendChild(node);
                }
                g.appendChild(holder);
                if (s.kind === 'line' && s.marker.show) {
                    s.markerNode = drawMarkers(s);
                    g.appendChild(s.markerNode);
                }
            }
            svg.appendChild(g);
        }

        function drawLine(model, s) {
            var g = createEl('g', {opacity: s.opacity, 'class': 'ogr-chart-line'});
            var d = '';
            var run = [];
            for (var j = 0; j < s.points.length; j++) {
                var p = s.points[j];
                if (p.y === null || isNaN(p.y)) {
                    d += linePath(run, s.spline);
                    run = []; // gap for empty points
                    continue;
                }
                p.px = pointX(model, p);
                p.py = yToPx(model, p.y);
                run.push(p);
            }
            d += linePath(run, s.spline);
            g.appendChild(createEl('path', {
                d: d.trim(), fill: 'none', stroke: s.color, 'stroke-width': s.lineWidth,
                'stroke-dasharray': seriesDash(s), 'stroke-linejoin': 'round'
            }));
            return g;
        }

        /* path through a run of points without gaps: straight segments or, with spline, the natural cubic
           spline written as one cubic Bezier segment per pair of points */
        function linePath(run, spline) {
            if (run.length === 0) {
                return '';
            }
            var m = spline ? splineCurvatures(run) : null;
            var d = ' M ' + run[0].px + ' ' + run[0].py;
            for (var i = 1; i < run.length; i++) {
                var p0 = run[i - 1], p1 = run[i];
                if (!m) {
                    d += ' L ' + p1.px + ' ' + p1.py;
                    continue;
                }
                var h = p1.px - p0.px;
                var slope = (p1.py - p0.py) / h;
                var slope0 = slope - h * (2 * m[i - 1] + m[i]) / 6; // spline slope leaving p0
                var slope1 = slope + h * (m[i - 1] + 2 * m[i]) / 6; // spline slope arriving at p1
                d += ' C ' + (p0.px + h / 3) + ' ' + (p0.py + h * slope0 / 3) +
                    ' ' + (p1.px - h / 3) + ' ' + (p1.py - h * slope1 / 3) +
                    ' ' + p1.px + ' ' + p1.py;
            }
            return d;
        }

        /* second derivatives of the natural cubic spline through the points (zero at both ends), from the
           tridiagonal system of the inner points; null (straight segments) for fewer than three points or
           x positions that do not strictly increase */
        function splineCurvatures(run) {
            var n = run.length;
            if (n < 3) {
                return null;
            }
            var i;
            var h = [];
            for (i = 0; i < n - 1; i++) {
                h[i] = run[i + 1].px - run[i].px;
                if (!(h[i] > 0)) {
                    return null;
                }
            }
            var diag = [], rhs = [];
            for (i = 1; i < n - 1; i++) {
                var b = 2 * (h[i - 1] + h[i]);
                var r = 6 * ((run[i + 1].py - run[i].py) / h[i] - (run[i].py - run[i - 1].py) / h[i - 1]);
                if (i > 1) {
                    var w = h[i - 1] / diag[i - 1];
                    b -= w * h[i - 1];
                    r -= w * rhs[i - 1];
                }
                diag[i] = b;
                rhs[i] = r;
            }
            var m = [];
            m[0] = 0;
            m[n - 1] = 0;
            for (i = n - 2; i >= 1; i--) {
                m[i] = (rhs[i] - h[i] * m[i + 1]) / diag[i];
            }
            return m;
        }

        /* a dot of the series colour on every point with a value */
        function drawMarkers(s) {
            var g = createEl('g', {'class': 'ogr-chart-markers'});
            var r = (s.marker.size || 2) / Math.SQRT2;
            angular.forEach(s.points, function (p) {
                if (p.y !== null && !isNaN(p.y)) {
                    g.appendChild(createEl('circle', {cx: p.px, cy: p.py, r: r, fill: s.color}));
                }
            });
            return g;
        }

        /* band: area between the upper and the lower edge */
        function drawBand(model, s) {
            var upper = [], lower = [];
            for (var j = 0; j < s.points.length; j++) {
                var p = s.points[j];
                if (p.upper === null || p.lower === null || isNaN(p.upper) || isNaN(p.lower)) {
                    continue;
                }
                var x = pointX(model, p);
                p.px = x;
                p.py = yToPx(model, (p.upper + p.lower) / 2);
                upper.push(x + ' ' + yToPx(model, p.upper));
                lower.push(x + ' ' + yToPx(model, p.lower));
            }
            if (upper.length === 0) {
                return null;
            }
            var d = 'M ' + upper[0];
            for (var i = 1; i < upper.length; i++) {
                d += ' L ' + upper[i];
            }
            for (i = lower.length - 1; i >= 0; i--) {
                d += ' L ' + lower[i];
            }
            d += ' Z';
            var g = createEl('g', {opacity: s.opacity, 'class': 'ogr-chart-band'});
            g.appendChild(createEl('path', {
                d: d, fill: s.color, stroke: s.edgeColor || 'transparent', 'stroke-width': 1
            }));
            return g;
        }

        /* axis lines, ticks and labels; a chart whose series have no points keeps its axis lines and X ticks */
        function drawAxes(svg, model) {
            if (!model.axesVisible && !model.bareAxes) {
                return;
            }
            var plot = model.plot;
            var lines = gridLines(model);
            var left = crispDown(plot.left), right = crispDown(plot.right);
            var top = crispDown(plot.top), bottom = crispDown(plot.bottom);
            var i;

            // X axis labels, line and ticks
            var gx = createEl('g', {'class': 'ogr-chart-xaxis'});
            if (model.axesVisible) {
                angular.forEach(model.xTicks, function (tick) {
                    if (!tick.hidden && tick.text !== '') {
                        gx.appendChild(textEl(tick.text, {
                            x: tick.label.x, y: tick.label.y, 'text-anchor': tick.label.anchor
                        }, model.xFont));
                    }
                });
            }
            gx.appendChild(createEl('line', {
                x1: left, x2: right, y1: bottom, y2: bottom, stroke: STYLE.axisColor, 'stroke-width': 1
            }));
            var ticksD = '';
            angular.forEach(lines.x, function (x) {
                ticksD += 'M ' + x + ' ' + (bottom + STYLE.xTickSize) + ' L ' + x + ' ' + bottom + ' ';
            });
            gx.appendChild(createEl('path', {d: ticksD, fill: 'none', stroke: STYLE.axisColor, 'stroke-width': 1}));
            svg.appendChild(gx);

            // Y axis labels, line, ticks and title
            var gy = createEl('g', {'class': 'ogr-chart-yaxis'});
            ticksD = '';
            for (i = 0; i < model.yTicks.length; i++) {
                var tick = model.yTicks[i];
                ticksD += 'M ' + (left - STYLE.yTickSize) + ' ' + lines.y[i] + ' L ' + left + ' ' + lines.y[i] + ' ';
                // the label's middle at the value: baseline a quarter of the text height below it
                gy.appendChild(textEl(tick.text, {
                    x: plot.left - 10.5, y: yToPx(model, tick.value) + measureDom(tick.text, model.yFont).height / 4,
                    'text-anchor': 'end'
                }, model.yFont));
            }
            gy.appendChild(createEl('line', {
                x1: left, x2: left, y1: top, y2: bottom, stroke: STYLE.axisColor, 'stroke-width': 1
            }));
            gy.appendChild(createEl('path', {d: ticksD, fill: 'none', stroke: STYLE.axisColor, 'stroke-width': 1}));
            if (model.yTitleVisible) {
                var tx = STYLE.padding + 7;
                var ty = plot.top + plot.height / 2;
                gy.appendChild(textEl(model.yAxis.title.text, {
                    x: tx, y: ty, 'text-anchor': 'middle', 'dominant-baseline': 'middle',
                    transform: 'rotate(-90,' + tx + ',' + ty + ')'
                }, fontOf(model.yAxis.title.font || model.yAxis.font)));
            }
            svg.appendChild(gy);
        }

        //************************************************************************************
        // animate: every line is revealed from the left over drawInMs (eased in and out) while its markers
        // grow to full size one after another, spread evenly over the same time
        //************************************************************************************

        function drawIn(model) {
            var start = Date.now();
            var end = STYLE.drawInMs;
            var items = [];
            angular.forEach(model.series, function (s) {
                if (!s.revealRect) {
                    return;
                }
                s.revealRect.setAttribute('width', 0);
                var markers = [];
                var dots = s.markerNode ? s.markerNode.childNodes : [];
                for (var i = 0; i < dots.length; i++) {
                    var delay = Math.floor(i * STYLE.drawInMs / dots.length);
                    markers.push({node: dots[i], delay: delay, x: dots[i].getAttribute('cx'), y: dots[i].getAttribute('cy')});
                    dots[i].setAttribute('transform', 'scale(0)');
                    end = Math.max(end, delay + STYLE.markerPopMs);
                }
                items.push({rect: s.revealRect, markers: markers});
            });
            var frame = requestFrame(step);
            return function stop() {
                cancelFrame(frame);
                frame = null;
            };

            function step() {
                var t = Date.now() - start;
                angular.forEach(items, function (item) {
                    item.rect.setAttribute('width', model.plot.width * easeInOut(Math.min(1, t / STYLE.drawInMs)));
                    angular.forEach(item.markers, function (m) {
                        if (t >= m.delay && !m.done) {
                            var grown = Math.min(1, (t - m.delay) / STYLE.markerPopMs);
                            m.node.setAttribute('transform', 'translate(' + m.x + ' ' + m.y + ') scale(' +
                                easeInOut(grown) + ') translate(' + -m.x + ' ' + -m.y + ')');
                            m.done = grown >= 1;
                        }
                    });
                });
                frame = t < end ? requestFrame(step) : null;
            }
        }

        /* 0 -> 1, slow at both ends (half a cosine wave) */
        function easeInOut(p) {
            return (1 - Math.cos(p * Math.PI)) / 2;
        }

        /* legend layout, below the plot: every item takes a slot of symbol + gap + name + item padding; slots
           are filled into rows no wider than the chart minus a side margin, and the widest row is centred */
        function layoutLegend(model) {
            var items = model.series.filter(function (s) {
                return s.points.length > 0;
            });
            if (items.length === 0) {
                return null;
            }
            var pad = STYLE.legendItemPadding;
            var maxRowWidth = model.width - 2 * STYLE.legendSideMargin;
            var rows = [];
            var row = null;
            var itemHeight = STYLE.legendItemSize;
            angular.forEach(items, function (series) {
                var size = measureDom(series.label, model.legendFont);
                var slot = STYLE.legendItemSize + STYLE.legendElementSpacing + size.width + pad;
                itemHeight = Math.max(itemHeight, size.height);
                if (!row || (row.items.length > 0 && row.width + slot > maxRowWidth)) {
                    row = {items: [], width: 0};
                    rows.push(row);
                }
                row.items.push({series: series, width: slot - pad, textHeight: size.height});
                row.width += slot;
            });
            var widest = Math.max.apply(null, rows.map(function (r) {
                return r.width;
            }));
            return {
                rows: rows,
                itemHeight: itemHeight,
                // the widest row (without its trailing padding) centred, nudged right by half a padding
                left: (model.width - (widest - pad)) / 2 + pad / 2,
                height: rows.length * itemHeight + (rows.length - 1) * pad + 2 * STYLE.legendElementSpacing
            };
        }

        /* legend items: a line series is shown as a small ring on a short line, a band as a filled square,
           followed by the series label */
        function drawLegend(svg, model) {
            var box = model.legendBox;
            if (!model.legendVisible || !box) {
                return;
            }
            var size = STYLE.legendItemSize;
            var space = STYLE.legendElementSpacing;
            var boxTop = model.height - STYLE.legendBottomGap - box.height;
            var g = createEl('g', {'class': 'ogr-chart-legend'});
            model.legendItems = [];
            for (var r = 0; r < box.rows.length; r++) {
                var row = box.rows[r];
                var itemX = box.left;
                var itemY = boxTop + space + r * (box.itemHeight + STYLE.legendItemPadding);
                for (var i = 0; i < row.items.length; i++) {
                    var entry = row.items[i];
                    var s = entry.series;
                    var color = s.hidden ? 'gray' : s.color;
                    var startX = itemX + size / 2;
                    var startY = itemY + Math.max(entry.textHeight, size) / 2;
                    var item = createEl('g', {'class': 'ogr-chart-legend-item', cursor: 'pointer'});
                    if (s.kind === 'band') {
                        item.appendChild(createEl('rect', {
                            x: startX - size / 2, y: startY - size / 2, width: size, height: size,
                            fill: color, stroke: 'transparent'
                        }));
                    } else {
                        item.appendChild(lineSymbol(startX, startY + 1, color, s.marker.show));
                    }
                    var textFont = s.hidden ? angular.extend({}, model.legendFont, {color: 'gray'}) : model.legendFont;
                    item.appendChild(textEl(s.label, {
                        x: itemX + size + space, y: startY + entry.textHeight / 4, 'text-anchor': 'start'
                    }, textFont));
                    g.appendChild(item);
                    model.legendItems.push({node: item, series: s});
                    itemX += entry.width + STYLE.legendItemPadding;
                }
            }
            svg.appendChild(g);
        }

        /* ring centred at (cx, cy) with a line stub on its left and right; without markers just the line */
        function lineSymbol(cx, cy, color, withMarker) {
            var ring = STYLE.legendSymbolRing;
            var reach = STYLE.legendSymbolReach;
            var stroke = {stroke: color, 'stroke-width': STYLE.legendSymbolStroke};
            var symbol = createEl('g', {'class': 'ogr-chart-legend-symbol'});
            if (!withMarker) {
                symbol.appendChild(createEl('line', angular.extend({x1: cx - reach, y1: cy, x2: cx + reach, y2: cy}, stroke)));
                return symbol;
            }
            symbol.appendChild(createEl('line', angular.extend({x1: cx - reach, y1: cy, x2: cx - ring, y2: cy}, stroke)));
            symbol.appendChild(createEl('line', angular.extend({x1: cx + ring, y1: cy, x2: cx + reach, y2: cy}, stroke)));
            symbol.appendChild(createEl('circle', angular.extend({cx: cx, cy: cy, r: ring, fill: 'transparent'}, stroke)));
            return symbol;
        }

        /* placeholder: a text (e.g. "Empty") centred over the plot area, shown in place of a chart */
        function drawPlaceholder(el, model) {
            var message = model.placeholder;
            if (!message.show) {
                return null;
            }
            var overlay = $document[0].createElement('div');
            overlay.className = 'ogr-chart-placeholder';
            overlay.style.position = 'absolute';
            overlay.style.pointerEvents = 'none';
            var svgLeft = Math.max(0, (el.clientWidth - model.width) / 2);
            overlay.style.left = (svgLeft + model.plot.left) + 'px';
            overlay.style.top = model.plot.top + 'px';
            overlay.style.width = model.plot.width + 'px';
            overlay.style.height = model.plot.height + 'px';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';
            var node = $document[0].createElement('div');
            node.textContent = String(message.text || '');
            node.style.fontSize = message.fontSize || '';
            node.style.opacity = angular.isDefined(message.opacity) ? message.opacity : 1;
            overlay.appendChild(node);
            el.appendChild(overlay);
            return overlay;
        }

        //************************************************************************************
        // tracker: vertical guide line under the pointer, a marker on every series and one tooltip per series,
        // stacked so they do not overlap
        //************************************************************************************

        function bindTracker(el, svg, model) {
            var plot = model.plot;
            var group = createEl('g', {'class': 'ogr-chart-hover', 'pointer-events': 'none'});
            svg.appendChild(group);
            var hovered = null;
            var tracks = model.series.map(buildTrack);
            var pending = null;   // latest mouse event, processed once per animation frame
            var frame = null;
            var shownKey = null;  // points currently shown; the drawing only depends on them

            svg.addEventListener('mousemove', onMove);
            svg.addEventListener('mouseleave', onLeave);
            return stop;

            function stop() {
                cancelFrame(frame);
                frame = null;
                pending = null;
            }

            function onLeave() {
                stop();
                clear(group);
                shownKey = null;
                setHovered(null);
            }

            function onMove(evt) {
                pending = {clientX: evt.clientX, target: evt.target};
                if (frame === null) {
                    frame = requestFrame(processMove);
                }
            }

            function processMove() {
                frame = null;
                var evt = pending;
                pending = null;
                if (!evt) {
                    return;
                }
                var rect = svg.getBoundingClientRect();
                var mx = evt.clientX - rect.left;
                setHovered(seriesOfNode(evt.target));
                // track while the pointer is horizontally inside the x axis
                if (!(mx > plot.left && mx < plot.right)) {
                    clear(group);
                    shownKey = null;
                    return;
                }
                showTracker(mx);
            }

            /* seriesStyle.hoverOpacity: the series under the pointer is redrawn with that opacity */
            function seriesOfNode(node) {
                while (node && node !== svg) {
                    for (var i = 0; i < model.series.length; i++) {
                        if (model.series[i].node === node) {
                            return model.series[i];
                        }
                    }
                    node = node.parentNode;
                }
                return null;
            }

            function setHovered(series) {
                if (!angular.isNumber(model.hoverOpacity)) {
                    return;
                }
                if (hovered === series) {
                    return;
                }
                if (hovered && hovered.node) {
                    hovered.node.setAttribute('opacity', hovered.opacity);
                }
                hovered = series;
                if (hovered && hovered.node) {
                    hovered.node.setAttribute('opacity', model.hoverOpacity);
                }
            }

            function showTracker(mx) {
                // pixel -> axis value
                var xValue = model.xMin + (mx - plot.left) / plot.width * (model.xMax - model.xMin);
                var hits = [];
                var key = '';
                var i;
                // one x for the whole chart: the tracked point nearest to the pointer over all series
                // (on a tie the earlier series wins)
                var target = null;
                for (i = 0; i < tracks.length; i++) {
                    var near = closestPointX(tracks[i], xValue);
                    if (near && (target === null || Math.abs(near.xValue - xValue) < Math.abs(target - xValue))) {
                        target = near.xValue;
                    }
                }
                // only series with a point at exactly that x take part; the x must be inside the x range and
                // the value not below the y axis minimum
                if (target !== null && target >= model.xMin && target <= model.xMax) {
                    for (i = 0; i < model.series.length; i++) {
                        var index = pointIndexAt(tracks[i], target);
                        if (index === null) {
                            continue;
                        }
                        var series = model.series[i];
                        var point = series.points[index];
                        var yValue = (series.kind === 'band') ? point.upper : point.y;
                        if (yValue < model.yMin) {
                            continue;
                        }
                        hits.push({series: series, index: index, xValue: target, yValue: yValue});
                        key += i + ':' + index + ',';
                    }
                }
                if (key === shownKey) {
                    return; // same points as the last frame: identical drawing, nothing to redo
                }
                shownKey = key;
                clear(group);

                var tips = [];
                var widestBox = 0;
                var trackerX = null;
                var pad = TRACKER.textMargin;
                for (i = 0; i < hits.length; i++) {
                    var h = hits[i];
                    var text = tooltipText(model, h.series, h.index, defaultTooltipText(h.series, h.index));
                    var font = tooltipFont(h.series);
                    var textSize = measureDom(text, font);
                    var tip = {
                        x: xToPx(model, h.xValue),
                        anchor: yToPx(model, h.yValue),
                        series: h.series,
                        text: text,
                        font: font,
                        textHeight: textSize.height,
                        width: textSize.width + 2 * pad,
                        height: textSize.height + 2 * pad
                    };
                    tips.push(tip);
                    trackerX = tip.x;
                    widestBox = Math.max(widestBox, tip.width);
                }
                if (tips.length === 0) {
                    return;
                }

                // tracker line at the shared x, clipped to the plot
                group.appendChild(createEl('path', {
                    d: 'M ' + trackerX + ' ' + plot.top + ' L ' + trackerX + ' ' + plot.bottom,
                    fill: 'none', stroke: TRACKER.guideColor, 'stroke-width': TRACKER.guideWidth,
                    'clip-path': 'url(#' + model.clipId + ')', 'class': 'ogr-chart-tracker'
                }));
                // a marker on every tracked point
                var symbols = createEl('g', {'clip-path': 'url(#' + model.clipId + ')', 'class': 'ogr-chart-tracker-markers'});
                var radius = TRACKER.markerSize / Math.SQRT2;
                for (i = 0; i < tips.length; i++) {
                    symbols.appendChild(createEl('circle', {
                        cx: tips[i].x, cy: tips[i].anchor, r: radius,
                        fill: TRACKER.markerFill, 'stroke-width': TRACKER.markerRingWidth,
                        stroke: tips[i].series.color, opacity: 1
                    }));
                }
                group.appendChild(symbols);

                tips.sort(function (a, b) {
                    return a.anchor - b.anchor;
                });
                stackTooltips(tips);
                // a box goes right of its point while that side still has room for sideRoom times the widest box
                for (i = 0; i < tips.length; i++) {
                    var fitsRight = tips[i].x + TRACKER.pointGap + TRACKER.sideRoom * widestBox <= plot.right;
                    drawTooltip(tips[i], fitsRight ? 'right' : 'left');
                }
            }

            /* per series lookup table, built once per render: distinct x values in ascending order,
               each with the first point index that has it. Hidden / axis-only series are not tracked, and
               neither are points without a value (gaps) */
            function buildTrack(series) {
                if (series.axisOnly || series.hidden || series.points.length === 0) {
                    return null;
                }
                var rows = [];
                for (var j = 0; j < series.points.length; j++) {
                    var p = series.points[j];
                    var x = model.isCategory ? p.xIndex : parseFloat(p.x);
                    if (isNaN(x)) {
                        return null; // a series with a non-numeric x value is never tracked
                    }
                    var hasValue = (series.kind === 'band')
                        ? isFiniteNumber(p.upper) && isFiniteNumber(p.lower)
                        : isFiniteNumber(p.y);
                    if (hasValue) {
                        rows.push({x: x, index: j});
                    }
                }
                if (rows.length === 0) {
                    return null;
                }
                rows.sort(function (a, b) {
                    return a.x - b.x || a.index - b.index;
                });
                var xs = [], firstIndex = [];
                for (j = 0; j < rows.length; j++) {
                    if (j === 0 || rows[j].x !== rows[j - 1].x) {
                        xs.push(rows[j].x);
                        firstIndex.push(rows[j].index);
                    }
                }
                return {xs: xs, firstIndex: firstIndex};
            }

            /* the series point whose x value is nearest to the pointer, only while the pointer is within half a
               unit of the series' own x extent; on a tie the value that occurs earlier in the series wins */
            function closestPointX(track, xValue) {
                if (!track) {
                    return null;
                }
                var xs = track.xs;
                if (!(xValue >= xs[0] - 0.5 && xValue <= xs[xs.length - 1] + 0.5)) {
                    return null;
                }
                var lo = 0, hi = xs.length;
                while (lo < hi) {
                    var mid = (lo + hi) >> 1;
                    if (xs[mid] < xValue) {
                        lo = mid + 1;
                    } else {
                        hi = mid;
                    }
                }
                var best = -1;
                for (var c = lo - 1; c <= lo; c++) {
                    if (c < 0 || c >= xs.length) {
                        continue;
                    }
                    if (best < 0) {
                        best = c;
                        continue;
                    }
                    var dc = Math.abs(xs[c] - xValue), db = Math.abs(xs[best] - xValue);
                    if (dc < db || (dc === db && track.firstIndex[c] < track.firstIndex[best])) {
                        best = c;
                    }
                }
                return {index: track.firstIndex[best], xValue: xs[best]};
            }

            /* index of the series point at exactly this x value, or null when the series has none */
            function pointIndexAt(track, x) {
                if (!track) {
                    return null;
                }
                var lo = 0, hi = track.xs.length - 1;
                while (lo <= hi) {
                    var mid = (lo + hi) >> 1;
                    if (track.xs[mid] === x) {
                        return track.firstIndex[mid];
                    }
                    if (track.xs[mid] < x) {
                        lo = mid + 1;
                    } else {
                        hi = mid - 1;
                    }
                }
                return null;
            }

            /* default tooltip text: "x : y" for lines, "x <br/> High : upper <br/> Low : lower" for bands;
               x is the axis label of the point (category text or the raw number), the values are raw */
            function defaultTooltipText(series, index) {
                var point = series.points[index];
                var x = model.isCategory ? model.categories[point.xIndex] : point.x;
                if (series.kind === 'band') {
                    return x + ' <br/> High : ' + point.upper + ' <br/> Low : ' + point.lower;
                }
                return x + ' : ' + point.y;
            }

            /* tooltip font: defaults overridden by series.tooltipFont */
            function tooltipFont(series) {
                var f = series.tooltipFont;
                return {
                    size: f.size || TRACKER.font.size,
                    fontFamily: f.fontFamily || TRACKER.font.fontFamily,
                    fontStyle: f.fontStyle || TRACKER.font.fontStyle,
                    fontWeight: f.fontWeight || TRACKER.font.fontWeight,
                    color: f.color || TRACKER.textColor
                };
            }

            /* spec.tooltipText(point, defaultText) may replace the default text; it gets the point as given in
               the spec ({x, y, text} or {x, upper, lower, text}) */
            function tooltipText(chartModel, series, index, defaultText) {
                if (!angular.isFunction(chartModel.tooltipText)) {
                    return defaultText;
                }
                var p = series.points[index];
                var point = (series.kind === 'band')
                    ? {x: p.x, upper: p.upper, lower: p.lower, text: p.text}
                    : {x: p.x, y: p.y, text: p.text};
                var text = chartModel.tooltipText(point, defaultText);
                return (text === null || angular.isUndefined(text)) ? defaultText : String(text);
            }

            /* stacking (tips sorted by their point's y): every box starts centred on its point. Boxes that
               would touch form a column - boxes one spacing apart, centred halfway between the column's first
               and last point - and a column that then reaches the one above absorbs it. If the whole stack fits
               into the plot it is pushed inside: first off the bottom edge, then off the top edge; otherwise it
               is laid out from the plot top down. */
            function stackTooltips(tips) {
                var gap = TRACKER.stackGap;
                var columns = [];
                angular.forEach(tips, function (tip) {
                    var column = centred({tips: [tip], from: tip.anchor, to: tip.anchor, height: tip.height});
                    var above = columns[columns.length - 1];
                    while (above && above.top + above.height + gap > column.top) {
                        columns.pop();
                        column = centred({
                            tips: above.tips.concat(column.tips),
                            from: above.from,
                            to: column.to,
                            height: above.height + gap + column.height
                        });
                        above = columns[columns.length - 1];
                    }
                    columns.push(column);
                });
                angular.forEach(columns, function (column) {
                    var y = column.top;
                    angular.forEach(column.tips, function (tip) {
                        tip.top = y;
                        y += tip.height + gap;
                    });
                });

                var needed = gap * (tips.length - 1);
                angular.forEach(tips, function (tip) {
                    needed += tip.height;
                });
                var i;
                var limit;
                if (needed > plot.height - TRACKER.clearanceTop - TRACKER.clearanceBottom) {
                    // too many to fit: the stack starts at the plot top, the boxes running past the bottom
                    // are left out when drawing
                    limit = plot.top + TRACKER.clearanceTop;
                    for (i = 0; i < tips.length; i++) {
                        tips[i].top = limit;
                        limit += tips[i].height + gap;
                    }
                    return;
                }
                limit = plot.bottom - TRACKER.clearanceBottom;
                for (i = tips.length - 1; i >= 0; i--) {
                    tips[i].top = Math.min(tips[i].top, limit - tips[i].height);
                    limit = tips[i].top - gap;
                }
                limit = plot.top + TRACKER.clearanceTop;
                for (i = 0; i < tips.length; i++) {
                    tips[i].top = Math.max(tips[i].top, limit);
                    limit = tips[i].top + tips[i].height + gap;
                }
            }

            function centred(column) {
                column.top = (column.from + column.to - column.height) / 2;
                return column;
            }

            /* one tooltip: a box beside its point with an arrow pointing at it, in the series colour; left out
               when the box or the point is outside the plot */
            function drawTooltip(tip, side) {
                var inside = function (x, y) {
                    return x >= plot.left && x <= plot.right && y >= plot.top && y <= plot.bottom;
                };
                if (!inside(tip.x, tip.anchor) || tip.top < plot.top || tip.top + tip.height > plot.bottom) {
                    return;
                }
                var box = {
                    x: side === 'right' ? tip.x + TRACKER.pointGap : tip.x - TRACKER.pointGap - tip.width,
                    y: tip.top,
                    width: tip.width,
                    height: tip.height
                };
                var node = createEl('g', {'class': 'ogr-chart-tooltip'});
                node.appendChild(createEl('path', {
                    d: calloutPath(box, side === 'right' ? 'left' : 'right', tip.anchor),
                    fill: tip.series.color, stroke: 'transparent', 'stroke-width': 0,
                    'fill-opacity': TRACKER.boxOpacity
                }));

                // lines share the measured text height; each baseline sits so the text looks centred in its line
                var lines = tip.text.split('<br/>');
                var lineHeight = tip.textHeight / lines.length;
                var textX = box.x + TRACKER.textMargin;
                var baseline = box.y + TRACKER.textMargin + lineHeight / 2 + (parseFloat(tip.font.size) || 12) / 3;
                var label = createEl('text', {
                    x: textX, y: baseline, fill: tip.font.color, 'font-size': tip.font.size,
                    'font-family': tip.font.fontFamily, 'font-style': tip.font.fontStyle,
                    'font-weight': tip.font.fontWeight, 'text-anchor': 'start'
                });
                if (lines.length === 1) {
                    label.textContent = tip.text;
                } else {
                    angular.forEach(lines, function (line, k) {
                        var span = createEl('tspan', {x: textX, dy: k === 0 ? 0 : lineHeight});
                        span.textContent = line;
                        label.appendChild(span);
                    });
                }
                node.appendChild(label);
                group.appendChild(node);
            }
        }

        /* outline of a tooltip box: rounded corners (circular arcs) and an arrow on arrowSide whose base is
           centred on that side and whose tip is at the point's height (the box may be shifted by stacking, the
           tip never is). Drawn clockwise from the top left corner. */
        function calloutPath(box, arrowSide, tipY) {
            var r = TRACKER.boxRadius;
            var arrow = TRACKER.arrowSize;
            var left = box.x, right = box.x + box.width;
            var top = box.y, bottom = box.y + box.height;
            var middle = top + box.height / 2;
            var arc = function (x, y) {
                return ['A', r, r, 0, 0, 1, x, y];
            };
            var d = ['M', left + r, top, 'H', right - r].concat(arc(right, top + r));
            if (arrowSide === 'right') {
                d.push('V', middle - arrow / 2, 'L', right + arrow, tipY, 'L', right, middle + arrow / 2);
            }
            d.push('V', bottom - r);
            d = d.concat(arc(right - r, bottom), ['H', left + r], arc(left, bottom - r));
            if (arrowSide === 'left') {
                d.push('V', middle + arrow / 2, 'L', left - arrow, tipY, 'L', left, middle - arrow / 2);
            }
            d.push('V', top + r);
            d = d.concat(arc(left + r, top), ['Z']);
            return d.join(' ');
        }

        /* size of the text as laid out by the browser in a hidden element (integer offsetWidth/offsetHeight);
           used for every label, legend and tooltip measurement */
        function measureDom(text, font) {
            var cacheKey = font.size + '|' + font.fontFamily + '|' + font.fontStyle + '|' + font.fontWeight + '|' + text;
            if (measureCache.hasOwnProperty(cacheKey)) {
                return measureCache[cacheKey];
            }
            if (!measureNode) {
                measureNode = $document[0].createElement('text');
                measureNode.id = 'ogrChartMeasureText';
                measureNode.style.position = 'absolute';
                measureNode.style.top = '-100px';
                measureNode.style.left = '0';
                measureNode.style.visibility = 'hidden';
                measureNode.style.whiteSpace = 'nowrap';
                measureNode.style.backgroundColor = 'white';
                $document[0].body.appendChild(measureNode);
            }
            measureNode.style.display = 'block';
            // the text is never parsed as markup: "<br/>" separators become real line breaks,
            // everything else is plain text
            while (measureNode.firstChild) {
                measureNode.removeChild(measureNode.firstChild);
            }
            var lines = String(text).split('<br/>');
            for (var i = 0; i < lines.length; i++) {
                if (i > 0) {
                    measureNode.appendChild($document[0].createElement('br'));
                }
                measureNode.appendChild($document[0].createTextNode(lines[i]));
            }
            // reset first: an invalid or missing value would otherwise keep the previous measurement's setting
            measureNode.style.fontStyle = '';
            measureNode.style.fontWeight = '';
            measureNode.style.fontSize = font.size;
            measureNode.style.fontStyle = font.fontStyle || '';
            measureNode.style.fontFamily = font.fontFamily;
            measureNode.style.fontWeight = font.fontWeight || '';
            var size = {width: measureNode.offsetWidth, height: measureNode.offsetHeight};
            measureNode.style.display = 'none';
            if (measureCacheSize >= 5000) {
                measureCache = {};
                measureCacheSize = 0;
            }
            measureCache[cacheKey] = size;
            measureCacheSize++;
            return size;
        }

        function requestFrame(fn) {
            return $window.requestAnimationFrame ? $window.requestAnimationFrame(fn) : $window.setTimeout(fn, 16);
        }

        function cancelFrame(id) {
            if (id === null) {
                return;
            }
            if ($window.cancelAnimationFrame) {
                $window.cancelAnimationFrame(id);
            } else {
                $window.clearTimeout(id);
            }
        }

        function clear(node) {
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .directive('timeseriesChart', timeseriesChart);

    timeseriesChart.$inject = ['$window', 'chartConfig', 'TimeseriesUtils', 'DateUtils', 'OgrChart'];

    function timeseriesChart($window, chartConfig, TimeseriesUtils, DateUtils, OgrChart) {
        // Generates chart for one or more timeseries
        // Usage:
        //  <div data-timeseries-chart chart-data="vm.chartData">
        //  <div data-timeseries-chart chart-data="vm.chartData" line-style="vm.lineStyle">
        //  <div data-timeseries-chart chart-data="vm.chartData" date-format="vm.dateFormat" date-frequency="vm.dateFreq">
        //  <div data-timeseries-chart chart-data="vm.chartData" shadow-range="vm.shadowRange">
        //  <div data-timeseries-chart chart-data="vm.chartData" min-date="vm.minimumDate">
        //  <div data-timeseries-chart chart-data="vm.chartData" max-date="vm.maximumDate">
        //  <div data-timeseries-chart chart-data="vm.chartData" y-label="vm.country.currency.code + ' per USD'">
        // Input structure:
        //  vm.chartData = {
        //      chartId: "someId",
        //      title: "some title",
        //      lineSeries: [
        //          [
        //              {date: Date, value: Double},
        //              ...
        //          ],
        //          ...
        //      ]
        //  }
        //  vm.lineStyle = [
        //      {
        //          width: 2,
        //          color: '#3734FF',
        //          dashSetting: [<dashWidth>,<emptySpaceWidth>],
        //          markerSize: 2,
        //      },
        //      ...
        //  ]
        //  vm.shadowRange = [
        //      {
        //          start: Date,
        //          end: Date,
        //          color: '#373737',
        //          opacity: 0.5
        //      },
        //      ...
        //  ]
        // Creates:
        //  <div data-dd-timeseries-chart class="timeseriesChart">
        var directive = {
            link: linkFunc,
            restrict: 'A',
            scope: {
                chartData: '<',
                lineStyle: '<',
                lineWidth: '<',
                dateFormat: '<',
                dateFrequency: '<',
                shadowRange: '<',
                minDate: '<',
                maxDate: '<',
                yLabel: '<'
            }
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.addClass('timeseriesChart');
            element.attr('id', scope.chartData.chartId);

            makeChart();

            scope.$watch('chartData', updateChart, true);
            scope.$watch('lineStyle', updateChart, true);
            scope.$watch('lineWidth', updateChart, true);
            scope.$watch('dateFormat', updateChart, true);
            scope.$watch('dateFrequency', updateChart, true);
            scope.$watch('shadowRange', updateChart, true);
            scope.$watch('minDate', updateChart, true);
            scope.$watch('maxDate', updateChart, true);
            scope.$watch('yLabel', updateChart, true);
            scope.$watch(parentWidth,
                function (newVal, oldVal) {
                    // update chart after all the other stuff listening to
                    // the change of width of the parent div is done, 1 sec is enough
                    setTimeout(function () {
                        updateChart(newVal, oldVal);
                    }, 1000);
                },
                true);
            //some responsiveness here: when window was resized - recalculate
            // height of the chart based on the parent height
            var win = angular.element($window);
            win.bind("resize", updateChart);
            element.on('$destroy', function () {
                win.unbind("resize", updateChart);
            });

            function parentWidth() {
                return {
                    width: element.parent().width()
                };
            }

            function updateChart(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                //unbind this function before removing the chart
                win.unbind("resize", updateChart);
                OgrChart.destroy(element);
                element.empty();
                makeChart();
                win.bind("resize", updateChart);
            }

            function makeChart() {
                // console.log('here!');
                //load defaults
                var chartObject = angular.copy(chartConfig.timeseriesChartDefaults.chartObject);
                var defaultLineStyles = angular.copy(chartConfig.timeseriesChartDefaults.lineStyles);
                var defaultDateFormat = angular.copy(chartConfig.timeseriesChartDefaults.dateFormat);
                var defaultFrequency = angular.copy(chartConfig.timeseriesChartDefaults.frequency);
                var defaultShadowStyle = angular.copy(chartConfig.timeseriesChartDefaults.shadowStyle);

                //get chart title from chartData
                // chartObject.title.text = angular.copy(scope.chartData.title);

                //get the label for Y-axis
                var yLabel = angular.copy(scope.yLabel);
                if (!yLabel)
                    yLabel = "";

                //get lines' series from chartData
                var lineData = angular.copy(scope.chartData.lineSeries);

                // confidence bands data
                var bandWidthData = angular.copy(scope.chartData.lineBands);

                //try getting lines' styles from lineStyle
                var lineStyles = angular.copy(scope.lineStyle);

                //try getting lines' styles from lineStyle
                var lineWidths = angular.copy(scope.lineWidth);

                //get lines' legends from chartData
                var lineLegends = angular.copy(scope.chartData.lineLegends);

                //try getting tick labels' date format from dateFormat
                var dateFormat = angular.copy(scope.dateFormat);
                if (!dateFormat)
                    dateFormat = defaultDateFormat;

                //try getting tick labels' date frequency from dateFrequency
                var dateFrequency = angular.copy(scope.dateFrequency);
                if (!dateFrequency)
                    dateFrequency = defaultFrequency;

                //try getting shadow range from shadowRange
                var shadowRange = angular.copy(scope.shadowRange);
                if (!shadowRange)
                    shadowRange = [];

                //try getting minimum date from minDate
                var minDate = angular.copy(scope.minDate);

                //try getting maximum date from maxDate
                var maxDate = angular.copy(scope.maxDate);

                //update chart height based on the height of the parent element
                // console.log(element.parent().height());
                chartObject.height = element.parent().height();

                //if there was an error don't try to build a chart
                if (lineData === null) {
                    element.append('<p>Unable to plot the chart</p>');
                    return;
                }

                //if there's no line styles provided fill them in with the default line styles
                var ix;
                if (lineData.length > 0 && (!lineStyles || lineStyles.length == 0)) {
                    lineStyles = [];
                    for (ix = 0; ix < Math.min(6, lineData.length); ix++) {
                        lineStyles.push(defaultLineStyles.predefined[ix]);
                    }
                }

                //if line data is empty show the "Empty" message
                if (lineData.length == 0) {
                    chartObject.placeholder.show = true;
                    chartObject.xAxis.show = false;
                    chartObject.yAxis.show = false;
                    chartObject.xAxis.grid = false;
                    chartObject.yAxis.grid = false;
                    chartObject.yAxis.title.show = false;
                    chartObject.series = [];
                    chartObject.xAxis.shading = [];
                    chartObject.legend.show = false;
                } else {
                    chartObject.placeholder.show = false;
                    chartObject.xAxis.show = true;
                    chartObject.yAxis.show = true;
                    chartObject.xAxis.grid = true;
                    chartObject.yAxis.grid = true;
                    chartObject.yAxis.title.show = true;
                    chartObject.yAxis.title.text = yLabel;
                    chartObject.series = [];
                    chartObject.xAxis.shading = [];
                    chartObject.legend.show = true;
                }
                //cut the range of all chart series
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        if (minDate)
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint))
                                    return false;
                                return new Date(dataPoint.date) >= minDate;
                            });
                        if (maxDate)
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint))
                                    return false;
                                return new Date(dataPoint.date) <= maxDate;
                            });
                    }
                }
                //configure shadow ranges
                if (lineData.length > 0)
                    for (ix = 0; ix < shadowRange.length; ix++) {
                        var ixc = angular.copy(ix);
                        var sr = angular.copy(shadowRange[ixc]);
                        sr.visible = true;
                        //todo: lineData[0] is a nasty assumption -- use the series which starts the earliest instead
                        if (shadowRange[ixc].start) {
                            var convertedDate = DateUtils.convertLocalDateToServer(
                                TimeseriesUtils.parseTsDate(
                                    TimeseriesUtils.convertDateToTsDate(shadowRange[ixc].start, dateFrequency, dateFormat), dateFrequency
                                )
                            );
                            sr.start = lineData[0].findIndex(function (d) {
                                return d.date == convertedDate;
                            });
                        } else {
                            sr.start = 0;
                        }
                        if (shadowRange[ixc].end) {
                            var convertedDate = DateUtils.convertLocalDateToServer(
                                TimeseriesUtils.parseTsDate(
                                    TimeseriesUtils.convertDateToTsDate(shadowRange[ixc].end, dateFrequency, dateFormat), dateFrequency
                                )
                            );
                            sr.end = lineData[0].findIndex(function (d) {
                                return d.date == convertedDate;
                            });
                        } else {
                            if (shadowRange[ixc].start) {
                                sr.end = lineData[0].length - 1;
                            } else {
                                sr.end = 0;
                            }
                        }
                        for (var styleProperty in defaultShadowStyle) {
                            if (defaultShadowStyle.hasOwnProperty(styleProperty) && !shadowRange[ixc].hasOwnProperty(styleProperty)) {
                                sr[styleProperty] = defaultShadowStyle[styleProperty];
                            }
                        }
                        chartObject.xAxis.shading.push({from: sr.start, to: sr.end, color: sr.color, opacity: sr.opacity});
                    }
                //fill in series of chartObject with the lines' data
                var minValue = Number.MAX_VALUE;
                var maxValue = -Number.MAX_VALUE;
                // first and last date label over all series (in text order), for the daily category axis
                var firstTick, lastTick;
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        var bandPoints = [];
                        const hasBand = (angular.isDefined(bandWidthData[ix]) && bandWidthData[ix] !== 0);
                        //convert dates to formatted date strings
                        for (var jx = 0; jx < lineData[ix].length; jx++) {
                            const yNum = lineData[ix][jx].value;
                            const dt = lineData[ix][jx].date;
                            minValue = Math.min(minValue, yNum);
                            maxValue = Math.max(maxValue, yNum);
                            lineData[ix][jx].dateFormatted = TimeseriesUtils.convertDateToTsDate(dt, dateFrequency, dateFormat);
                            const tick = lineData[ix][jx].dateFormatted;
                            if (firstTick === undefined || String(tick) < String(firstTick)) {
                                firstTick = tick;
                            }
                            if (lastTick === undefined || String(tick) > String(lastTick)) {
                                lastTick = tick;
                            }
                            if (hasBand) {
                                bandPoints.push({
                                    x: lineData[ix][jx].dateFormatted,
                                    upper: yNum + bandWidthData[ix],
                                    lower: yNum - bandWidthData[ix]
                                });
                            }
                        }
                        //use default line style if number of lines is higher the number of predefined lines in config
                        if (lineStyles.length < ix + 1) {
                            lineStyles.push(defaultLineStyles.new);
                        }
                        //adjust line width if user supplied one
                        if (lineWidths.length >= ix + 1 && lineWidths[ix]) {
                            lineStyles[ix].width = lineWidths[ix];
                        }
                        //use default legend if lineLegends array is shorter
                        var lineName = "";
                        if (!lineLegends || lineLegends.length < ix + 1) {
                            lineName = "curve" + (ix + 1);
                        } else {
                            lineName = lineLegends[ix];
                        }
                        // add confidence bands for lines
                        if (bandPoints.length > 0) {
                            chartObject.series.push({
                                kind: 'band',
                                color: '#dbdbe6',
                                tooltipFont: {color: '#1e2834'},
                                edgeColor: 'transparent',
                                points: bandPoints,
                                label: lineName + " ±1 stdev"
                            });
                        }
                        //add series to the chart structure
                        chartObject.series.push({
                            kind: 'line',
                            color: lineStyles[ix].color,
                            lineWidth: lineStyles[ix].width,
                            marker: {show: false, size: lineStyles[ix].markerSize},
                            dash: lineStyles[ix].dashSetting,
                            points: lineData[ix].map(function (d) {
                                return {x: d.dateFormatted, y: d.value};
                            }),
                            label: lineName
                        });
                    }
                }

                // add invisible series to the beginning of chartObject.series array
                // to correctly handle the X axis ticks
                var dataPoints = [];
                const endDate = new Date(lastTick);
                for (var d = new Date(firstTick); d <= endDate; d.setDate(d.getDate() + 1)) {
                    dataPoints.push({
                        x: TimeseriesUtils.convertDateToTsDate(d, dateFrequency, dateFormat),
                        y: -100
                    });
                }
                chartObject.series.unshift({
                    kind: 'line',
                    color: "transparent",
                    points: dataPoints,
                    label: " ",
                    // only supplies the daily x categories; OgrChart never draws or tracks it
                    axisOnly: true
                });
                // adjust X-axis interval to be at most 9 ticks
                const nTicks = dataPoints.length;
                chartObject.xAxis.step = Math.ceil(nTicks / 9);
                // adjust Y-axis range to be tight
                var delta = Math.abs(maxValue - minValue);
                if (lineData.length > 0) {
                    chartObject.yAxis.min = minValue - 0.1 * delta;
                    chartObject.yAxis.max = maxValue + 0.1 * delta;
                }
                // console.log(chartObject);
                //generate the chart from prepared object
                OgrChart.render(element, angular.copy(chartObject));
            }
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .constant('chartConstants', {
            'lineColorSet': [
                '#46b44f',
                '#356581',
                '#ff8400',
                '#8b4513',
                '#e52b50',
                '#8b92a1',
                '#ffd700'
            ]
        });
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .provider('chartConfig', chartConfig);

    // configuration
    chartConfig.$inject = ['chartConstants'];

    function chartConfig(chartConstants) {
        this.timeseriesChartDefaultDateFormat = 'YYFP';
        this.timeseriesChartDefaultFrequency = 4; //quarterly
        this.timeseriesChartDefaultShadowStyle = {
            color: '#aea',
            opacity: 0.25
        };
        this.timeseriesChartDefaultObject = {
            height: 250,
            xAxis: {
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                show: true, // to be changed for empty charts
                grid: true,
                scale: 'category',
                shading: [] //range shadowing is empty by default
            },
            yAxis: {
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                title: {
                    show: false,
                    text: 'Yield (%, annually compounded)',
                    font: {
                        size: "12px",
                        fontFamily: "Helvetica",
                        color: "#1e2834"
                    }
                },
                show: true, // to be changed for empty charts
                grid: true
            },
            seriesStyle: {
                defaultOpacity: 0.75,
                hoverOpacity: 1
            },
            //Series are to be filled in the app
            series: [],
            //vertical tracker line with a tooltip per series
            tracker: true,
            legend: {
                show: true,
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                clickToHide: false
            },
            placeholder: {
                show: false, // to be changed for empty charts
                text: "Empty",
                fontSize: "24px",
                opacity: 0.2
            },
            tooltipText: tooltipText
        };

        this.timeseriesChartDefaultLineStyles = {
            predefined: [ //todo: only seven lines are predefined so far, will see if more is needed
                {
                    width: 3,
                    color: chartConstants.lineColorSet[0],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[1],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[2],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[3],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[4],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[5],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[6],
                    dashSetting: [1, 0],
                    markerSize: 2
                }
            ],
            new: {
                width: 3,
                color: null, //will be picked automatically
                dashSetting: [1, 0],
                markerSize: 2
            }
        };

        this.$get = function () {
            return {
                timeseriesChartDefaults: {
                    chartObject: this.timeseriesChartDefaultObject,
                    lineStyles: this.timeseriesChartDefaultLineStyles,
                    dateFormat: this.timeseriesChartDefaultDateFormat,
                    frequency: this.timeseriesChartDefaultFrequency,
                    shadowStyle: this.timeseriesChartDefaultShadowStyle
                }
            };
        };

        function tooltipText(point) {
            if (angular.isDefined(point.lower)) {
                return "High : " + point.upper.toPrecision(4) + " <br/> " + "Low : " + point.lower.toPrecision(4);
            }
            //reformat Y number up to 4th precision point
            return point.x + " : " + point.y.toPrecision(4);
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('portalApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('portalApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-portalApp-error');
                var entityKey = httpResponse.headers('X-portalApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('portalApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 403:
                // never serialise the response: its config carries the Authorization header
                addErrorAlert('You are not entitled to access this file or page.');
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    // never serialise the response: its config carries the Authorization header
                    addErrorAlert('Request failed (' + httpResponse.status + (httpResponse.statusText ? ' ' + httpResponse.statusText : '') + ')');
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('portalApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-portalApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-portalApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('portalApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }

            return config;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', '$localStorage', 'Translation',
        'amMoment'];

    function translationHandler($rootScope, $window, $state, $translate, $localStorage, Translation, amMoment) {
        var k = 0;
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            $localStorage.translationsTable = {}; //$localStorage.translationsTable || {};
            //if the current translation changes, update the window title and other labels
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                var langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
                updateTitle();
                //update translations of the labels stored in the database Translation table
                angular.forEach(['reportPageTitles', 'ntfVariableLabels', 'equationLabels',
                        'symbolLabels'],
                    function (objName) {
                        updateTranslationsFor(langKey, objName);
                    });
                angular.forEach(['name', 'description_short', 'description_detailed'], function (objName) {
                    updateTranslationsFor(langKey, 'precookedScenarioLabels', objName);
                });
                angular.forEach(['title', 'unit'], function (objName) {
                    updateTranslationsFor(langKey, 'reportPageChartTitles', objName);
                });

                //change dates locale for momentJs
                amMoment.changeLocale(langKey);
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            var paramSet = {};
            if (titleKey && $state.params && $state.params.countryName) {
                paramSet = {countryName: $state.params.countryName};
            }
            $translate(titleKey || 'global.title', paramSet).then(function (title) {
                $window.document.title = title;
            });
        }

        function updateTranslationsFor(langKey, objName, subObjName) {
            var mainState = $state.get('main');
            mainState.data = mainState.data || {};
            mainState.data[objName] = mainState.data[objName] || [];
            angular.forEach(mainState.data[objName], function (obj) {
                obj = (typeof subObjName === 'undefined') ? obj : obj[subObjName];
                if (angular.isDefined(obj.keyPhrase) && obj.keyPhrase !== "") {
                    if (!$localStorage.translationsTable.hasOwnProperty(obj.keyPhrase)
                        || !$localStorage.translationsTable[obj.keyPhrase].hasOwnProperty(langKey)) {
                        $localStorage.translationsTable[obj.keyPhrase] =
                            $localStorage.translationsTable[obj.keyPhrase] || {};
                        $localStorage.translationsTable[obj.keyPhrase][langKey] =
                            $localStorage.translationsTable[obj.keyPhrase][langKey] || '';
                        Translation.get({
                            keyPhrase: obj.keyPhrase,
                            languageKey: langKey
                        }).$promise
                            .then(function (data) {
                                obj.translated = data.translation;
                                $localStorage.translationsTable[obj.keyPhrase][langKey] = data.translation;
                            })
                            .catch(function () {
                                obj.translated = obj.keyPhrase;
                                $localStorage.translationsTable[obj.keyPhrase][langKey] = obj.keyPhrase;
                            });
                    }
                    else
                        obj.translated = $localStorage.translationsTable[obj.keyPhrase][langKey];
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
                          Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                //pre-store the data about chart titles when leaving the 'page' state for another non-'page' state
                if (fromState.name === 'page' && toState.name !== 'page'){
                    toState.data.reportPageChartTitles = fromState.data.reportPageChartTitles;
                }

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                // scroll to the top of the page
                document.body.scrollTop = document.documentElement.scrollTop = 0;

                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            var stateChangeError = $rootScope.$on('$stateChangeError',
                function (event, toState, toParams, fromState, fromParams, error) {
                    if (error === "signin") {
                        console.log('User is not authorized or account info is not ready yet! Redirecting to home.');
                        $state.go("home");
                    }
                    else console.log(error);

                });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
                if (angular.isDefined(stateChangeError) && stateChangeError !== null) {
                    stateChangeError();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');

        // add missing case for the CS locale months
        moment.locale('cs', {
            months: function (m, format) {
                var months = {
                        'nominative': 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
                        'genitive': 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split('_')
                    },
                    nounCase = (/D[oD\.]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
                        'genitive' :
                        'nominative';
                return months[nounCase][m.month()];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stickyStateConfig);

    stickyStateConfig.$inject = ['$stickyStateProvider'];

    function stickyStateConfig($stickyStateProvider) {
        //enable debug
        $stickyStateProvider.enableDebug(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('ogr-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('ArchiveController', ArchiveController);

    ArchiveController.$inject = ['$filter', '$state', 'subscribedCountryList', 'allYcmRounds', 'archiveResources',
        'DataUtils', 'Resource'];

    function ArchiveController($filter, $state, subscribedCountryList, allYcmRounds, archiveResources,
                               DataUtils, Resource) {
        var vm = this;
        vm.downloadResource = downloadResource;
        vm.country = subscribedCountryList.find(function (c) {
            return (c.id == $state.params.countryId);
        });
        vm.allYcmRounds = allYcmRounds;
        vm.yearGroupList = [];
        // if round is not found (doesn't exist or not subscribed) => stop here
        if (angular.isArray(allYcmRounds) && allYcmRounds.length > 0) {
            // pre-process the resources (add descriptions, icon types, ordering etc.) for each round
            // and group the rounds by year
            var yearGroup = {
                uncollapsed: true,
                roundList: [],
                thisYear: allYcmRounds[0].created.slice(0, 4)
            };
            for (var rx = 0; rx < allYcmRounds.length; rx++) {
                var yStr = allYcmRounds[rx].created.slice(0, 4);
                var y = parseInt(yStr);
                if (rx > 0 && parseInt(allYcmRounds[rx - 1].created.slice(0, 4)) !== y) {
                    vm.yearGroupList.push(angular.copy(yearGroup));
                    yearGroup = {uncollapsed: false, roundList: [], thisYear: yStr};
                }
                var thisResources = archiveResources[rx].map(function (res) {
                    if (res.description.indexOf("YCM-YIELD-CURVE-SPREADSHEET") !== -1) {
                        res.ix = 0;
                        res.roundIx = rx;
                        res.desc = "YCM Report Table";
                        res.ext = "csv";
                        res.icon = "fa fa-file-excel-o fa-fw";
                    } else if (res.description.indexOf("YCM-DAILY-ZERO-CURVE-SPREADSHEET") !== -1) {
                        res.ix = 1;
                        res.roundIx = rx;
                        res.desc = "Daily Zero Curve Table";
                        res.ext = "csv";
                        res.icon = "fa fa-file-excel-o fa-fw";
                    } else if (res.description.indexOf("YCM-DAILY-CCY-CURVE-SPREADSHEET") !== -1) {
                        res.ix = 2;
                        res.roundIx = rx;
                        res.desc = "Daily CCY Rates Table";
                        res.ext = "csv";
                        res.icon = "fa fa-file-excel-o fa-fw";
                    } else if (res.description.indexOf("YCM-IRS-BREAKEVEN-SPREADSHEET") !== -1) {
                        res.ix = 3;
                        res.roundIx = rx;
                        res.desc = "Historical Break-Even Table";
                        res.ext = "csv";
                        res.icon = "fa fa-file-excel-o fa-fw";
                    } else {
                        res.ix = 4;
                        res.roundIx = rx;
                        res.desc = "Unknown file";
                        res.ext = "";
                        res.icon = "fa fa-file-o fa-fw";
                    }
                    return res;
                });
                yearGroup.roundList.push({created: allYcmRounds[rx].created, resList: angular.copy(thisResources)});
                if (rx + 1 === allYcmRounds.length) {
                    vm.yearGroupList.push(angular.copy(yearGroup));
                }
            }
        }

        /**
         * Triggers downloading -- either proper resource downloading from SVN or a data export
         * @param res -- resource object
         */
        function downloadResource(res) {
            Resource
                .download({id: res.id, download: true})
                .$promise
                .then(function (response) {
                    var fileName = vm.country.name + " -- " + res.desc + " ("
                        + $filter('date')(vm.allYcmRounds[res.roundIx].created, 'dd-MMM-yyyy')
                        + ")" + ((res.ext === "") ? "" : ("." + res.ext));
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName);
                });

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'FooterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('portalApp')
        .constant('VERSION', "1.0.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'UserGroup', 'paginationConstants'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, UserGroup, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.userGroups = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        UserGroup.query({
            size: paginationConstants.userGroupSelectionItemsPerPage
        }, onSuccess, onError);

        function onSuccess(userGroups) {
            vm.userGroups = userGroups.map(function(data){return data.name});
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MODOP'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = 10000; //paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            // vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null, company: null,
                activated: null, userGroup: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('statistics', {
            parent: 'admin',
            url: '/statistics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'statistics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/statistics/statistics.html',
                    controller: 'StatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('StatisticsService', StatisticsService);

    StatisticsService.$inject = ['$resource'];

    function StatisticsService ($resource) {
        var service = $resource('api/users-statistics', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('StatisticsController', StatisticsController);

    StatisticsController.$inject = ['$filter', 'StatisticsService'];

    function StatisticsController ($filter, StatisticsService) {
        var vm = this;

        vm.statistics = null;

        loadAll();

        function loadAll () {
            StatisticsService.query({}, function(result){
                vm.statistics = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('companies-statistics', {
            parent: 'admin',
            url: '/companies-statistics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'companies.statistics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/statistics/companies-statistics.html',
                    controller: 'CompaniesStatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('CompaniesStatisticsService', CompaniesStatisticsService);

    CompaniesStatisticsService.$inject = ['$resource'];

    function CompaniesStatisticsService ($resource) {
        var service = $resource('api/companies-statistics', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CompaniesStatisticsController', CompaniesStatisticsController);

    CompaniesStatisticsController.$inject = ['CompaniesStatisticsService'];

    function CompaniesStatisticsController (CompaniesStatisticsService) {
        var vm = this;

        vm.statistics = null;

        loadAll();

        function loadAll () {
            CompaniesStatisticsService.query({}, function(result){
                vm.statistics = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('portalApp')
        .controller('ProtectionPolicyModalController', ProtectionPolicyModalController);

    ProtectionPolicyModalController.$inject = ['$http', '$uibModalInstance', 'Principal', 'Auth'];

    function ProtectionPolicyModalController ($http, $uibModalInstance, Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.success = null;

        vm.text = "text is being loaded...";

        vm.cancel = cancel;
        vm.saveAcceptProtectionPolicy = saveAcceptProtectionPolicy;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function saveAcceptProtectionPolicy () {

            Principal.identity().then(function(account) {
                vm.currentAccount = account;
                var date = new Date();
                vm.currentAccount.policyAcceptedDate = date;
                console.log("Updating user with date of protection policy acceptance " + date);
                // Auth.updateAccount(vm.currentAccount).then(function () {
                //     vm.error = null;
                //     vm.success = 'OK';
                // }).catch(function () {
                //     vm.success = null;
                //     vm.error = 'ERROR';
                // });

                $http({method: 'PUT', url: 'api/user_acceptance?code=GDPR-text'}).
                then(function(response) {
                    console.log('The acceptance saved.');
                }, function(response) {
                    console.error('The acceptance was not saved.');
                });

                $uibModalInstance.dismiss('cancel');
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function() {
    'use strict';

    angular.module('portalApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('ActualController', ActualController);

    ActualController.$inject = ['$filter', '$q', '$sce', '$state', 'subscribedCountryList', 'latestYcmRound', 'latestYcmResults',
        'latestYcmResources', 'DataUtils', 'Resource', 'YcmCalculation', 'ycTableConstants'];

    function ActualController($filter, $q, $sce, $state, subscribedCountryList, latestYcmRound, latestYcmResults,
        latestYcmResources, DataUtils, Resource, YcmCalculation, ycTableConstants) {
        var vm = this;
        vm.mainView = $state.params.mainView;
        vm.country = subscribedCountryList.find(function (c) {
            return (c.id == $state.params.countryId);
        });
        vm.noRecalculation = checkIfNoRecalculate();
        vm.tableRowOrder = ['zero_curve', 'gov_zero_curve', 'irs_quarterly', 'sharpe_ratio_irs', 'sharpe_ratio_zc',
            'ccy_semiannual', 'ccy_continuous', 'sharpe_ratio_ccy', 'fpas_compounded_mean', 'fpas_compounded_std'];
        vm.editableRowsList = (vm.noRecalculation) ? [] : ['sharpe_ratio_zc'];
        vm.lastRowsOfBlocks = ['sharpe_ratio_zc', 'sharpe_ratio_ccy'];
        vm.latestYcmRound = latestYcmRound;
        vm.ycmResources = [];
        vm.tableData = {};
        vm.origTableData = {};
        vm.tableTenorState = ycTableConstants.tenorList.labels.reduce(function (accum, tLab) {
            accum[tLab] = {
                recalculated: true,
                calculating: false,
                failed: false
            };
            return accum;
        }, {});
        vm.downloadResource = downloadResource;
        vm.dataTableFromYcmResults = dataTableFromYcmResults;
        vm.fillTableColumnFromYcData = fillTableColumnFromYcData;
        vm.fillTableRowFromYcData = fillTableRowFromYcData;
        vm.switchToChart = switchToChart;
        vm.recalculate = (vm.noRecalculation) ? null : recalculate;

        // if round is not found (doesn't exist or not subscribed) => stop here
        if (latestYcmRound !== null && !angular.equals(latestYcmRound, {})) {
            // create table data for YC directive out of YCM results
            if (angular.isArray(latestYcmResults) && latestYcmResults.length > 0) {
                vm.tableData = dataTableFromYcmResults(latestYcmResults);
                vm.origTableData = angular.copy(vm.tableData);
            }
            // pre-process the resources (add descriptions, icon types, ordering etc.)
            vm.ycmResources = latestYcmResources.map(function (res) {
                if (res.description.indexOf("YCM-YIELD-CURVE-SPREADSHEET") !== -1) {
                    res.ix = 0;
                    res.desc = "YCM Report Table";
                    res.ext = "csv";
                    res.icon = "fa fa-file-excel-o fa-fw";
                } else if (res.description.indexOf("YCM-DAILY-ZERO-CURVE-SPREADSHEET") !== -1) {
                    res.ix = 1;
                    res.desc = "Daily Zero Curve Table";
                    res.ext = "csv";
                    res.icon = "fa fa-file-excel-o fa-fw";
                } else if (res.description.indexOf("YCM-DAILY-CCY-CURVE-SPREADSHEET") !== -1) {
                    res.ix = 2;
                    res.desc = "Daily CCY Rates Table";
                    res.ext = "csv";
                    res.icon = "fa fa-file-excel-o fa-fw";
                } else {
                    res.ix = 3;
                    res.desc = "Unknown file";
                    res.ext = "";
                    res.icon = "fa fa-file-o fa-fw";
                }
                return res;
            });
        }

        /**
         * Recalculates the yields and Sharpe ratios for the specified tenor(s) and value(s) of zero-coupon SR
         *
         * @param tnr -- array of modified tenors
         * @param val -- array of new zero-coupon SR values
         */
        function recalculate(tnr, val) {
            const zeroCurveIx = latestYcmResults.findIndex(function (res) {
                return res.name === 'zero_curve';
            });
            const zeroCurveSrIx = latestYcmResults.findIndex(function (res) {
                return res.name === 'sharpe_ratio_zc';
            });
            const irsCurveIx = latestYcmResults.findIndex(function (res) {
                return res.name === 'irs_quarterly';
            });
            const irsCurveSrIx = latestYcmResults.findIndex(function (res) {
                return res.name === 'sharpe_ratio_irs';
            });
            if (zeroCurveSrIx > -1 && zeroCurveIx > -1) {
                // first, we recalculate ZERO and GOV ZERO curves for all modified tenors,
                // as recalculated zero curve is going to be used as discount factors for the following
                // IRS recalculation
                const zeroCurveSrData = latestYcmResults[zeroCurveSrIx].yieldCurveData;
                var zcPromises = [];
                for (var i = 0; i < tnr.length; i++) {
                    const thisValue = val[i];
                    const thisTenor = tnr[i];
                    const zeroCurveSrTenorIx = zeroCurveSrData.findIndex(function (tnr) {
                        return tnr.tenorLabel === thisTenor;
                    });
                    if (zeroCurveSrTenorIx > -1) {
                        vm.tableTenorState[thisTenor].calculating = true;
                        vm.tableTenorState[thisTenor].failed = false;
                        var thisZeroCurveSrTenorData = angular.copy(zeroCurveSrData[zeroCurveSrTenorIx]);
                        thisZeroCurveSrTenorData.value = thisValue;
                        var thisPromise = YcmCalculation('zero')
                            .calculate(thisZeroCurveSrTenorData)
                            .$promise
                            .then(function (res) {
                                fillTableColumnFromYcData(res, thisTenor);
                            })
                            .catch(function () {
                                vm.tableTenorState[thisTenor].calculating = false;
                                vm.tableTenorState[thisTenor].recalculated = false;
                                vm.tableTenorState[thisTenor].failed = true;
                            });
                        zcPromises.push(thisPromise);
                    }
                }

                // second we recalculate IRS coupons and Sharpe ratios
                if (irsCurveIx > -1 && irsCurveSrIx > -1) {
                    $q.all(zcPromises)
                        .then(function () {
                            const modifiedZeroCurveSr = updateCurveDataFromTable(latestYcmResults[zeroCurveSrIx]);
                            const modifiedZeroCurve = updateCurveDataFromTable(latestYcmResults[zeroCurveIx]);
                            var thisPromise = callYcmCalculation(tnr, 'irs', [modifiedZeroCurveSr, modifiedZeroCurve], false);
                            // third we recalculate CCY rates and Sharpe ratios
                            $q.when(thisPromise)
                                .then(function () {
                                    const modifiedIrsCurveSr = updateCurveDataFromTable(latestYcmResults[irsCurveSrIx]);
                                    const modifiedIrsCurve = updateCurveDataFromTable(latestYcmResults[irsCurveIx]);
                                    callYcmCalculation(tnr, 'ccy', [modifiedIrsCurveSr, modifiedIrsCurve], true);
                                });
                        });
                }
            }
        }

        /**
         * Sends the calculation request of the specified type with the provided request parameters
         * and fills the table with the resulting curves
         *
         * @param tnr               -- array of modified tenors
         * @param calculationType   -- type of calculation: 'irs' or 'ccy'
         * @param requestParameters -- array of YieldCurveDTO objects used as an input for the
         *                             corresponding calculation
         * @param isLastInQueue     -- whether this is the last call to calculation after which
         *                             the calculation indicator should be updated
         */
        function callYcmCalculation(tnr, calculationType, requestParameters, isLastInQueue) {
            return YcmCalculation(calculationType).calculate(requestParameters)
                .$promise
                .then(function (res) {
                    for (var i = 0; i < res.length; i++) {
                        fillTableRowFromYcData(res[i].yieldCurveData, res[i].name);
                    }
                    if (isLastInQueue) {
                        for (i = 0; i < tnr.length; i++) {
                            const thisTenor = tnr[i];
                            vm.tableTenorState[thisTenor].calculating = false;
                            vm.tableTenorState[thisTenor].recalculated = true;
                            vm.tableTenorState[thisTenor].failed = false;
                        }
                    }
                })
                .catch(function () {
                    for (var i = 0; i < tnr.length; i++) {
                        const thisTenor = tnr[i];
                        vm.tableTenorState[thisTenor].calculating = false;
                        vm.tableTenorState[thisTenor].recalculated = false;
                        vm.tableTenorState[thisTenor].failed = true;
                    }
                });
        }

        /**
         * Switches the main panel to the yc-chart view ("by maturity" tab)
         *
         */
        function switchToChart() {
            $state.go('selectedCountry', {countryId: vm.country.id, mainView: 'yc-chart', chartType: 'maturity'});
        }

        /**
         * Converts YCM results to the input structure for yc-table directive
         *
         * @param ycmResults -- resulting array of curves
         * @returns {{rowHeaders: Array, tableId: string, hideTenors: number[], rows: Array, rowTooltips: Array, rowUnits: Array}}
         */
        function dataTableFromYcmResults(ycmResults) {
            var tblData = {
                tableId: 'actual-tbl',
                hideTenors: [1, 7, Math.floor(365 / 12), Math.floor(365 / 6)],
                rowIds: [],
                rowHeaders: [],
                rowTooltips: [],
                rowUnits: [],
                rows: []
            };
            for (var rx = 0; rx < vm.tableRowOrder.length; rx++) {
                const thisRx = rx;
                const thisIx = ycmResults.findIndex(function (res) {
                    return res.name === vm.tableRowOrder[thisRx];
                });
                if (thisIx !== -1) {
                    const thisCurve = angular.copy(ycmResults[thisIx]);
                    const isEditable = vm.editableRowsList.includes(vm.tableRowOrder[thisRx]);
                    const isLastInBlock = vm.lastRowsOfBlocks.includes(vm.tableRowOrder[thisRx]);
                    tblData.rowIds.push(vm.tableRowOrder[thisRx]);
                    tblData.rowHeaders.push(thisCurve.label);
                    tblData.rowTooltips.push(thisCurve.description);
                    tblData.rowUnits.push($sce.trustAsHtml(thisCurve.unit));
                    var rowData = {};
                    for (var dx = 0; dx < thisCurve.yieldCurveData.length; dx++) {
                        const col = thisCurve.yieldCurveData[dx];
                        if (col.value === 'NaN') {
                            col.value = '';
                        }
                        rowData[col.tenorLabel] = {
                            value: col.value,
                            isEditable: isEditable,
                            isLastInBlock: isLastInBlock
                        };
                    }
                    tblData.rows.push(rowData);
                }
            }
            return tblData;
        }

        /**
         * Fills in the column of tableData with the values from the list of YieldCurveDataDTO
         *
         * @param tenorLabel         -- tenor label for which to fill in the tableData
         * @param yieldCurveDataList -- (re)calculated YCM results in a form of
         *                              List<YieldCurveDataDTO>
         */
        function fillTableColumnFromYcData(yieldCurveDataList, tenorLabel) {
            for (var rx = 0; rx < vm.tableRowOrder.length; rx++) {
                const thisRx = rx;
                const thisIx = yieldCurveDataList.findIndex(function (res) {
                    return res.yieldCurveName === vm.tableRowOrder[thisRx];
                });
                const thisVmTableRowIx = vm.tableData.rowIds.findIndex(function (res) {
                    return res === vm.tableRowOrder[thisRx];
                });
                if (thisIx > -1 && yieldCurveDataList[thisIx].tenorLabel === tenorLabel) {
                    vm.tableData.rows[thisVmTableRowIx][tenorLabel].value =
                        (yieldCurveDataList[thisIx].value === 'NaN')
                            ? '' : yieldCurveDataList[thisIx].value;
                }
            }
        }

        /**
         * Fills in the row of tableData with the values from the list of YieldCurveDataDTO
         *
         * @param curveName          -- name of the curve for which to fill in the tableData
         * @param yieldCurveDataList -- (re)calculated YCM results in a form of
         *                              List<YieldCurveDataDTO>
         */
        function fillTableRowFromYcData(yieldCurveDataList, curveName) {
            const thisVmTableRowIx = vm.tableData.rowIds.findIndex(function (res) {
                return res === curveName;
            });
            for (var i = 0; i < yieldCurveDataList.length; i++) {
                const thisTenorData = yieldCurveDataList[i];
                if (thisVmTableRowIx > -1 && thisTenorData.yieldCurveName === curveName) {
                    vm.tableData.rows[thisVmTableRowIx][thisTenorData.tenorLabel].value =
                        (thisTenorData.value === 'NaN')
                            ? '' : thisTenorData.value;
                }
            }
        }

        /**
         * Triggers server-side downloading from SVN (published_results, usually)
         *
         * @param res -- resource object
         */
        function downloadResource(res) {
            Resource
                .download({id: res.id, download: true})
                .$promise
                .then(function (response) {
                    var fileName = vm.country.name + " -- " + res.desc + " ("
                        + $filter('date')(vm.latestYcmRound.created, 'dd-MMM-yyyy')
                        + ")" + ((res.ext === "") ? "" : ("." + res.ext));
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName);
                });

        }

        /**
         * Uses the values from the corresponding table row and populates the yieldCurveData array
         * of the input YieldCurveDTO object
         *
         * @param ycmResults -- original YieldCurveDTO object
         * @returns {*}
         */
        function updateCurveDataFromTable(ycmResults) {
            const thisCurveIx = vm.tableData.rowIds.findIndex(function (r) {
                return r === ycmResults.name;
            });
            var outYcmResults = angular.copy(ycmResults);
            if (thisCurveIx > -1 && angular.isDefined(ycmResults.yieldCurveData) && angular.isArray(ycmResults.yieldCurveData)) {
                const thisCurve = vm.tableData.rows[thisCurveIx];
                for (var i = 0; i < ycmResults.yieldCurveData.length; i++) {
                    var val = thisCurve[outYcmResults.yieldCurveData[i].tenorLabel].value;
                    outYcmResults.yieldCurveData[i].value = (val === '') ? 'NaN' : val;

                }
            }
            return outYcmResults;
        }

        function checkIfNoRecalculate() {
            const zeroCurveSrIx = latestYcmResults.findIndex(function (res) {
                return res.name === 'sharpe_ratio_zc';
            });
            if (zeroCurveSrIx === -1) {
                return true;
            }
            const zeroCurveSrData = latestYcmResults[zeroCurveSrIx].yieldCurveData;
            if (!zeroCurveSrData) {
                return true;
            }
            // check if all values are NaN
            for (var i = 0; i < zeroCurveSrData.length; i++) {
                if (zeroCurveSrData[i].value !== 'NaN'
                    && zeroCurveSrData[i].value !== ''
                    && zeroCurveSrData[i].value !== null
                    && zeroCurveSrData[i].value !== undefined) {
                    return false;
                }
            }
            return true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.accept = null;
        vm.policyNotAccepted = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else if (vm.accept == null) {
                vm.policyNotAccepted = 'NOT';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.registerAccount.policyAcceptedDate = new Date();
                vm.registerAccount.groupName = "regular";
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    vm.accept = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('data_protection_policy', {
            parent: 'account',
            url: '/data_protection_policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.data_protection_policy'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/data_protection_policy/data_protection_policy.html',
                    controller: 'DataProtectionPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dataProtectionPolicy');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('DataProtectionPolicyController', DataProtectionPolicyController);

    DataProtectionPolicyController.$inject = ['$resource', '$translate'];

    function DataProtectionPolicyController ($resource, $translate) {
        var vm = this;

        vm.date_accepted = null;

        var UserAcceptance = $resource('api/user_acceptance?code=GDPR-text');

        var ua = UserAcceptance.query();

        ua.$promise.then(function () {
            vm.date_accepted = ua[0].accepted;
        })

    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module("portalApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/actual/actual.html","<div class=\"panel actual-panel\" ng-if=\"vm.mainView === \'actual\'\"><div class=\"panel-body\" ng-if=\"vm.latestYcmRound && vm.latestYcmRound.created\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Actual YCM Results</h3><h3 class=\"no-margin-top\"><small>Published on: {{vm.latestYcmRound.created | date:\'MMMM dd, yyyy\'}}</small></h3></div></div><!-- YC table directive --><div data-yc-table data-table-data=\"vm.tableData\" data-orig-data=\"vm.origTableData\" data-switch-to-chart=\"vm.switchToChart\" data-recalculate-fun=\"vm.recalculate\" data-show-units-col=\"false\" data-show-units-row=\"true\" data-country-name=\"vm.country.name\" data-tenor-state=\"vm.tableTenorState\"></div><!-- show resources list in case table is unavailable --><div ng-if=\"!vm.tableData || !vm.tableData.rows || !vm.tableData.rows.length\" style=\"padding-top: 10px\"><div ng-repeat=\"resource in vm.ycmResources | orderBy:\'ix\'\" style=\"padding-bottom: 5px; padding-left: 10px\"><i ng-class=\"resource.icon\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" ng-click=\"vm.downloadResource(resource)\">{{resource.desc}}</a></div></div></div><!-- show this when no YCM rounds were found--><div class=\"panel-body\" ng-if=\"!vm.latestYcmRound || !vm.latestYcmRound.created\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Actual YCM Results</h3><h3 class=\"no-margin-top\"><small>Unavailable</small></h3></div></div><div style=\"padding-top: 10px\"><p>We didn\'t find anything to share with you in this section. Please contact OGResearch YCM team to get more information.</p></div></div></div>");
$templateCache.put("app/archive/archive.html","<div class=\"panel archive-panel\"><div class=\"panel-body\" ng-if=\"vm.allYcmRounds && vm.allYcmRounds.length\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Archive</h3><h3 class=\"no-margin-top\"><!--<small> Published between: {{vm.allYcmRounds[vm.allYcmRounds.length-1].created | date:\'MMMM dd,\n                        yyyy\'}}\n                        &mdash;&nbsp;{{vm.allYcmRounds[0].created | date:\'MMMM dd, yyyy\'}}\n                    </small>--> <small>Published YCM Results</small></h3></div></div><div style=\"padding-top: 10px\"><uib-accordion data-close-others=\"true\"><uib-accordion-group ng-repeat=\"yearGroup in vm.yearGroupList\" is-open=\"yearGroup.uncollapsed\"><uib-accordion-heading><div class=\"container-accordion-heading\">{{yearGroup.thisYear}} <i class=\"pull-right fa fa-chevron-down\" ng-if=\"yearGroup.uncollapsed\" style=\"font-size:18px\" aria-label=\"open container\"></i> <i class=\"pull-right fa fa-chevron-right\" ng-if=\"!yearGroup.uncollapsed\" style=\"font-size:18px\" aria-label=\"close container\"></i></div></uib-accordion-heading><div class=\"row\"><div class=\"col-md-6\" ng-repeat=\"round in yearGroup.roundList\"><h2 class=\"no-margin-top\"><small style=\"color:#46b44f\">{{round.created | date:\'MMMM dd, yyyy\'}}</small></h2><div ng-repeat=\"resource in round.resList | orderBy:\'ix\'\" style=\"padding-bottom: 5px; padding-left: 10px\"><i ng-class=\"resource.icon\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" ng-click=\"vm.downloadResource(resource)\">{{resource.desc}}</a></div></div></div></uib-accordion-group></uib-accordion></div></div><!-- show this when no YCM rounds were found--><div class=\"panel-body\" ng-if=\"!(vm.allYcmRounds && vm.allYcmRounds.length)\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Archive</h3><h3 class=\"no-margin-top\"><small>Empty</small></h3></div></div><div style=\"padding-top: 10px\"><p>We didn\'t find anything to share with you in this section. Please contact OGResearch YCM team to get more information.</p></div></div></div>");
$templateCache.put("app/country-note/country-note.html","<div class=\"alert alert-info country-note\" ng-if=\"vm.countryNotes.length > 0\"><div class=\"row\"><div class=\"col-md-12\"><h4>Note{{vm.countryNotes.length > 1 ? \'s\' : \'\'}}:</h4></div></div><div ng-repeat=\"countryNote in vm.countryNotes track by $index\" style=\"padding-bottom: 5px; padding-left: 10px\"><div class=\"row\"><div class=\"col-md-12\">{{countryNote.note}}<div ng-if=\"vm.countryNotes.length > 1 && ($index+1) != vm.countryNotes.length\"><hr></div></div></div></div></div>");
$templateCache.put("app/fpas/fpas.html","<div class=\"panel fpas-panel\"><div class=\"panel-body\" ng-if=\"vm.latestFullFpasRound && vm.latestFullFpasRound.created\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Recent Macro Forecast</h3><h3 class=\"no-margin-top\"><small>Published on: {{vm.latestFullFpasRound.created | date:\'MMMM dd, yyyy\'}}</small></h3></div></div><div style=\"padding-top: 10px\"><div ng-repeat=\"resource in vm.fpasResources | orderBy:\'ix\'\" style=\"padding-bottom: 5px; padding-left: 10px\"><i ng-class=\"resource.icon\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" ng-click=\"vm.downloadResource(resource,vm.latestFullFpasRound)\">{{resource.desc}}</a></div></div></div><!-- show this when no FPAS rounds were found--><div class=\"panel-body\" ng-if=\"!vm.latestFullFpasRound || !vm.latestFullFpasRound.created\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Recent Macro Forecast</h3><h3 class=\"no-margin-top\"><small>Unavailable</small></h3></div></div><div style=\"padding-top: 10px\"><p>We didn\'t find anything to share with you in this section. Please contact OGResearch YCM team to get more information.</p></div></div><div class=\"panel-body\" ng-if=\"vm.latestFpasRound && vm.latestFpasRound.created && vm.cpiResource\"><div class=\"row\"><div class=\"col-md-12\"><h4 class=\"no-margin-bottom\">CPI Data</h4></div></div><div style=\"padding-top: 10px\"><div style=\"padding-bottom: 5px; padding-left: 10px\"><i class=\"fa fa-file-excel-o fa-fw\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" ng-click=\"vm.downloadResource(vm.cpiResource,vm.latestFpasRound)\">{{vm.cpiResource.desc}} ({{vm.latestFpasRound.created | date:\'MMMM dd, yyyy\'}})</a></div></div><div class=\"cpi-archive\" ng-if=\"vm.olderFpasRounds\"><h5 class=\"cpi-archive-header\" ng-click=\"vm.cpiArchiveOpen=!vm.cpiArchiveOpen\">Archive<span class=\"pull-right\"> <i class=\"pull-right fa fa-chevron-down\" ng-if=\"vm.cpiArchiveOpen\" aria-label=\"open container\"></i> <i class=\"pull-right fa fa-chevron-right\" ng-if=\"!vm.cpiArchiveOpen\" aria-label=\"close container\"></i></span></h5><div ng-show=\"vm.cpiArchiveOpen\"><hr><div class=\"row\"><div class=\"col-md-6\" ng-repeat=\"round in vm.olderFpasRounds\" ng-if=\"vm.olderFpasCpiResource[$index]\"><div style=\"padding-bottom: 5px; padding-left: 10px\"><i class=\"fa fa-file-excel-o fa-fw\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" ng-click=\"vm.downloadResource(vm.olderFpasCpiResource[$index],round)\">{{round.created | date:\'MMMM dd, yyyy\'}}</a></div></div></div></div></div><!--        <uib-accordion data-close-others=\"true\">--><!--            <uib-accordion-group>--><!--                <uib-accordion-heading>--><!--                    <div class=\"container-accordion-heading\" is-open=\"vm.cpiArchiveOpen\">Archive--><!--                        <i class=\"pull-right fa fa-chevron-down\"--><!--                           ng-if=\"!vm.cpiArchiveOpen\"--><!--                           style=\"font-size:18px\"--><!--                           aria-label=\"open container\"></i>--><!--                        <i class=\"pull-right fa fa-chevron-right\"--><!--                           ng-if=\"vm.cpiArchiveOpen\"--><!--                           style=\"font-size:18px\"--><!--                           aria-label=\"close container\"></i>--><!--                    </div>--><!--                </uib-accordion-heading>--><!--                <div class=\"row\">--><!--                    <div class=\"col-md-6\" ng-repeat=\"round in vm.olderFpasRounds\">--><!--                        <div style=\"padding-bottom: 5px; padding-left: 10px;\">--><!--                            <i class=\"fa fa-file-excel-o fa-fw\"--><!--                               style=\"font-size:16px\"--><!--                               aria-label=\"download file\"></i>--><!--                            <a class=\"resource-link\"--><!--                               ng-click=\"vm.downloadResource(vm.cpiResource,round)\">{{round.created | date:\'MMMM dd, yyyy\'}}</a>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--            </uib-accordion-group>--><!--        </uib-accordion>--></div></div>");
$templateCache.put("app/home/home.html","<div ng-cloak><div class=\"container-fluid\"><div ng-switch=\"vm.isAuthenticated()\"><div class=\"row\"><div class=\"col-md-12\"><h1 translate=\"home.title\"></h1></div></div><div class=\"row\" ng-switch-when=\"false\"><div class=\"col-md-9 home-curves\"><!--                    <div translate=\"global.messages.info.about\" translate-compile></div>--><h2 class=\"public-curves-title\">IRS and XCCY Swap Curves</h2><div class=\"public-curves-disclaimer\"><div ng-include=\"\'app/public-curves/public-curves-attribution.html\'\"></div><div ng-include=\"\'app/public-curves/public-curves-disclaimer.html\'\"></div></div><p ng-if=\"vm.curvesLoaded && !vm.curves\" class=\"public-curves-unavailable\">The curves are temporarily unavailable. Please try again later.</p><div ng-include=\"\'app/public-curves/public-curves-tables.html\'\"></div><div ng-include=\"\'app/public-curves/public-curves-files.html\'\"></div><!--                    <ul>--><!--                        <li style=\"padding-top: 10pt;\">We combine observable market data and macro-fundamental analysis--><!--                            to provide tools for theoretical fair-pricing of financial instruments in poorly developed--><!--                            local capital markets--><!--                        </li>--><!--                        <li style=\"padding-top: 10pt;\">IRS, CCY swap and forward curves, zero coupon and par curves--><!--                        </li>--><!--                        <li style=\"padding-top: 10pt;\">Risk-neutral and risk-compensating curves fitting client\'s--><!--                            risk-return preferences and mandates--><!--                        </li>--><!--                        <li style=\"padding-top: 10pt;\">Primary and secondary market data cleaning and collection,--><!--                            liquidity premiums and risk adjustments--><!--                        </li>--><!--                        <li style=\"padding-top: 10pt;\">Model-based interpolations and extrapolation combining market--><!--                            data with macroeconomic and financial sector intelligence--><!--                        </li>--><!--                        <li style=\"padding-top: 10pt;\">Full documentation for regulatory purposes--><!--                        </li>--><!--                        <li style=\"padding-top: 10pt;\">Special focus on data-poor, emerging and frontier market--><!--                            economies--><!--                        </li>--><!--                        <li style=\"padding-top: 10pt;\">Processes audited to ISAE 3402 standard</li>--><!--                    </ul>--></div><div class=\"col-md-3\"><div class=\"well well-md\"><div ui-view=\"login-inline\"></div></div><div class=\"well well-md home-about\"><h4>Yield curves tailor-made to the client, market, and instrument</h4><p>Read about the methodology behind our yield curves in the white paper, see the product presentation, and check the conventions applied to the published curves.</p><a class=\"learn-more-link\" href=\"content/pdf/white-paper.pdf\" target=\"_blank\">White Paper</a> <a class=\"learn-more-link\" href=\"content/pdf/presentation.pdf\" target=\"_blank\">Presentation</a> <a class=\"learn-more-link\" ng-href=\"{{vm.conventionsUrl}}\" target=\"_blank\" rel=\"noopener noreferrer\">Conventions</a></div><!--                    Please contact OGResearch to get an access to the portal.--><div class=\"alert alert-warning\" translate=\"global.messages.info.howtoregister\" translate-compile></div></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div ng-cloak><div class=\"container-fluid\"><!-- main page area --><div class=\"report-area\"><!-- navigation tabs --><ul class=\"nav nav-tabs country-tab-nav\" ng-if=\"vm.subscribedCountryList\"><li ng-class=\"{active: !vm.$state.includes(\'selectedCountry\')}\"><a data-toggle=\"tab\" ui-sref=\"main\">Overview</a></li><li ng-repeat=\"country in vm.subscribedCountryList | orderBy : \'name\'\" ng-class=\"{active: vm.$state.includes(\'selectedCountry\') && (vm.$state.params.countryId == country.id)}\"><a data-toggle=\"tab\" ng-if=\"country\" ng-click=\"vm.onCountrySelected(country.id)\"><!--                        <img class=\"flag-img-tab\"--><!--                             src=\"content/images/flag-{{country.code}}.png\"/>&nbsp;{{country.name}}</a>--> {{country.name}}</a></li></ul><!-- \"overview\" page content --><div ng-show=\"!vm.$state.includes(\'selectedCountry\')\"><div class=\"row\"><div class=\"col-sm-6 col-md-4 col-lg-3\" ng-repeat=\"round in vm.latestYcmRoundList | orderBy : \'countryName\'\"><div class=\"country-overview-panel\"><h3 class=\"no-margin-bottom\">{{round.countryName}}</h3><div ng-if=\"round.created\"><h3 class=\"no-margin-top\"><small>Last YCM Delivery: {{round.created | date : \'MMMM dd, yyyy\'}}</small></h3><!--                                <div class=\"panel-body\">--><div><div ng-repeat=\"resource in vm.resourcesForRound(round.id) | orderBy : \'ix\'\" style=\"padding-bottom: 5px; padding-left: 10px\"><i ng-class=\"resource.icon\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" ng-click=\"vm.downloadResource(resource, round)\">{{resource.desc}}</a></div></div></div><div ng-if=\"!round.created\"><h3 class=\"no-margin-top\"><small>Last YCM Delivery: Unavailable</small></h3><!--                                <div class=\"panel-body\"></div>--><div></div></div><a class=\"learn-more-link\" ng-click=\"vm.onCountrySelected(round.countryId)\">More ...</a></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-md-12\"><div class=\"country-overview-panel\"><h3>Further Information</h3><div style=\"padding-bottom: 5px; padding-left: 10px\"><i class=\"fa fa-file-pdf-o fa-fw\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" href=\"content/pdf/Delivery Calendar 2026.pdf\" target=\"_blank\">YCM Delivery Calendar 2026</a></div><div style=\"padding-bottom: 5px; padding-left: 10px\"><i class=\"fa fa-file-pdf-o fa-fw\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" href=\"content/pdf/white-paper.pdf\" target=\"_blank\">YCM White Paper</a></div><div style=\"padding-bottom: 5px; padding-left: 10px\"><i class=\"fa fa-file-pdf-o fa-fw\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" href=\"content/pdf/presentation.pdf\" target=\"_blank\">YCM Product Presentation</a></div><div style=\"padding-bottom: 5px; padding-left: 10px\"><i class=\"fa fa-file-excel-o fa-fw\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" ng-click=\"vm.downloadSummary(\'Bloomberg\')\">Bloomberg Input File</a></div><!--                            <div style=\"padding-bottom: 5px; padding-left: 10px;\">--><!--                                <i class=\"fa fa-file-excel-o fa-fw\"--><!--                                   style=\"font-size:16px\"--><!--                                   aria-label=\"download file\"></i>--><!--                                <a class=\"resource-link\"--><!--                                   ng-click=\"vm.downloadSummary(\'LSEG\')\">LSEG Input File</a>--><!--                            </div>--><div style=\"padding-bottom: 5px; padding-left: 10px\"><i class=\"fa fa-file-pdf-o fa-fw\" style=\"font-size:16px\" aria-label=\"download file\"></i> <a class=\"resource-link\" href=\"content/pdf/EBRD curves conventions.pdf\" target=\"_blank\">EBRD Curves Conventions</a></div></div></div></div></div><!-- country page content --><div ng-show=\"vm.$state.includes(\'selectedCountry\')\"><div class=\"row\"><div class=\"col-md-12\"><div ui-view=\"country-note\"></div></div><div class=\"col-md-12\"><div ui-view=\"actual\"></div></div><div class=\"col-md-12\"><div ui-view=\"yc-chart\"></div></div><!--                    <div class=\"col-md-12 panel\">--><!--                        <hr/>--><!--                    </div>--><div class=\"col-md-6\"><div ui-view=\"archive\"></div></div><div class=\"col-md-6\"><div ui-view=\"fpas\"></div></div></div></div></div></div></div>");
$templateCache.put("app/public-curves/public-curves-attribution.html","<p>These curves are published thanks to the contribution of the Swiss State Secretariat for Economic Affairs (SECO). OGResearch derives them from available market data, using a pricing methodology developed together with the European Bank for Reconstruction and Development (EBRD). They are indicative par simple mid rates, provided for valuation purposes. Each curve is updated twice a month.</p>");
$templateCache.put("app/public-curves/public-curves-disclaimer.html","<p>The information on this page is provided for information only. It is not investment advice, nor an offer or a solicitation to buy or sell any financial instrument, and the rates are not executable quotes. The curves may be revised without notice.</p><p>EBRD, SECO and OGResearch make no representation or warranty, express or implied, as to the accuracy or completeness of this information, and accept no liability for any loss arising from its use.</p>");
$templateCache.put("app/public-curves/public-curves-files.html","<!-- the latest daily zero and cross-currency curves (the Daily Zero Curve and CCY Rates tables of the Archive section,\n     as CSV files), shared by the public curves page and the home page (needs vm.curves) --><div ng-if=\"vm.curves.dailyTables.length\"><h3 class=\"public-curves-section\">Historical Daily Yield Curves</h3><p>Daily zero curves and cross-currency curves as CSV files in continuous compounding.</p><div class=\"table-responsive\"><table class=\"table table-condensed table-striped public-curves-table public-curves-files-table\"><thead><tr><th>Currency</th><th>Daily Zero Curves<br>(% pa continuous)</th><th>Daily XCCY Curves<br>(% pa continuous)</th></tr></thead><tbody><tr ng-repeat=\"row in vm.curves.dailyTables track by row.code\"><td title=\"{{row.country}}\">{{row.currency || row.country}}</td><td><a ng-if=\"row.zeroCurve\" ng-href=\"api/open/ycm/public-curves/files/{{row.code}}/zero-curve\" download><i class=\"fa fa-file-excel-o fa-fw\" aria-hidden=\"true\"></i>CSV</a> <span ng-if=\"!row.zeroCurve\" class=\"text-muted\">&ndash;</span></td><td><a ng-if=\"row.ccyRates\" ng-href=\"api/open/ycm/public-curves/files/{{row.code}}/ccy-rates\" download><i class=\"fa fa-file-excel-o fa-fw\" aria-hidden=\"true\"></i>CSV</a> <span ng-if=\"!row.ccyRates\" class=\"text-muted\">&ndash;</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/public-curves/public-curves-tables.html","<!-- the IRS and cross-currency tables, shared by the public curves page and the home page (needs vm.curves and vm.date) --><div ng-if=\"vm.curves\"><h3 class=\"public-curves-section\">IRS Curves on {{vm.date | date:\'MMMM d, yyyy\'}}</h3><div class=\"table-responsive\" ng-if=\"vm.curves.irs.rows.length\"><table class=\"table table-condensed table-striped public-curves-table\"><thead><tr><th>Country</th><th>Currency</th><th>Convention</th><th class=\"text-right\" ng-repeat=\"tenor in vm.curves.irs.tenors track by $index\">{{tenor}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.curves.irs.rows track by $index\"><td>{{row.country}}</td><td>{{row.currency}}</td><td>{{row.convention}}</td><td class=\"text-right\" ng-repeat=\"value in row.values track by $index\">{{(value === null) ? \'\' : (value | number:2)}}</td></tr></tbody></table></div><p ng-if=\"!vm.curves.irs.rows.length\">No IRS curves are available at the moment.</p><h3 class=\"public-curves-section\">Cross-Currency Curves on {{vm.date | date:\'MMMM d, yyyy\'}}</h3><div class=\"table-responsive\" ng-if=\"vm.curves.ccy.rows.length\"><table class=\"table table-condensed table-striped public-curves-table\"><thead><tr><th>Country</th><th>Currency</th><th>Convention</th><th class=\"text-right\" ng-repeat=\"tenor in vm.curves.ccy.tenors track by $index\">{{tenor}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.curves.ccy.rows track by $index\"><td>{{row.country}}</td><td>{{row.currency}}</td><td>{{row.convention}}</td><td class=\"text-right\" ng-repeat=\"value in row.values track by $index\">{{(value === null) ? \'\' : (value | number:2)}}</td></tr></tbody></table></div><p ng-if=\"!vm.curves.ccy.rows.length\">No cross-currency curves are available at the moment.</p></div>");
$templateCache.put("app/public-curves/public-curves.html","<div class=\"public-curves\"><h2 class=\"public-curves-title\">IRS and XCCY Swap Curves</h2><p class=\"public-curves-conventions\"><i class=\"fa fa-file-pdf-o fa-fw\" aria-hidden=\"true\"></i> <a ng-href=\"{{vm.conventionsUrl}}\" target=\"_blank\" rel=\"noopener noreferrer\">EBRD Curves Conventions</a></p><div class=\"public-curves-disclaimer\"><div ng-include=\"\'app/public-curves/public-curves-attribution.html\'\"></div><div ng-include=\"\'app/public-curves/public-curves-disclaimer.html\'\"></div></div><p ng-if=\"!vm.curves\" class=\"public-curves-unavailable\">The curves are temporarily unavailable. Please try again later.</p><div ng-include=\"\'app/public-curves/public-curves-tables.html\'\"></div><div ng-include=\"\'app/public-curves/public-curves-files.html\'\"></div></div>");
$templateCache.put("app/yc-chart/yc-chart-maturity.html","<!-- YC chart directive --><div class=\"row\" ng-if=\"vm.chartType===\'maturity\'\"><div class=\"col-md-9\"><!--                <div class=\"chart-pane\" style=\"text-align: center\">--><div class=\"thumbnail chart-pane\" style=\"text-align: center\"><span class=\"yc-chart-control-box-header\">{{vm.chartTitle}}</span><div data-yield-curve-chart data-chart-data=\"vm.chartData\" data-min-tenor=\"vm.chartMinTenor\" data-max-tenor=\"vm.chartMaxTenor\" data-curve-type=\"vm.curveType\" data-y-axis-title=\"vm.yAxisTitle\" data-lang-key=\"vm.langKey\"></div></div></div><div class=\"col-md-3\"><div class=\"thumbnail\" style=\"text-align: center\"><span class=\"yc-chart-control-box-header\">Chart Type</span><div class=\"btn-group btn-group-justified btn-group-sm\" role=\"group\" style=\"padding: 10px 5px\"><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.zeroCurveSelected()\" ng-class=\"{active: vm.curveType==\'zero\'}\">Zero </a><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.irsCurveSelected()\" ng-class=\"{active: vm.curveType==\'irs\'}\">IRS </a><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.ccyCurveSelected()\" ng-class=\"{active: vm.curveType==\'ccy\'}\">CCY </a><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.irsSharpeRatioSelected()\" ng-class=\"{active: vm.curveType==\'irsSr\'}\">IRS&nbsp;SR</a></div></div><div class=\"thumbnail\" style=\"text-align: center\"><span class=\"yc-chart-control-box-header\">Select Dates</span><div style=\"display:inline-block; min-height:200px\"><multiple-date-picker ng-model=\"vm.selectedDates\" day-click=\"vm.onDaySelected\" days-allowed=\"vm.availableDates\" month=\"vm.activeMonth\"></multiple-date-picker></div><div style=\"padding: 10px 5px\"><a type=\"button\" class=\"btn btn-default btn-sm dates-clear-btn\" title=\"Clear selected dates\" ng-click=\"vm.clearDates()\">Clear</a> <a type=\"button\" class=\"btn btn-default btn-sm dates-clear-btn\" title=\"Select current curve\" ng-click=\"vm.selectCurrent()\">Add current</a></div></div><div class=\"thumbnail\" style=\"text-align: center\"><span class=\"yc-chart-control-box-header\">Curve Range</span><div style=\"font-size: 11px\">{{vm.curveRangeLimit}}&nbsp;years</div><div style=\"padding: 6px 10px\"><slider ng-model=\"vm.curveRangeModel\" ng-change=\"vm.onCurveRangeChanged()\" on-stop-slide=\"vm.onCurveRangeSaved()\" min=\"vm.minSlider\" max=\"vm.maxSlider\" step=\"vm.sliderStep\" tooltip=\"hide\"></slider></div></div></div></div>");
$templateCache.put("app/yc-chart/yc-chart-time.html","<!-- YC chart directive --><div class=\"row\" ng-if=\"vm.chartType===\'time\'\"><div class=\"col-md-9\"><div class=\"thumbnail chart-pane\" style=\"text-align: center\"><span class=\"yc-chart-control-box-header\">{{vm.chartTitle}}</span><div data-timeseries-chart data-chart-data=\"vm.chartData\" data-date-format=\"\'yyyy-MM-dd\'\" data-date-frequency=\"365\" data-line-width=\"vm.lineWidth\" data-y-label=\"vm.yAxisTitle\"></div></div></div><div class=\"col-md-3\"><div class=\"thumbnail\" style=\"text-align: center\"><span class=\"yc-chart-control-box-header\">Chart Type</span><div class=\"btn-group btn-group-justified btn-group-sm\" role=\"group\" style=\"padding: 10px 5px\"><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.zeroCurveSelected()\" ng-class=\"{active: vm.curveType==\'zero\'}\">Zero </a><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.irsCurveSelected()\" ng-class=\"{active: vm.curveType==\'irs\'}\">IRS </a><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.ccyCurveSelected()\" ng-class=\"{active: vm.curveType==\'ccy\'}\">CCY </a><a type=\"button\" class=\"btn btn-default no-padding-left no-padding-right curve-type-btn\" ng-click=\"vm.irsSharpeRatioSelected()\" ng-class=\"{active: vm.curveType==\'irsSr\'}\">IRS&nbsp;SR</a></div></div><div class=\"thumbnail\" style=\"text-align: center\"><span class=\"yc-chart-control-box-header\">Select Tenors</span><div class=\"row\" style=\"margin: 10px\"><div class=\"col-xs-2 col-md-3 no-padding-left no-padding-right\" ng-repeat=\"tenor in vm.availableTenors\"><a type=\"button\" class=\"btn btn-default tenor-pick-btn\" ng-click=\"vm.onTenorPicked(tenor)\" ng-class=\"{active: vm.selectedTenors.includes(tenor)}\">{{tenor}}</a></div></div></div><div class=\"thumbnail\" style=\"text-align: center\" ng-if=\"vm.curveType==\'irsSr\'\"><span class=\"yc-chart-control-box-header\">Select Sharpe Ratios</span><div class=\"row\" style=\"margin: 10px\"><div class=\"center-block\"><a type=\"button\" class=\"btn btn-default btn-block sharpe-ratio-pick-btn\" ng-click=\"vm.onSharpeRatioPicked(\'actual\')\" ng-class=\"{active: vm.selectedSR.includes(\'actual\')}\">Actual </a><a type=\"button\" class=\"btn btn-default btn-block sharpe-ratio-pick-btn\" ng-click=\"vm.onSharpeRatioPicked(\'break-even\')\" ng-class=\"{active: vm.selectedSR.includes(\'break-even\')}\">Historical Break-Even</a></div></div></div></div></div>");
$templateCache.put("app/yc-chart/yc-chart.html","<div class=\"panel actual-panel\" ng-if=\"vm.mainView === \'yc-chart\'\"><div class=\"panel-body\" ng-if=\"vm.latestYcmRound && vm.latestYcmRound.created\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Yield Curve Chart <button type=\"button\" title=\"Switch to Actual YCM Table Page\" class=\"pull-right btn btn-default btn-sm switch-view-btn\" ng-click=\"vm.switchToTable()\"><i class=\"fa fa-table fa-fw\" aria-label=\"go to table\"></i>&nbsp<span class=\"hidden-xs\">Back to YCM Table</span>&nbsp;&gt;</button></h3><h3 class=\"no-margin-top\"><small>Compare Published YCM Results</small></h3></div></div><!-- YC chart views --><ul class=\"nav nav-tabs chart-tab-nav\"><li ng-class=\"{active: vm.chartType===\'maturity\'}\"><a data-toggle=\"tab\" ng-click=\"vm.onTabSelected(\'maturity\')\">By maturity</a></li><li ng-class=\"{active: vm.chartType===\'time\'}\"><a data-toggle=\"tab\" ng-click=\"vm.onTabSelected(\'time\')\">By time</a></li></ul><div><div ng-if=\"vm.chartType===\'maturity\'\"><div ui-view=\"yc-chart-maturity\"></div></div><div ng-if=\"vm.chartType===\'time\'\"><div ui-view=\"yc-chart-time\"></div></div></div></div><!-- show this when no YCM rounds were found--><div class=\"panel-body\" ng-if=\"!vm.latestYcmRound || !vm.latestYcmRound.created\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"no-margin-bottom\">Yield Curve Chart</h3><h3 class=\"no-margin-top\"><small>Unavailable</small></h3></div></div><div style=\"padding-top: 10px\"><p>We didn\'t find anything to share with you in this section. Please contact OGResearch YCM team to get more information.</p></div></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/data_protection_policy/data_protection_policy.html","<div>Our Data Protection Policy you have accepted on {{vm.date_accepted | date:\'mediumDate\'}}<div ng-include=\"\'api/text_element/text?code=GDPR-text\'\"></div></div>");
$templateCache.put("app/account/password/password.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/account/register/register.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"register.title\">Registration</h1><!--<div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\">--><!--<strong>Registration saved!</strong> Please check your email for confirmation.--><!--</div>--><!--<div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\">--><!--<strong>Registration failed!</strong> Please try again later.--><!--</div>--><!--<div class=\"alert alert-danger\" ng-show=\"vm.policyNotAccepted\" translate=\"register.messages.error.accept\">--><!--<strong>You must accept the Data protection policy first!</strong> Please read the policy and accept it before continue.--><!--</div>--><!--<div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\">--><!--<strong>Login name already registered!</strong> Please choose another one.--><!--</div>--><!--<div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\">--><!--<strong>E-mail is already in use!</strong> Please choose another one.--><!--</div>--><!--<div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">--><!--The password and its confirmation do not match!--><!--</div>--></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-warning\" translate=\"global.messages.info.howtoregister\">Shall you want to access this web-site please <a href=\"mailto:it@ogresearch.com?subject=OGResearch YCM Portal: account registration request\">contact us</a></div><!--<form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"firstName\" translate=\"global.form.firstName\">First Name</label>--><!--<input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'global.form.firstName.placeholder\' | translate}}\"--><!--ng-model=\"vm.registerAccount.firstName\" ng-minlength=1 required>--><!--<div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\">--><!--<p class=\"help-block\"--><!--ng-show=\"form.firstName.$error.required\" translate=\"register.messages.validate.firstName.required\">--><!--Your first name is required.--><!--</p>--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.firstName.$error.minlength\" translate=\"register.messages.validate.firstName.minlength\">&ndash;&gt;--><!--&lt;!&ndash;Your username is required to be at least 1 character.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.firstName.$error.maxlength\" translate=\"register.messages.validate.firstName.maxlength\">&ndash;&gt;--><!--&lt;!&ndash;Your username cannot be longer than 50 characters.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.firstName.$error.pattern\" translate=\"register.messages.validate.firstName.pattern\">&ndash;&gt;--><!--&lt;!&ndash;Your username can only contain lower-case letters and digits.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"lastName\" translate=\"global.form.lastName\">Second Name</label>--><!--<input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'global.form.lastName.placeholder\' | translate}}\"--><!--ng-model=\"vm.registerAccount.lastName\" ng-minlength=1 required>--><!--<div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\">--><!--<p class=\"help-block\"--><!--ng-show=\"form.lastName.$error.required\" translate=\"register.messages.validate.lastName.required\">--><!--Your last name is required.--><!--</p>--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.lastName.minlength\">&ndash;&gt;--><!--&lt;!&ndash;Your username is required to be at least 1 character.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.lastName.maxlength\">&ndash;&gt;--><!--&lt;!&ndash;Your username cannot be longer than 50 characters.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.lastName.pattern\">&ndash;&gt;--><!--&lt;!&ndash;Your username can only contain lower-case letters and digits.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label>--><!--<input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\"--><!--ng-model=\"vm.registerAccount.login\" ng-minlength=1 ng-maxlength=50 ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required>--><!--<div ng-show=\"form.login.$dirty && form.login.$invalid\">--><!--<p class=\"help-block\"--><!--ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">--><!--Your username is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">--><!--Your username is required to be at least 1 character.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">--><!--Your username cannot be longer than 50 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">--><!--Your username can only contain lower-case letters and digits.--><!--</p>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label>--><!--<input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\"--><!--ng-model=\"vm.registerAccount.email\" ng-minlength=5 ng-maxlength=100 required>--><!--<div ng-show=\"form.email.$dirty && form.email.$invalid\">--><!--<p class=\"help-block\"--><!--ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">--><!--Your e-mail is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">--><!--Your e-mail is invalid.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">--><!--Your e-mail is required to be at least 5 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">--><!--Your e-mail cannot be longer than 100 characters.--><!--</p>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"company\" translate=\"global.form.company\">Company</label>--><!--<input type=\"text\" class=\"form-control\" id=\"company\" name=\"company\" placeholder=\"{{\'global.form.company.placeholder\' | translate}}\"--><!--ng-model=\"vm.registerAccount.company\" ng-minlength=1 required>--><!--<div ng-show=\"form.company.$dirty && form.company.$invalid\">--><!--<p class=\"help-block\"--><!--ng-show=\"form.company.$error.required\" translate=\"register.messages.validate.company.required\">--><!--Your company is required.--><!--</p>--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.company.$error.minlength\" translate=\"register.messages.validate.company.minlength\">&ndash;&gt;--><!--&lt;!&ndash;Your username is required to be at least 1 character.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.company.$error.maxlength\" translate=\"register.messages.validate.company.maxlength\">&ndash;&gt;--><!--&lt;!&ndash;Your username cannot be longer than 50 characters.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--&lt;!&ndash;<p class=\"help-block\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"form.company.$error.pattern\" translate=\"register.messages.validate.company.pattern\">&ndash;&gt;--><!--&lt;!&ndash;Your username can only contain lower-case letters and digits.&ndash;&gt;--><!--&lt;!&ndash;</p>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label>--><!--<input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\"--><!--ng-model=\"vm.registerAccount.password\" ng-minlength=4 ng-maxlength=50 required>--><!--<div ng-show=\"form.password.$dirty && form.password.$invalid\">--><!--<p class=\"help-block\"--><!--ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">--><!--Your password is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">--><!--Your password is required to be at least 4 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">--><!--Your password cannot be longer than 50 characters.--><!--</p>--><!--</div>--><!--<password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label>--><!--<input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\"--><!--ng-model=\"vm.confirmPassword\" ng-minlength=4 ng-maxlength=50 required>--><!--<div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\">--><!--<p class=\"help-block\"--><!--ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">--><!--Your confirmation password is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">--><!--Your confirmation password is required to be at least 4 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">--><!--Your confirmation password cannot be longer than 50 characters.--><!--</p>--><!--</div>--><!--</div>--><!--<h3 translate=\"register.title_gdpr\">General Data Protection Regulation (GDPR) policy</h3>--><!--<div class=\"form-group\">--><!--<textarea class=\"form-control\" rows=\"10\" id=\"comment\" readonly>--><!--Goal of the data protection policy--><!--The goal of the data protection policy is to depict the legal data protection aspects in one summarising document. It can also be used as the basis for statutory data protection inspections, e.g. by the customer within the scope of commissioned processing. This is not only to ensure compliance with the European General Data Protection Regulation (GDPR) but also to provide proof of compliance.--><!--Preamble--><!--Brief description of the company and motivation to comply with data protection.--><!--Security policy and responsibilities in the company--><!--•	For a company, in addition to existing corporate objectives, the highest data protection goals are to be defined and documented. Data protection goals are based on data protection principles and must be individually modified for every company.--><!--•	Determination of roles and responsibilities (e.g. representatives of the company, operational data protection officers, coordinators or data protection team and operational managers)--><!--•	Commitment to continuous improvement of a data protection management system--><!--•	Training, sensitisation and obligation of the employees--><!--Legal framework in the company--><!--•	Industry-specific legal or conduct regulations for handling personal data--><!--•	Requirements of internal and external parties--><!--•	Applicable laws, possibly with special local regulations--><!--Documentation--><!--•	Conducted internal and external inspections--><!--•	Data protection need: determination of protection need with regard to confidentiality, integrity and availability. The BSI Standard 100-2 categories from the German Federal Office for Information Security [Bundesamt für Sicherheit in der Informationstechnik – BSI] are helpful, e.g.: ‘normal’, ‘high’ and ‘very high’.--><!--Existing technical and organisational measures (TOM)--><!--Appropriate technical and organisational measures that must be implemented and substantiated, taking into account, inter alia, the purpose of the processing, the state of the technology and the implementation costs.--><!--The description of the implemented TOM can, for example, be based on the structure of ISO/IEC 27002, taking into account ISO/IEC 29151 (guidelines for the protection of personal data). The respective chapters should be substantiated by referencing the existing guidelines.--><!--Examples of such guidelines include:--><!--•	Guideline for the rights of data subjects--><!--•	Access control--><!--•	Information classification (and handling thereof)--><!--•	Physical and environmental-related security for end users such as:--><!--o	Permissible use of values--><!--o	Guideline for information transfer based on the work environment and screen locks--><!--o	Mobile devices and telecommuting--><!--o	Restriction of software installation and use--><!--•	Data backup--><!--•	Information transfer--><!--•	Protection against malware--><!--•	Handling technical weak points--><!--•	Cryptographic measures--><!--•	Communication security--><!--•	Privacy and protection of personal information--><!--•	Supplier relationships: Noting regular inspection and evaluation of data processing, especially the efficacy of the implemented technical and organisational measures.--><!--</textarea>--><!--</div>--><!--<div class=\"checkbox\" align=\"right\">--><!--<label><input type=\"checkbox\" required ng-model=\"vm.accept\">Accept</label>--><!--</div>--><!--<button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"register.form.button\">Register</button>--><!--</form>--></div></div></div>");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div>");
$templateCache.put("app/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filtered.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/logs/logs.html","<div class=\"table-responsive\"><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.ehcache.title\">Ehcache statistics</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.ehcache.cachename\">Cache name</th><th class=\"text-right\" translate=\"metrics.ehcache.objects\">Objects</th><th class=\"text-right\" translate=\"metrics.ehcache.hits\">Hits</th><th class=\"text-right\" translate=\"metrics.ehcache.misses\">Misses</th><th class=\"text-right\" translate=\"metrics.ehcache.evictioncount\">Eviction count</th><th class=\"text-right\" translate=\"metrics.ehcache.mean\">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.cachesStats\" ng-once><td>{{v.name}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/protection-policy/protection-policy.modal.html","<div class=\"modal-header\"><!--<button aria-label=\"Cancel\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span>--><h4 class=\"modal-title\" id=\"showProtectionPolicyLabel\">GDPR Data Protection Policy</h4>Please read through, scroll down and accept by pressing the Accept button.</div><div class=\"modal-body pad\"><!--<div ng-include=\"\'app/admin/protection-policy/protection-policy.text.html\'\"></div>--><div ng-include=\"\'api/text_element/text?code=GDPR-text\'\"></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.saveAcceptProtectionPolicy()\">Accept</button><!--<button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>--></div>");
$templateCache.put("app/admin/protection-policy/protection-policy.text.html","<h1>PRIVACY POLICY</h1><p>As of April 3rd 2019</p><p>OGResearch (“we”, “us” or “our”) respects your privacy and is committed to protecting your privacy when you use our Services. As “Services”, we collectively define the products, applications, tools, and features provided, including without limitation during free trials, on the YCM Portal platform <a href=\"https://ycm.ogresearch.com\">https://ycm.ogresearch.com</a>. This Privacy Policy describes what personal information we collect, what we do with it, how we secure it and informs you about your choices and rights.</p><p>By using the Services, you confirm that you have read, understood and agreed to this Privacy Policy.</p><h2>Collection and use of personal information</h2><p>When you make use of our proprietary online platform, the YCM Portal (hereinafter referred to as the Website), your personal information will be collected.</p><p>There are two main ways in which we obtain your personal information, which also determines how we use the personal information we obtain about you to:<ol><li>Your personal information is collected and processed when you register for a free trial or subscribe to our Services and make use of the Services available through our Website. This way we collect and process: e-mail address, first and last names, and company names (we require you to provide us with information for contractual or legal reasons). You provide this personal information directly when you create an account allowing you to access the Services provided on the Website (“Account”). We use the information we directly collect from you to only allow us to respond to customer service requests and to communicate with you about the status and updates to the Services (including sending e-mails with updates on our research products and our analytical outputs). You may visit the front page of our Website without giving away your personal information. However, to have the full access to the platform, you need to register or subscribe, and we collect your personal information as specified above.</li><li>We record some of it automatically when you use our Services sites (including with technologies like cookies or Google Analytics). When you visit our Website, we collect website and application usage information such as visited pages, time spent during the page visit, how far you scrolled on a webpage, how many times were particular documents downloaded. For this, we use cookies and Google Analytics, which collects the anonymous traffic data such as page visits and file downloads as mentioned above. We do not collect information such as your age, gender, interests, bank details or clickstream. The collected information is used to provide an overview of how registrants and subscribers are accessing and using the Website. The automatically collected information have statistical characteristics and are not confined to a specific user. We use the information we automatically collect from you to only allow us to better respond to the customer service requests and to improve our Services. We process your personal information for the above purposes when:<ul><li>You have consented to the use of your personal information in a particular way. When you consent, you can change your mind at any time.</li><li>We need your personal information to provide you with the Services requested by you, or to respond to service inquiries. For example, we need your email address, so you can sign in to your Account to use our Services on a trial basis or as a paying client.</li><li>We also have a legitimate interest in using your personal information to operate the YCM Portal business and provide you with tailored communications to develop and promote our Services and analytical capabilities, and also to anonymize and subsequently use anonymized information.</li></ul></li></ol></p><p>If you want to know, which of your personal information is held by OGResearch at any moment and how it is processed, please write to <a href=\"mailto:datacontroller@ogresearch.com\">datacontroller@ogresearch.com</a>.</p><h2>Your rights and choices</h2><p>Where the applicable law requires (and subject to any relevant exceptions under law), you may have the right to access, update, change or delete personal information.</p><p>In case you want to access, change, rectify, remove or erase your personal information, please write an e-mail to <a href=\"mailto:datacontroller@ogresearch.com\">datacontroller@ogresearch.com</a> where you specify your request. You do not need to specify a reason for such request. You can exercise your other rights (including deleting your Account) by contacting us at the same email address. You can also elect not to receive emailed notifications on the status and updates to the Services and other marketing communications by following the unsubscribe instruction in such communications.</p><p>You have the right to restrict or object to the processing of your personal information or to exercise a right to data portability under applicable law. You also have the right to lodge a complaint with a competent supervisory authority, which in our case is:</p><div id=\"uoou-address\" class=\"gdpr-address\"><b>The Office for Personal Data Protection</b><br>Pplk. Sochora 27<br>170 00 Praha 7<br>Czech Republic<br>Phone information: +420 234 665 111<br>Phone switchboard: +420 234 665 555<br>Email: <a href=\"posta@uoou.cz\">posta@uoou.cz</a></div><p>Additionally, if we rely on consent for the processing of your personal information, you have the right to withdraw it at any time and free of charge. When you do so, this will not affect the lawfulness of the processing before your consent withdrawal.</p><h2>How do we secure your information?</h2><p>We have taken steps to ensure that high standards of data protection are adhered to for all the forms of data processing mentioned in our privacy policy.</p><p>To maintain the safety of your personal information, we implement a variety of security measures when a user enters, submits, or accesses its information. Your personal information is contained behind secured networks, and it is only accessible by a limited number of persons who have special access rights to such systems and are required to keep the information confidential. In addition, all sensitive information you supply is encrypted via Secure Socket Layer (SSL) technology. We never ask for credit card numbers. We use regular Malware Scanning.</p><h2>How we retain your personal information?</h2><p>We retain personal information regarding you or your use of the Services for as long as your Account is active or for as long as needed to provide you with the Services. The precise periods for which we keep your personal information vary depending on the nature of the information and why we need it. As a user come back to us after an Account becomes inactive, we don’t immediately delete your personal information when your trial expires. Instead, we keep your personal information for a reasonable period of time, so it will be there for you if you come back. Please note that in the course of providing the Services, we collect and maintain aggregated, anonymized or de-personalized information which we may retain indefinitely.</p><h3>Cookie policy</h3><p>We also use cookies. Cookies are small pieces of text sent to your browser when you visit a site. They serve a variety of functions, like enabling us to remember certain information as you navigate between pages on our website and use the Services. We use cookies for the following purposes:<ul><li><b>Authentication, Personalization and Security:</b> Cookies help us verify your account and device and determine when you’re logged in, so we can make it easier for you to access the Services and provide the appropriate experiences and features. We also use cookies to help prevent fraudulent use of login credentials.</li><li><b>Third Parties:</b> Third Party Services may use cookies to help you sign into their services from our Services. We also use third party cookies, such as <a href=\"https://www.google.com/analytics\">Google Analytics</a>, to assist with analyzing performance. Any third-party cookie usage is governed by the privacy policy of the third party placing the cookie.</li><li><b>Opting Out:</b> You can set your browser to not accept cookies, but this may limit your ability to use the Services. We currently don’t respond to <a href=\"https://allaboutdnt.com\">DNT</a> signals from browsers visiting our Services. You can also follow these <a href=\"http://www.youronlinechoices.com/uk/five-top-tips\">five top tips</a> to help you manage your online privacy.</li></ul></p><h2>Changes to this statement</h2><p>From time to time, we may make changes to this Privacy Policy and Cookie Policy. This may be in relation to changes in the law, best practice or changes in our services. These changes will be reflected in this statement, and you will be presented with a request to accept a revised version of our Privacy Policy and Cookie Policy.</p><h2>How to contact us</h2><p>If you have questions, comments or complaints about this Privacy Policy or our privacy practices or if you would like to exercise your rights and choices, please email us at <a href=\"mailto:datacontroller@ogresearch.com\">datacontroller@ogresearch.com</a>, or write to us at the address below. Data Controller is OGResearch s.r.o. Contact information for the Data Controller:</p><div id=\"ogr-address\" class=\"gdpr-address\"><b>OGResearch s.r.o.</b><br>Havlíčkova 15<br>110 00, Praha 1<br>Czech Republic</div>");
$templateCache.put("app/admin/statistics/companies-statistics.html","<div><h2 translate=\"companies.statistics.title\">Users Statistics</h2><br><span translate=\"companies.statistics.filter\">Search</span> <input type=\"text\" ng-model=\"filter.$\" class=\"form-control\"><br><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th><span translate=\"companies.statistics.table.header.company\">Company</span></th><th><span translate=\"companies.statistics.table.header.eventType\">Event Type</span></th><th><span translate=\"companies.statistics.table.header.eventCount\">Event Count</span></th><th><span translate=\"companies.statistics.table.header.application\">Application</span></th></tr></thead><tr ng-repeat=\"statistic in filteredStatistics = (vm.statistics | filter:filter)\"><td><small>{{statistic.company}}</small></td><td><small>{{statistic.eventType}}</small></td><td><small>{{statistic.eventCount}}</small></td><td><small>{{statistic.application}}</small></td></tr></table></div>");
$templateCache.put("app/admin/statistics/statistics.html","<div><h2 translate=\"users.statistics.title\">Users Statistics</h2><br><span translate=\"users.statistics.filter\">Search</span> <input type=\"text\" ng-model=\"filter.$\" class=\"form-control\"><br><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th><span translate=\"users.statistics.table.header.login\">Login</span></th><th><span translate=\"users.statistics.table.header.firstName\">First Name</span></th><th><span translate=\"users.statistics.table.header.lastName\">Last Name</span></th><th><span translate=\"users.statistics.table.header.email\">E-mail</span></th><th><span translate=\"users.statistics.table.header.company\">Company</span></th><th><span translate=\"users.statistics.table.header.eventType\">Event Type</span></th><th><span translate=\"users.statistics.table.header.eventCount\">Event Count</span></th><th><span translate=\"users.statistics.table.header.application\">Application</span></th></tr></thead><tr ng-repeat=\"statistic in filteredStatistics = (vm.statistics | filter:filter)\"><td><small>{{statistic.login}}</small></td><td><small>{{statistic.firstName}}</small></td><td><small>{{statistic.lastName}}</small></td><td><small>{{statistic.email}}</small></td><td><small>{{statistic.company}}</small></td><td><small>{{statistic.eventType}}</small></td><td><small>{{statistic.eventCount}}</small></td><td><small>{{statistic.application}}</small></td></tr></table></div>");
$templateCache.put("app/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate=\"userManagement.email\">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate=\"userManagement.company\">Company</span></dt><dd>{{vm.user.company}}</dd><dt><span translate=\"userManagement.activated\">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate=\"userManagement.userGroup\">User Group</span></dt><dd>{{vm.user.groupName}}</dd><dt><span translate=\"userManagement.langKey\">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate=\"userManagement.createdBy\">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate=\"userManagement.createdDate\">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate=\"userManagement.profiles\">Profiles</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"authority in vm.user.authorities\"><span>{{authority}}</span></li></ul></dd></dl><button type=\"submit\" ui-sref=\"user-management\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.company\">Company</label><input type=\"company\" class=\"form-control\" name=\"company\" ng-model=\"vm.user.company\" required ng-maxlength=\"255\"></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group\"><label translate=\"userManagement.userGroup\">User Group</label><select class=\"form-control\" name=\"groupName\" ng-model=\"vm.user.groupName\" ng-options=\"groupName as groupName for groupName in vm.userGroups track by groupName\"></select></div><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" multiple=\"multiple\" name=\"authority\" ng-model=\"vm.user.authorities\" ng-options=\"authority for authority in vm.authorities\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-4\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div><br><span translate=\"userManagement.filter\">Search</span> <input type=\"text\" ng-model=\"filter.$\" class=\"form-control\"><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"login\"><span data-translate=\"userManagement.login\">Login</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"email\"><span data-translate=\"userManagement.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"company\"><span data-translate=\"userManagement.company\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th><th jh-sort-by=\"userGroup\"><span translate=\"userManagement.userGroup\">User Group</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"langKey\"><span data-translate=\"userManagement.langKey\">Lang Key</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"userManagement.profiles\">Profiles</span></th><th jh-sort-by=\"createdDate\"><span data-translate=\"userManagement.createdDate\">Created Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastModifiedBy\"><span data-translate=\"userManagement.lastModifiedBy\">Last Modified By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastModifiedDate\"><span data-translate=\"userManagement.lastModifiedDate\">Last Modified Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><!--<tr ng-repeat=\"user in filteredData = (vm.users | filter:filter) | limitTo:vm.itemsPerPage:vm.itemsPerPage*(vm.page-1)\">--><tr ng-repeat=\"user in filteredData = (vm.users | filter:filter)\"><td><a ui-sref=\"user-management-detail({login:user.login})\">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td>{{user.company}}</td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Deactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td><span class=\"label label-primary\">{{user.groupName}}</span></td><td>{{user.langKey}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-management-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!--<div class=\"text-center\">--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination>--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count>--><!--</div>--></div>");
$templateCache.put("app/components/login/login-inline.html","<div class=\"row\"><div class=\"col-md-12\"><h2 translate=\"login.title\">Sign in</h2></div><div class=\"col-md-12\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-12\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><!--        <div class=\"alert alert-warning\" translate=\"global.messages.info.howtoregister\" translate-compile>--><!--        </div>--></div></div>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"login.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><!--<div class=\"alert alert-warning\" translate=\"global.messages.info.register\" translate-compile>--><!--You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a>--><!--</div>--></div></div></div>");
$templateCache.put("app/components/yc-table/yc-table.html","<div class=\"yc-table-wrapper\" ng-if=\"tableData && tableData.rows && tableData.rows.length\"><div class=\"buttons-panel\"><button type=\"button\" title=\"Switch to YCM Chart Page\" class=\"btn btn-default btn-sm switch-view-btn\" ng-click=\"switchToChart()\"><img class=\"yc-chart-ico\" src=\"content/images/line-plot-ico.svg\" aria-label=\"go to chart\">&nbsp<span class=\"hidden-xs\">Switch to YCM Chart</span>&nbsp;&gt;</button> <button type=\"button\" title=\"Export current table to CSV\" class=\"btn btn-default btn-sm export-csv-btn\" ng-click=\"exportToCsv()\"><i class=\"fa fa-file-excel-o fa-fw\" aria-label=\"download file\"></i>&nbsp;<span class=\"hidden-xs\">Export Table</span></button> <button type=\"button\" title=\"Reset table to original values\" class=\"btn btn-default btn-sm reset-tbl-btn\" ng-if=\"!noRecalculate\" ng-click=\"resetTable()\"><i class=\"fa fa-undo fa-fw\" aria-label=\"download file\"></i>&nbsp;<span class=\"hidden-xs\">Reset Table</span></button> <button type=\"button\" title=\"Recalculate all rates based on user-supplied Zero Coupon Sharpe Ratios\" class=\"btn btn-default btn-sm recalculate-btn\" ng-if=\"!noRecalculate\" ng-class=\"{\'is-pending-recalculate\': getNotRecalculatedTenors().length > 0}\" ng-click=\"recalculate()\"><i class=\"fa fa-calculator fa-fw\" aria-label=\"recalculate\"></i>&nbsp;<span class=\"hidden-xs\">Recalculate</span></button> <button type=\"button\" class=\"btn btn-default btn-xs toggle-tenors-btn pull-right\" title=\"{{someTenorsHidden ? \'Expand the table showing all the tenors\' : \'Shrink the table hiding some tenors\'}}\" ng-show=\"hiddenTenorsDefined\" ng-click=\"toggleTenors()\"><i ng-class=\"someTenorsHidden ? \'fa fa-plus-square-o\' : \'fa fa-minus-square-o\'\" aria-label=\"show-hide columns\"></i>&nbsp;<span class=\"hidden-xs\">{{ someTenorsHidden ? \'Show all tenors\' : \'Hide extra tenors\' }}</span></button></div><div class=\"yc-table-values-wrapper\" ng-class=\"showUnitsCol ? \'\' : \'no-units-col\'\"><table class=\"yc-table\"><thead><tr><th class=\"yc-table-th yc-desc-th\" ng-dblclick=\"toggleDesc()\">Description&nbsp;<button type=\"button\" class=\"btn btn-default btn-xs toggle-desc-btn\" title=\"{{descHidden ? \'Show detailed descriptions\' : \'Hide detailed descriptions\'}}\" ng-click=\"toggleDesc()\"><i ng-class=\"descHidden ? \'fa fa-plus-square-o\' : \'fa fa-minus-square-o\'\" aria-label=\"show-hide descriptions\"></i></button></th><th class=\"yc-table-th yc-units-th\" ng-if=\"showUnitsCol\">Unit</th><th class=\"yc-table-th\" ng-class=\"{\'is-modified\':getModifiedTenors().includes(tnr)&&!tenorState[tnr].failed,\n                                \'is-pending-recalculate\':!tenorState[tnr].recalculated&&!tenorState[tnr].failed,\n                                \'is-failed\':tenorState[tnr].failed}\" ng-dblclick=\"toggleTenors()\" ng-repeat=\"tnr in activeTenors track by $index\">{{tnr}} <span ng-if=\"!tenorState[tnr].calculating && (getModifiedTenors().includes(tnr) || !tenorState[tnr].recalculated)\"><i class=\"fa fa-info-circle th-info-icon\" tooltip-class=\"tenor-info-tooltip\" uib-tooltip=\"{{(getModifiedTenors().includes(tnr) ? \'Modified\' : \'\')\n                                        +(!tenorState[tnr].recalculated\n                                        ? (tenorState[tnr].failed ? \', recalculation failed, please adjust Sharpe ratios\' : \', not recalculated yet\')\n                                        : \' and recalculated\')}}\"></i></span> <span ng-if=\"tenorState[tnr].calculating\"><i class=\"fa fa-spinner fa-pulse th-info-icon\"></i></span></th></tr></thead><tbody><tr class=\"yc-table-tr\" ng-class=\"{\'with-desc\': !descHidden, \'no-units-row\': !showUnitsRow}\" ng-repeat=\"row in tableData.rows track by $index\"><td class=\"yc-desc-td\" title=\"{{(tableData.rowTooltips && tableData.rowTooltips[$index]) ? tableData.rowTooltips[$index] : \'\' }}\"><div>{{tableData.rowHeaders[$index]}}</div><div class=\"yc-units-div\" ng-show=\"showUnitsRow\">{{tableData.rowUnits[$index]}}</div><div ng-hide=\"descHidden || !(tableData.rowTooltips && tableData.rowTooltips[$index])\" class=\"desc-detailed\" ng-class=\"showUnitsRow ? \'\' : \'no-units-row\'\">{{tableData.rowTooltips[$index]}}</div></td><td ng-if=\"showUnitsCol\" class=\"yc-units-td\"><div ng-bind-html=\"tableData.rowUnits[$index]\"></div></td><td ng-repeat=\"tnr in activeTenors track by $index\" class=\"yc-value-td\" ng-class=\"{\'calculating-now\': tenorState[tnr].calculating}\"><input class=\"yc-input form-control\" ng-class=\"{\'yc-end-blk-row\': row[tnr].isLastInBlock,\n                                        \'is-modified\': (row[tnr].value != origData.rows[$parent.$index][tnr].value) && !tenorState[tnr].failed,\n                                        \'is-pending-recalculate\': (tableData.rowIds[$parent.$index] == \'sharpe_ratio_zc\') && (row[tnr].value != origData.rows[$parent.$index][tnr].value) && !tenorState[tnr].recalculated && !tenorState[tnr].failed, \'is-failed\': tenorState[tnr].failed}\" ng-disabled=\"!row[tnr].isEditable || tenorState[tnr].calculating\" ng-model=\"row[tnr].value\" ng-change=\"onYcInputChanged($parent.$index, $index)\" input-rounding></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/application/application-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.application.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.application.delete.question\" translate-values=\"{id: \'{{vm.application.id}}\'}\">Are you sure you want to delete this Application?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/application/application-detail.html","<div><h2><span translate=\"portalApp.application.detail.title\">Application</span> {{vm.application.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.application.name\">Name</span></dt><dd><span>{{vm.application.name}}</span></dd><dt><span translate=\"portalApp.application.description\">Description</span></dt><dd><span>{{vm.application.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/application/application-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myApplicationLabel\" translate=\"portalApp.application.home.createOrEditLabel\">Create or edit a Application</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.application.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.application.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.application.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.application.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.application.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.application.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/application/applications.html","<div><h2 translate=\"portalApp.application.home.title\">Applications</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"application.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.application.home.createLabel\">Create new Application</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.application.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.application.name\">Name</span></th><th><span translate=\"portalApp.application.description\">Description</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"application in vm.applications track by application.id\"><td><a ui-sref=\"application-detail({id:application.id})\">{{application.id}}</a></td><td>{{application.name}}</td><td>{{application.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"application-detail({id:application.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"application.edit({id:application.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"application.delete({id:application.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/application-feature/application-feature-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.applicationFeature.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.applicationFeature.delete.question\" translate-values=\"{id: \'{{vm.applicationFeature.id}}\'}\">Are you sure you want to delete this ApplicationFeature?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/application-feature/application-feature-detail.html","<div><h2><span translate=\"portalApp.applicationFeature.detail.title\">ApplicationFeature</span> {{vm.applicationFeature.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.applicationFeature.applicationName\">Application Name</span></dt><dd><span>{{vm.applicationFeature.applicationName}}</span></dd><dt><span translate=\"portalApp.applicationFeature.featureName\">Feature Name</span></dt><dd><span>{{vm.applicationFeature.name}}</span></dd><dt><span translate=\"portalApp.applicationFeature.featureDescription\">Feature Description</span></dt><dd><span>{{vm.applicationFeature.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/application-feature/application-feature-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myApplicationFeatureLabel\" translate=\"portalApp.applicationFeature.home.createOrEditLabel\">Create or edit a ApplicationFeature</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.applicationFeature.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.applicationFeature.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.applicationFeature.applicationName\" for=\"field_name\">Application Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_applicationName\" ng-model=\"vm.applicationFeature.applicationName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.applicationFeature.featureName\" for=\"field_name\">Feature Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.applicationFeature.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.applicationFeature.featureDescription\" for=\"field_description\">Feature Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.applicationFeature.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/application-feature/application-features.html","<div><h2 translate=\"portalApp.applicationFeature.home.title\">ApplicationFeatures</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"application-feature.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.applicationFeature.home.createLabel\">Create new Application Feature</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.applicationFeature.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeature.applicationName\">Application Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeature.featureName\">Feature Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"portalApp.applicationFeature.featureDescription\">Feature Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"applicationFeature in vm.applications track by applicationFeature.id\"><td><a ui-sref=\"applicationFeature-detail({id:applicationFeature.id})\">{{applicationFeature.id}}</a></td><td>{{applicationFeature.applicationName}}</td><td>{{applicationFeature.name}}</td><td>{{applicationFeature.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"application-feature-detail({id:applicationFeature.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"application-feature.edit({id:applicationFeature.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"application-feature.delete({id:applicationFeature.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/application-feature-entity-map/application-feature-entity-map-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.applicationFeatureEntityMap.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.applicationFeatureEntityMap.delete.question\" translate-values=\"{id: \'{{vm.applicationFeatureEntityMap.id}}\'}\">Are you sure you want to delete this ApplicationFeatureEntityMap?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/application-feature-entity-map/application-feature-entity-map-detail.html","<div><h2><span translate=\"portalApp.applicationFeatureEntityMap.detail.title\">ApplicationFeatureEntityMap</span> {{vm.applicationFeatureEntityMap.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.applicationFeatureEntityMap.entityType\">Entity Type</span></dt><dd><span>{{vm.applicationFeatureEntityMap.entityType}}</span></dd><dt><span translate=\"portalApp.applicationFeatureEntityMap.entityKey\">Entity Key</span></dt><dd><span>{{vm.applicationFeatureEntityMap.entityKey}}</span></dd><dt><span translate=\"portalApp.applicationFeatureEntityMap.applicationName\">Application Name</span></dt><dd><span>{{vm.applicationFeatureEntityMap.applicationName}}</span></dd><dt><span translate=\"portalApp.applicationFeatureEntityMap.featureName\">Feature Name</span></dt><dd><span>{{vm.applicationFeatureEntityMap.applicationFeatureName}}</span></dd><dt><span translate=\"portalApp.applicationFeatureEntityMap.featureDescription\">Feature Description</span></dt><dd><span>{{vm.applicationFeatureEntityMap.applicationFeatureDescription}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/application-feature-entity-map/application-feature-entity-map-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myApplicationFeatureEntityMapLabel\" translate=\"portalApp.applicationFeatureEntityMap.home.createOrEditLabel\">Create or edit a ApplicationFeatureEntityMap</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.applicationFeatureEntityMap.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.applicationFeatureEntityMap.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.applicationFeatureEntityMap.entityType\" for=\"field_entityType\">Entity Type</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_entityType\" ng-model=\"vm.applicationFeatureEntityMap.entityType\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.applicationFeatureEntityMap.entityKey\" for=\"field_entityKey\">Entity Key</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_entityKey\" ng-model=\"vm.applicationFeatureEntityMap.entityKey\"></div><div class=\"form-group\"><label translate=\"portalApp.applicationFeatureEntityMap.featureName\">Application Feature</label><select class=\"form-control\" name=\"applicationFeatureName\" ng-model=\"vm.applicationFeatureEntityMap.applicationFeatureName\" ng-options=\'applicationFeature.name as (applicationFeature.name + \"     ( \" + applicationFeature.applicationName + \" )\") for applicationFeature in vm.applicationFeatures\'></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/application-feature-entity-map/application-feature-entity-map.html","<div><h2 translate=\"portalApp.applicationFeatureEntityMap.home.title\">ApplicationFeatureEntityMaps</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"application-feature-entity-map.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.applicationFeatureEntityMap.home.createLabel\">Create new Application Feature</span></button></div><div class=\"col-xs-8 no-padding-right\"><!--<form name=\"searchForm\" class=\"form-inline\">--><!--<div class=\"input-group pull-right\" >--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.applicationFeatureEntityMap.home.search\' | translate }}\">--><!--<span  class=\"input-group-btn width-min\" >--><!--<button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--</button>--><!--</span>--><!--<span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\">--><!--<button class=\"btn btn-info\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-trash\"></span>--><!--</button>--><!--</span>--><!--</div>--><!--</form>--></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureEntityMap.entityType\">Entity Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureEntityMap.entityKey\">Entity Key</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureEntityMap.applicationName\">Application Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureEntityMap.featureName\">Feature Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"portalApp.applicationFeatureEntityMap.featureDescription\">Feature Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"applicationFeatureEntityMap in vm.applications track by applicationFeatureEntityMap.id\"><td><a ui-sref=\"applicationFeatureEntityMap-detail({id:applicationFeatureEntityMap.id})\">{{applicationFeatureEntityMap.id}}</a></td><td>{{applicationFeatureEntityMap.entityType}}</td><td>{{applicationFeatureEntityMap.entityKey}}</td><td>{{applicationFeatureEntityMap.applicationName}}</td><td>{{applicationFeatureEntityMap.applicationFeatureName}}</td><td>{{applicationFeatureEntityMap.applicationFeatureDescription}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"application-feature-entity-map-detail({id:applicationFeatureEntityMap.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"application-feature-entity-map.edit({id:applicationFeatureEntityMap.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"application-feature-entity-map.delete({id:applicationFeatureEntityMap.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/country/countries.html","<div><h2 translate=\"portalApp.country.home.title\">Countries</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"country.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.country.home.createLabel\">Create new Country</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.country.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.reset()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.country.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"portalApp.country.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"portalApp.country.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"vm.page >= vm.links[\'last\']\"><tr ng-repeat=\"country in vm.countries track by country.id\"><td><a ui-sref=\"country-detail({id:country.id})\">{{country.id}}</a></td><td>{{country.name}}</td><td>{{country.code}}</td><td>{{country.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"country-detail({id:country.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"country.edit({id:country.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"country.delete({id:country.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/country/country-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.country.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.country.delete.question\" translate-values=\"{id: \'{{vm.country.id}}\'}\">Are you sure you want to delete this Country?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/country/country-detail.html","<div><h2><span translate=\"portalApp.country.detail.title\">Country</span> {{vm.country.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.country.name\">Name</span></dt><dd><span>{{vm.country.name}}</span></dd><dt><span translate=\"portalApp.country.code\">Code</span></dt><dd><span>{{vm.country.code}}</span></dd><dt><span translate=\"portalApp.country.description\">Description</span></dt><dd><span>{{vm.country.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/country/country-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCountryLabel\" translate=\"portalApp.country.home.createOrEditLabel\">Create or edit a Country</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.country.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.country.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.country.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.country.name\" ng-maxlength=\"250\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"250\">This field cannot be longer than 250 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.country.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.country.code\" ng-maxlength=\"3\"><div ng-show=\"editForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"3\">This field cannot be longer than 3 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.country.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.country.description\" ng-maxlength=\"250\"><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"250\">This field cannot be longer than 250 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/application-feature-user-group-map/application-feature-user-group-map-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.applicationFeatureUserGroupMap.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.applicationFeatureUserGroupMap.delete.question\" translate-values=\"{id: \'{{vm.applicationFeatureUserGroupMap.id}}\'}\">Are you sure you want to delete this ApplicationFeatureUserGroupMap?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/application-feature-user-group-map/application-feature-user-group-map-detail.html","<div><h2><span translate=\"portalApp.applicationFeatureUserGroupMap.detail.title\">ApplicationFeatureUserGroupMap</span> {{vm.applicationFeatureUserGroupMap.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.applicationFeatureUserGroupMap.userGroupId\">User Group ID</span></dt><dd><span>{{vm.applicationFeatureUserGroupMap.userGroupId}}</span></dd><dt><span translate=\"portalApp.applicationFeatureUserGroupMap.userGroupName\">User Group Name</span></dt><dd><span>{{vm.applicationFeatureUserGroupMap.userGroupName}}</span></dd><dt><span translate=\"portalApp.applicationFeatureUserGroupMap.applicationName\">Application Name</span></dt><dd><span>{{vm.applicationFeatureUserGroupMap.applicationName}}</span></dd><dt><span translate=\"portalApp.applicationFeatureUserGroupMap.featureName\">Feature Name</span></dt><dd><span>{{vm.applicationFeatureUserGroupMap.applicationFeatureName}}</span></dd><dt><span translate=\"portalApp.applicationFeatureUserGroupMap.featureDescription\">Feature Description</span></dt><dd><span>{{vm.applicationFeatureUserGroupMap.applicationFeatureDescription}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/application-feature-user-group-map/application-feature-user-group-map-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myApplicationFeatureUserGroupMapLabel\" translate=\"portalApp.applicationFeatureUserGroupMap.home.createOrEditLabel\">Create or edit a ApplicationFeatureUserGroupMap</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.applicationFeatureUserGroupMap.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.applicationFeatureUserGroupMap.id\" readonly=\"readonly\"></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"portalApp.applicationFeatureUserGroupMap.userGroupName\" for=\"field_name\">User Group Name</label>--><!--<input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_userGroupName\"--><!--ng-model=\"vm.applicationFeatureUserGroupMap.userGroupName\"--><!--/>--><!--</div>--><div class=\"form-group\"><label translate=\"portalApp.applicationFeatureUserGroupMap.userGroupName\">User Group</label><select class=\"form-control\" name=\"groupName\" ng-model=\"vm.applicationFeatureUserGroupMap.userGroupName\" ng-options=\"groupName as groupName for groupName in vm.userGroups track by groupName\"></select></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"portalApp.applicationFeatureUserGroupMap.applicationName\" for=\"field_name\">Application Name</label>--><!--<input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_applicationName\"--><!--ng-model=\"vm.applicationFeatureUserGroupMap.applicationName\"--><!--/>--><!--</div>--><div class=\"form-group\"><label translate=\"portalApp.applicationFeatureUserGroupMap.featureName\">Application Feature</label><select class=\"form-control\" name=\"applicationFeatureName\" ng-model=\"vm.applicationFeatureUserGroupMap.applicationFeatureName\" ng-options=\'applicationFeature.name as (applicationFeature.name + \"     ( \" + applicationFeature.applicationName + \" )\") for applicationFeature in vm.applicationFeatures\'></select></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"portalApp.applicationFeatureUserGroupMap.featureName\" for=\"field_name\">Feature Name</label>--><!--<input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\"--><!--ng-model=\"vm.applicationFeatureUserGroupMap.applicationFeatureName\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"portalApp.applicationFeatureUserGroupMap.featureDescription\" for=\"field_description\">Feature Description</label>--><!--<input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_applicationFeatureDescription\"--><!--ng-model=\"vm.applicationFeatureUserGroupMap.applicationFeatureDescription\"--><!--/>--><!--</div>--></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/application-feature-user-group-map/application-feature-user-group-map.html","<div><h2 translate=\"portalApp.applicationFeatureUserGroupMap.home.title\">ApplicationFeatureUserGroupMaps</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"application-feature-user-group-map.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.applicationFeatureUserGroupMap.home.createLabel\">Create new Application Feature</span></button></div><div class=\"col-xs-8 no-padding-right\"><!--<form name=\"searchForm\" class=\"form-inline\">--><!--<div class=\"input-group pull-right\" >--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.applicationFeatureUserGroupMap.home.search\' | translate }}\">--><!--<span  class=\"input-group-btn width-min\" >--><!--<button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--</button>--><!--</span>--><!--<span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\">--><!--<button class=\"btn btn-info\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-trash\"></span>--><!--</button>--><!--</span>--><!--</div>--><!--</form>--></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureUserGroupMap.userGroupId\">User Group ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureUserGroupMap.userGroupName\">User Group Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureUserGroupMap.applicationName\">Application Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.applicationFeatureUserGroupMap.featureName\">Feature Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"portalApp.applicationFeatureUserGroupMap.featureDescription\">Feature Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"applicationFeatureUserGroupMap in vm.applications track by applicationFeatureUserGroupMap.id\"><td><a ui-sref=\"applicationFeatureUserGroupMap-detail({id:applicationFeatureUserGroupMap.id})\">{{applicationFeatureUserGroupMap.id}}</a></td><td>{{applicationFeatureUserGroupMap.userGroupId}}</td><td>{{applicationFeatureUserGroupMap.userGroupName}}</td><td>{{applicationFeatureUserGroupMap.applicationName}}</td><td>{{applicationFeatureUserGroupMap.applicationFeatureName}}</td><td>{{applicationFeatureUserGroupMap.applicationFeatureDescription}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"application-feature-user-group-map-detail({id:applicationFeatureUserGroupMap.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"application-feature-user-group-map.edit({id:applicationFeatureUserGroupMap.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"application-feature-user-group-map.delete({id:applicationFeatureUserGroupMap.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/currency/currencies.html","<div><h2 translate=\"portalApp.currency.home.title\">Currencies</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"currency.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.currency.home.createLabel\">Create new Currency</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.currency.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.currency.code\">Code</span></th><th><span translate=\"portalApp.currency.name\">Name</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"currency in vm.currencies track by currency.id\"><td><a ui-sref=\"currency-detail({id:currency.id})\">{{currency.id}}</a></td><td>{{currency.code}}</td><td>{{currency.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"currency-detail({id:currency.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"currency.edit({id:currency.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"currency.delete({id:currency.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/currency/currency-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.currency.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.currency.delete.question\" translate-values=\"{id: \'{{vm.currency.id}}\'}\">Are you sure you want to delete this Currency?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/currency/currency-detail.html","<div><h2><span translate=\"portalApp.currency.detail.title\">Currency</span> {{vm.currency.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.currency.code\">Code</span></dt><dd><span>{{vm.currency.code}}</span></dd><dt><span translate=\"portalApp.currency.name\">Name</span></dt><dd><span>{{vm.currency.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/currency/currency-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCurrencyLabel\" translate=\"portalApp.currency.home.createOrEditLabel\">Create or edit a Currency</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.currency.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.currency.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.currency.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.currency.code\" ng-maxlength=\"3\"><div ng-show=\"editForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"3\">This field cannot be longer than 3 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.currency.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.currency.name\" ng-maxlength=\"250\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"250\">This field cannot be longer than 250 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/currency-journal/currency-journal-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.currencyJournal.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.currencyJournal.delete.question\" translate-values=\"{id: \'{{vm.currencyJournal.id}}\'}\">Are you sure you want to delete this Currency Journal?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/currency-journal/currency-journal-detail.html","<div><h2><span translate=\"portalApp.currencyJournal.detail.title\">Currency Journal</span> {{vm.currencyJournal.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.currencyJournal.activeFrom\">Active From</span></dt><dd><span>{{vm.currencyJournal.activeFrom | date:\'mediumDate\'}}</span></dd><dt><span translate=\"portalApp.currencyJournal.activeUntil\">Active Until</span></dt><dd><span>{{vm.currencyJournal.activeUntil | date:\'mediumDate\'}}</span></dd><dt><span translate=\"portalApp.currencyJournal.currency\">Currency</span></dt><dd><a ui-sref=\"currency-detail({id:vm.currencyJournal.currencyId})\">{{vm.currencyJournal.currencyName}}</a></dd><dt><span translate=\"portalApp.currencyJournal.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.currencyJournal.countryId})\">{{vm.currencyJournal.countryName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/currency-journal/currency-journal-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCurrencyJournalLabel\" translate=\"portalApp.currencyJournal.home.createOrEditLabel\">Create or edit a Currency Journal</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.currencyJournal.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.currencyJournal.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.currencyJournal.activeFrom\" for=\"field_activeFrom\">Active From</label><div class=\"input-group\"><input id=\"field_activeFrom\" type=\"text\" class=\"form-control\" name=\"activeFrom\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.currencyJournal.activeFrom\" is-open=\"vm.datePickerOpenStatus.activeFrom\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'activeFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.currencyJournal.activeUntil\" for=\"field_activeUntil\">Active Until</label><div class=\"input-group\"><input id=\"field_activeUntil\" type=\"text\" class=\"form-control\" name=\"activeUntil\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.currencyJournal.activeUntil\" is-open=\"vm.datePickerOpenStatus.activeUntil\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'activeUntil\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"portalApp.currencyJournal.currency\" for=\"field_currency\">Currency</label><select class=\"form-control\" id=\"field_currency\" name=\"currency\" ng-model=\"vm.currencyJournal.currencyId\" ng-options=\"currency.id as currency.name for currency in vm.currencies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.currencyJournal.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.currencyJournal.countryId\" ng-options=\"country.id as country.name for country in vm.countries\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/currency-journal/currency-journals.html","<div><h2 translate=\"portalApp.currencyJournal.home.title\">Currency Journals</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"currency-journal.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.currencyJournal.home.createLabel\">Create new Currency Journal</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.currencyJournal.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.currencyJournal.activeFrom\">Active From</span></th><th><span translate=\"portalApp.currencyJournal.activeUntil\">Active Until</span></th><th><span translate=\"portalApp.currencyJournal.currency\">Currency</span></th><th><span translate=\"portalApp.currencyJournal.country\">Country</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"currencyJournal in vm.currencyJournals track by currencyJournal.id\"><td><a ui-sref=\"currency-journal-detail({id:currencyJournal.id})\">{{currencyJournal.id}}</a></td><td>{{currencyJournal.activeFrom | date:\'mediumDate\'}}</td><td>{{currencyJournal.activeUntil | date:\'mediumDate\'}}</td><td><a ui-sref=\"currency-detail({id:currencyJournal.currencyId})\">{{currencyJournal.currencyName}}</a></td><td><a ui-sref=\"country-detail({id:currencyJournal.countryId})\">{{currencyJournal.countryName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"currency-journal-detail({id:currencyJournal.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"currency-journal.edit({id:currencyJournal.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"currency-journal.delete({id:currencyJournal.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/frequency/frequencies.html","<div><h2 translate=\"portalApp.frequency.home.title\">Frequencies</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"frequency.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.frequency.home.createLabel\">Create new Frequency</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.frequency.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.frequency.value\">Value</span></th><th><span translate=\"portalApp.frequency.description\">Description</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"frequency in vm.frequencies track by frequency.id\"><td><a ui-sref=\"frequency-detail({id:frequency.id})\">{{frequency.id}}</a></td><td>{{frequency.value}}</td><td>{{frequency.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"frequency-detail({id:frequency.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"frequency.edit({id:frequency.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"frequency.delete({id:frequency.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/frequency/frequency-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.frequency.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.frequency.delete.question\" translate-values=\"{id: \'{{vm.frequency.id}}\'}\">Are you sure you want to delete this Frequency?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/frequency/frequency-detail.html","<div><h2><span translate=\"portalApp.frequency.detail.title\">Frequency</span> {{vm.frequency.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.frequency.value\">Value</span></dt><dd><span>{{vm.frequency.value}}</span></dd><dt><span translate=\"portalApp.frequency.description\">Description</span></dt><dd><span>{{vm.frequency.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/frequency/frequency-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFrequencyLabel\" translate=\"portalApp.frequency.home.createOrEditLabel\">Create or edit a Frequency</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.frequency.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.frequency.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.frequency.value\" for=\"field_value\">Value</label><input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.frequency.value\" ng-maxlength=\"63\"><div ng-show=\"editForm.value.$invalid\"><p class=\"help-block\" ng-show=\"editForm.value.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"63\">This field cannot be longer than 63 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.frequency.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.frequency.description\" ng-maxlength=\"250\"><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"250\">This field cannot be longer than 250 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/model/model-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.model.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.model.delete.question\" translate-values=\"{id: \'{{vm.model.id}}\'}\">Are you sure you want to delete this Model?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/model/model-detail.html","<div><h2><span translate=\"portalApp.model.detail.title\">Model</span> {{vm.model.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.model.name\">Name</span></dt><dd><span>{{vm.model.name}}</span></dd><dt><span translate=\"portalApp.model.description\">Description</span></dt><dd><span>{{vm.model.description}}</span></dd><dt><span translate=\"portalApp.model.isLinear\">Is Linear</span></dt><dd><span>{{vm.model.isLinear}}</span></dd><dt><span translate=\"portalApp.model.frequency\">Frequency</span></dt><dd><a ui-sref=\"frequency-detail({id:vm.model.frequencyId})\">{{vm.model.frequencyValue}}</a></dd><dt><span translate=\"portalApp.model.round\">Round</span></dt><dd><a ui-sref=\"round-detail({id:vm.model.roundId})\">{{vm.model.roundRoundCode}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/model/model-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myModelLabel\" translate=\"portalApp.model.home.createOrEditLabel\">Create or edit a Model</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.model.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.model.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.model.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.model.name\" ng-maxlength=\"128\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.model.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.model.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.model.isLinear\" for=\"field_isLinear\">Is Linear</label><input type=\"checkbox\" class=\"form-control\" name=\"isLinear\" id=\"field_isLinear\" ng-model=\"vm.model.isLinear\"></div><div class=\"form-group\"><label translate=\"portalApp.model.frequency\" for=\"field_frequency\">Frequency</label><select class=\"form-control\" id=\"field_frequency\" name=\"frequency\" ng-model=\"vm.model.frequencyId\" ng-options=\"frequency.id as frequency.value for frequency in vm.frequencies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.model.round\" for=\"field_round\">Round</label><select class=\"form-control\" id=\"field_round\" name=\"round\" ng-model=\"vm.model.roundId\" ng-options=\"round.id as round.roundCode for round in vm.rounds | orderBy:\'id\'\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/model/models.html","<div><h2 translate=\"portalApp.model.home.title\">Models</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"model.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.model.home.createLabel\">Create new Model</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.model.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.model.name\">Name</span></th><th><span translate=\"portalApp.model.description\">Description</span></th><th><span translate=\"portalApp.model.isLinear\">Is Linear</span></th><th><span translate=\"portalApp.model.frequency\">Frequency</span></th><th><span translate=\"portalApp.model.round\">Round</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models track by model.id\"><td><a ui-sref=\"model-detail({id:model.id})\">{{model.id}}</a></td><td>{{model.name}}</td><td>{{model.description}}</td><td>{{model.isLinear}}</td><td><a ui-sref=\"frequency-detail({id:model.frequencyId})\">{{model.frequencyValue}}</a></td><td><a ui-sref=\"round-detail({id:model.roundId})\">{{model.roundRoundCode}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"model-detail({id:model.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"model.edit({id:model.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"model.delete({id:model.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/model-equation/model-equation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.modelEquation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.modelEquation.delete.question\" translate-values=\"{id: \'{{vm.modelEquation.id}}\'}\">Are you sure you want to delete this Model Equation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/model-equation/model-equation-detail.html","<div><h2><span translate=\"portalApp.modelEquation.detail.title\">Model Equation</span> {{vm.modelEquation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.modelEquation.expression\">Expression</span></dt><dd><span>{{vm.modelEquation.expression}}</span></dd><dt><span translate=\"portalApp.modelEquation.label\">Label</span></dt><dd><span>{{vm.modelEquation.label}}</span></dd><dt><span translate=\"portalApp.modelEquation.isMeasurement\">Is Measurement</span></dt><dd><span>{{vm.modelEquation.isMeasurement}}</span></dd><dt><span translate=\"portalApp.modelEquation.model\">Model</span></dt><dd><a ui-sref=\"model-detail({id:vm.modelEquation.modelId})\">{{vm.modelEquation.modelName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/model-equation/model-equation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myModelEquationLabel\" translate=\"portalApp.modelEquation.home.createOrEditLabel\">Create or edit a Model Equation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.modelEquation.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.modelEquation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelEquation.expression\" for=\"field_expression\">Expression</label><input type=\"text\" class=\"form-control\" name=\"expression\" id=\"field_expression\" ng-model=\"vm.modelEquation.expression\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelEquation.label\" for=\"field_label\">Label</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.modelEquation.label\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelEquation.isMeasurement\" for=\"field_isMeasurement\">Is Measurement</label><input type=\"checkbox\" class=\"form-control\" name=\"isMeasurement\" id=\"field_isMeasurement\" ng-model=\"vm.modelEquation.isMeasurement\"></div><div class=\"form-group\"><label translate=\"portalApp.modelEquation.model\" for=\"field_model\">Model</label><select class=\"form-control\" id=\"field_model\" name=\"model\" ng-model=\"vm.modelEquation.modelId\" ng-options=\"model.id as model.name for model in vm.models\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/model-equation/model-equations.html","<div><h2 translate=\"portalApp.modelEquation.home.title\">Model Equations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"model-equation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.modelEquation.home.createLabel\">Create new Model Equation</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.modelEquation.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expression\"><span translate=\"portalApp.modelEquation.expression\">Expression</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"portalApp.modelEquation.label\">Label</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isMeasurement\"><span translate=\"portalApp.modelEquation.isMeasurement\">Is Measurement</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"modelName\"><span translate=\"portalApp.modelEquation.model\">Model</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"modelEquation in vm.modelEquations track by modelEquation.id\"><td><a ui-sref=\"model-equation-detail({id:modelEquation.id})\">{{modelEquation.id}}</a></td><td>{{modelEquation.expression}}</td><td>{{modelEquation.label}}</td><td>{{modelEquation.isMeasurement}}</td><td><a ui-sref=\"model-detail({id:modelEquation.modelId})\">{{modelEquation.modelName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"model-equation-detail({id:modelEquation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"model-equation.edit({id:modelEquation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"model-equation.delete({id:modelEquation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/model-symbol/model-symbol-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.modelSymbol.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.modelSymbol.delete.question\" translate-values=\"{id: \'{{vm.modelSymbol.id}}\'}\">Are you sure you want to delete this Model Symbol?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/model-symbol/model-symbol-detail.html","<div><h2><span translate=\"portalApp.modelSymbol.detail.title\">Model Symbol</span> {{vm.modelSymbol.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.modelSymbol.name\">Name</span></dt><dd><span>{{vm.modelSymbol.name}}</span></dd><dt><span translate=\"portalApp.modelSymbol.unit\">Unit</span></dt><dd><span>{{vm.modelSymbol.unit}}</span></dd><dt><span translate=\"portalApp.modelSymbol.label\">Label</span></dt><dd><span>{{vm.modelSymbol.label}}</span></dd><dt><span translate=\"portalApp.modelSymbol.latexAlias\">Latex Alias</span></dt><dd><span>{{vm.modelSymbol.latexAlias}}</span></dd><dt><span translate=\"portalApp.modelSymbol.isAdditive\">Is Additive</span></dt><dd><span>{{vm.modelSymbol.isAdditive}}</span></dd><dt><span translate=\"portalApp.modelSymbol.isMeasurement\">Is Measurement</span></dt><dd><span>{{vm.modelSymbol.isMeasurement}}</span></dd><dt><span translate=\"portalApp.modelSymbol.value\">Value</span></dt><dd><span>{{vm.modelSymbol.value}}</span></dd><dt><span translate=\"portalApp.modelSymbol.valueTrend\">Value Trend</span></dt><dd><span>{{vm.modelSymbol.valueTrend}}</span></dd><dt><span translate=\"portalApp.modelSymbol.symbolType\">Symbol Type</span></dt><dd><span translate=\"{{\'portalApp.ModelSymbolType.\' + vm.modelSymbol.symbolType}}\">{{vm.modelSymbol.symbolType}}</span></dd><dt><span translate=\"portalApp.modelSymbol.labelShort\">Label Short</span></dt><dd><span>{{vm.modelSymbol.labelShort}}</span></dd><dt><span translate=\"portalApp.modelSymbol.shock_peer_id\">Shock Peer Id</span></dt><dd><span>{{vm.modelSymbol.shock_peer_id}}</span></dd><dt><span translate=\"portalApp.modelSymbol.model\">Model</span></dt><dd><a ui-sref=\"model-detail({id:vm.modelSymbol.modelId})\">{{vm.modelSymbol.modelName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/model-symbol/model-symbol-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myModelSymbolLabel\" translate=\"portalApp.modelSymbol.home.createOrEditLabel\">Create or edit a Model Symbol</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.modelSymbol.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.modelSymbol.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.modelSymbol.name\" ng-maxlength=\"256\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.unit\" for=\"field_unit\">Unit</label><input type=\"text\" class=\"form-control\" name=\"unit\" id=\"field_unit\" ng-model=\"vm.modelSymbol.unit\" ng-maxlength=\"64\"><div ng-show=\"editForm.unit.$invalid\"><p class=\"help-block\" ng-show=\"editForm.unit.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.label\" for=\"field_label\">Label</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.modelSymbol.label\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.latexAlias\" for=\"field_latexAlias\">Latex Alias</label><input type=\"text\" class=\"form-control\" name=\"latexAlias\" id=\"field_latexAlias\" ng-model=\"vm.modelSymbol.latexAlias\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.isAdditive\" for=\"field_isAdditive\">Is Additive</label><input type=\"checkbox\" class=\"form-control\" name=\"isAdditive\" id=\"field_isAdditive\" ng-model=\"vm.modelSymbol.isAdditive\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.isMeasurement\" for=\"field_isMeasurement\">Is Measurement</label><input type=\"checkbox\" class=\"form-control\" name=\"isMeasurement\" id=\"field_isMeasurement\" ng-model=\"vm.modelSymbol.isMeasurement\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.modelSymbol.value\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.valueTrend\" for=\"field_valueTrend\">Value Trend</label><input type=\"number\" class=\"form-control\" name=\"valueTrend\" id=\"field_valueTrend\" ng-model=\"vm.modelSymbol.valueTrend\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.symbolType\" for=\"field_symbolType\">Symbol Type</label><select class=\"form-control\" name=\"symbolType\" ng-model=\"vm.modelSymbol.symbolType\" id=\"field_symbolType\"><option value=\"ENDOGENOUS\" translate=\"portalApp.ModelSymbolType.ENDOGENOUS\">ENDOGENOUS</option><option value=\"SHOCK\" translate=\"portalApp.ModelSymbolType.SHOCK\">SHOCK</option><option value=\"PARAMETER\" translate=\"portalApp.ModelSymbolType.PARAMETER\">PARAMETER</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.labelShort\" for=\"field_labelShort\">Label Short</label><input type=\"text\" class=\"form-control\" name=\"labelShort\" id=\"field_labelShort\" ng-model=\"vm.modelSymbol.labelShort\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.modelSymbol.shock_peer_id\" for=\"field_shock_peer_id\">Shock Peer Id</label><input type=\"number\" class=\"form-control\" name=\"shock_peer_id\" id=\"field_shock_peer_id\" ng-model=\"vm.modelSymbol.shock_peer_id\"></div><div class=\"form-group\"><label translate=\"portalApp.modelSymbol.model\" for=\"field_model\">Model</label><select class=\"form-control\" id=\"field_model\" name=\"model\" ng-model=\"vm.modelSymbol.modelId\" ng-options=\"model.id as model.name for model in vm.models\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/model-symbol/model-symbols.html","<div><h2 translate=\"portalApp.modelSymbol.home.title\">Model Symbols</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"model-symbol.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.modelSymbol.home.createLabel\">Create new Model Symbol</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.modelSymbol.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.modelSymbol.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"unit\"><span translate=\"portalApp.modelSymbol.unit\">Unit</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"portalApp.modelSymbol.label\">Label</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latexAlias\"><span translate=\"portalApp.modelSymbol.latexAlias\">Latex Alias</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isAdditive\"><span translate=\"portalApp.modelSymbol.isAdditive\">Is Additive</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isMeasurement\"><span translate=\"portalApp.modelSymbol.isMeasurement\">Is Measurement</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"portalApp.modelSymbol.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"valueTrend\"><span translate=\"portalApp.modelSymbol.valueTrend\">Value Trend</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"symbolType\"><span translate=\"portalApp.modelSymbol.symbolType\">Symbol Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"labelShort\"><span translate=\"portalApp.modelSymbol.labelShort\">Label Short</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shock_peer_id\"><span translate=\"portalApp.modelSymbol.shock_peer_id\">Shock Peer Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"modelName\"><span translate=\"portalApp.modelSymbol.model\">Model</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"modelSymbol in vm.modelSymbols track by modelSymbol.id\"><td><a ui-sref=\"model-symbol-detail({id:modelSymbol.id})\">{{modelSymbol.id}}</a></td><td>{{modelSymbol.name}}</td><td>{{modelSymbol.unit}}</td><td>{{modelSymbol.label}}</td><td>{{modelSymbol.latexAlias}}</td><td>{{modelSymbol.isAdditive}}</td><td>{{modelSymbol.isMeasurement}}</td><td>{{modelSymbol.value}}</td><td>{{modelSymbol.valueTrend}}</td><td translate=\"{{\'portalApp.ModelSymbolType.\' + modelSymbol.symbolType}}\">{{modelSymbol.symbolType}}</td><td>{{modelSymbol.labelShort}}</td><td>{{modelSymbol.shock_peer_id}}</td><td><a ui-sref=\"model-detail({id:modelSymbol.modelId})\">{{modelSymbol.modelName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"model-symbol-detail({id:modelSymbol.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"model-symbol.edit({id:modelSymbol.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"model-symbol.delete({id:modelSymbol.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/product/product-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.product.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.product.delete.question\" translate-values=\"{id: \'{{vm.product.id}}\'}\">Are you sure you want to delete this Product?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product/product-detail.html","<div><h2><span translate=\"portalApp.product.detail.title\">Product</span> {{vm.product.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.product.name\">Name</span></dt><dd><span>{{vm.product.name}}</span></dd><dt><span translate=\"portalApp.product.code\">Code</span></dt><dd><span>{{vm.product.code}}</span></dd><dt><span translate=\"portalApp.product.description\">Description</span></dt><dd><span>{{vm.product.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product/product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductLabel\" translate=\"portalApp.product.home.createOrEditLabel\">Create or edit a Product</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.product.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.product.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.product.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.product.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.product.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.product.code\" ng-maxlength=\"15\"><div ng-show=\"editForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"15\">This field cannot be longer than 15 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.product.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.product.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product/products.html","<div><h2 translate=\"portalApp.product.home.title\">Products</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.product.home.createLabel\">Create new Product</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.product.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.product.name\">Name</span></th><th><span translate=\"portalApp.product.code\">Code</span></th><th><span translate=\"portalApp.product.description\">Description</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"product in vm.products track by product.id\"><td><a ui-sref=\"product-detail({id:product.id})\">{{product.id}}</a></td><td>{{product.name}}</td><td>{{product.code}}</td><td>{{product.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-detail({id:product.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product.edit({id:product.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product.delete({id:product.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/resource/resource-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.resource.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.resource.delete.question\" translate-values=\"{id: \'{{vm.resource.id}}\'}\">Are you sure you want to delete this Resource?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/resource/resource-detail.html","<div><h2><span translate=\"portalApp.resource.detail.title\">Resource</span> {{vm.resource.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.resource.url\">Url</span></dt><dd><span>{{vm.resource.url}}</span></dd><dt><span translate=\"portalApp.resource.description\">Description</span></dt><dd><span>{{vm.resource.description}}</span></dd><dt><span translate=\"portalApp.resource.round\">Round</span></dt><dd><a ui-sref=\"round-detail({id:vm.resource.roundId})\">{{vm.resource.roundId}}</a></dd><dt><span translate=\"portalApp.resource.resourceKey\">Resource Key</span></dt><dd><a ui-sref=\"resource-key-detail({id:vm.resource.resourceKeyId})\">{{vm.resource.resourceKeyId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/resource/resource-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myResourceLabel\" translate=\"portalApp.resource.home.createOrEditLabel\">Create or edit a Resource</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.resource.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.resource.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.resource.url\" for=\"field_url\">Url</label><input type=\"text\" class=\"form-control\" name=\"url\" id=\"field_url\" ng-model=\"vm.resource.url\" ng-maxlength=\"4096\"><div ng-show=\"editForm.url.$invalid\"><p class=\"help-block\" ng-show=\"editForm.url.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4096\">This field cannot be longer than 4096 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.resource.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.resource.description\" ng-maxlength=\"1024\"><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1024\">This field cannot be longer than 1024 characters.</p></div></div><div class=\"form-group\"><label translate=\"portalApp.resource.round\" for=\"field_round\">Round</label><select class=\"form-control\" id=\"field_round\" name=\"round\" ng-model=\"vm.resource.roundId\" ng-options=\"round.id as round.id for round in vm.rounds\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.resource.resourceKey\" for=\"field_resourceKey\">Resource Key</label><select class=\"form-control\" id=\"field_resourceKey\" name=\"resourceKey\" ng-model=\"vm.resource.resourceKeyId\" ng-options=\"resourceKey.id as resourceKey.id for resourceKey in vm.resourcekeys\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/resource/resources.html","<div><h2 translate=\"portalApp.resource.home.title\">Resources</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"resource.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.resource.home.createLabel\">Create new Resource</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.resource.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.resource.url\">Url</span></th><th><span translate=\"portalApp.resource.description\">Description</span></th><th><span translate=\"portalApp.resource.round\">Round</span></th><th><span translate=\"portalApp.resource.resourceKey\">Resource Key</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"resource in vm.resources track by resource.id\"><td><a ui-sref=\"resource-detail({id:resource.id})\">{{resource.id}}</a></td><td>{{resource.url}}</td><td>{{resource.description}}</td><td><a ui-sref=\"round-detail({id:resource.roundId})\">{{resource.roundId}}</a></td><td><a ui-sref=\"resource-key-detail({id:resource.resourceKeyId})\">{{resource.resourceKeyId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"resource-detail({id:resource.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"resource.edit({id:resource.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"resource.delete({id:resource.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/result/result-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.result.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.result.delete.question\" translate-values=\"{id: \'{{vm.result.id}}\'}\">Are you sure you want to delete this Result?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/result/result-detail.html","<div><h2><span translate=\"portalApp.result.detail.title\">Result</span> {{vm.result.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.result.actionCode\">Action Code</span></dt><dd><span>{{vm.result.actionCode}}</span></dd><dt><span translate=\"portalApp.result.revision\">Revision</span></dt><dd><a ui-sref=\"revision-detail({id:vm.result.revisionId})\">{{vm.result.revisionId}}</a></dd><dt><span translate=\"portalApp.result.round\">Round</span></dt><dd><a ui-sref=\"round-detail({id:vm.result.roundId})\">{{vm.result.roundRoundCode}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/result/result-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myResultLabel\" translate=\"portalApp.result.home.createOrEditLabel\">Create or edit a Result</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.result.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.result.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.result.actionCode\" for=\"field_actionCode\">Action Code</label><input type=\"text\" class=\"form-control\" name=\"actionCode\" id=\"field_actionCode\" ng-model=\"vm.result.actionCode\" ng-maxlength=\"10\"><div ng-show=\"editForm.actionCode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.actionCode.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</p></div></div><div class=\"form-group\"><label translate=\"portalApp.result.revision\" for=\"field_revision\">Revision</label><select class=\"form-control\" id=\"field_revision\" name=\"revision\" ng-model=\"vm.result.revisionId\" ng-options=\"revision.id as revision.id for revision in vm.revisions\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.result.round\" for=\"field_round\">Round</label><select class=\"form-control\" id=\"field_round\" name=\"round\" ng-model=\"vm.result.roundId\" ng-options=\"round.id as round.roundCode for round in vm.rounds\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/result/results.html","<div><h2 translate=\"portalApp.result.home.title\">Results</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"result.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.result.home.createLabel\">Create new Result</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.result.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.reset()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"actionCode\"><span translate=\"portalApp.result.actionCode\">Action Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"revisionId\"><span translate=\"portalApp.result.revision\">Revision</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"roundRoundCode\"><span translate=\"portalApp.result.round\">Round</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"vm.page >= vm.links[\'last\']\"><tr ng-repeat=\"result in vm.results track by result.id\"><td><a ui-sref=\"result-detail({id:result.id})\">{{result.id}}</a></td><td>{{result.actionCode}}</td><td><a ui-sref=\"revision-detail({id:result.revisionId})\">{{result.revisionId}}</a></td><td><a ui-sref=\"round-detail({id:result.roundId})\">{{result.roundRoundCode}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"result-detail({id:result.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"result.edit({id:result.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"result.delete({id:result.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/result-series/result-series-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.resultSeries.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.resultSeries.delete.question\" translate-values=\"{id: \'{{vm.resultSeries.id}}\'}\">Are you sure you want to delete this Result Series?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/result-series/result-series-detail.html","<div><h2><span translate=\"portalApp.resultSeries.detail.title\">Result Series</span> {{vm.resultSeries.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.resultSeries.result\">Result</span></dt><dd><a ui-sref=\"result-detail({id:vm.resultSeries.resultId})\">{{vm.resultSeries.resultId}}</a></dd><dt><span translate=\"portalApp.resultSeries.timeseries\">Timeseries</span></dt><dd><a ui-sref=\"timeseries-detail({id:vm.resultSeries.timeseriesId})\">{{vm.resultSeries.timeseriesName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/result-series/result-series-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myResultSeriesLabel\" translate=\"portalApp.resultSeries.home.createOrEditLabel\">Create or edit a Result Series</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.resultSeries.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.resultSeries.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"portalApp.resultSeries.result\" for=\"field_result\">Result</label><select class=\"form-control\" id=\"field_result\" name=\"result\" ng-model=\"vm.resultSeries.resultId\" ng-options=\"result.id as result.id for result in vm.results\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.resultSeries.timeseries\" for=\"field_timeseries\">Timeseries</label><select class=\"form-control\" id=\"field_timeseries\" name=\"timeseries\" ng-model=\"vm.resultSeries.timeseriesId\" ng-options=\"timeseries.id as timeseries.name for timeseries in vm.timeseries | orderBy:\'id\'\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/result-series/result-series.html","<div><h2 translate=\"portalApp.resultSeries.home.title\">Result Series</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"result-series.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.resultSeries.home.createLabel\">Create new Result Series</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.resultSeries.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"resultId\"><span translate=\"portalApp.resultSeries.result\">Result</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"timeseriesName\"><span translate=\"portalApp.resultSeries.timeseries\">Timeseries</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"resultSeries in vm.resultSeries track by resultSeries.id\"><td><a ui-sref=\"result-series-detail({id:resultSeries.id})\">{{resultSeries.id}}</a></td><td><a ui-sref=\"result-detail({id:resultSeries.resultId})\">{{resultSeries.resultId}}</a></td><td><a ui-sref=\"timeseries-detail({id:resultSeries.timeseriesId})\">{{resultSeries.timeseriesName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"result-series-detail({id:resultSeries.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"result-series.edit({id:resultSeries.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"result-series.delete({id:resultSeries.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/smoother-multiplier/smoother-multiplier-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.smootherMultiplier.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.smootherMultiplier.delete.question\" translate-values=\"{id: \'{{vm.smootherMultiplier.id}}\'}\">Are you sure you want to delete this Smoother Multiplier?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/smoother-multiplier/smoother-multiplier-detail.html","<div><h2><span translate=\"portalApp.smootherMultiplier.detail.title\">Smoother Multiplier</span> {{vm.smootherMultiplier.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.smootherMultiplier.modelSymbol\">Model Symbol</span></dt><dd><a ui-sref=\"model-symbol-detail({id:vm.smootherMultiplier.modelSymbolId})\">{{vm.smootherMultiplier.modelSymbolName}}</a></dd><dt><span translate=\"portalApp.smootherMultiplier.timeseries\">Timeseries</span></dt><dd><a ui-sref=\"timeseries-detail({id:vm.smootherMultiplier.timeseriesId})\">{{vm.smootherMultiplier.timeseriesName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/smoother-multiplier/smoother-multiplier-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySmootherMultiplierLabel\" translate=\"portalApp.smootherMultiplier.home.createOrEditLabel\">Create or edit a Smoother Multiplier</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.smootherMultiplier.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.smootherMultiplier.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"portalApp.smootherMultiplier.modelSymbol\" for=\"field_modelSymbol\">Model Symbol</label><select class=\"form-control\" id=\"field_modelSymbol\" name=\"modelSymbol\" ng-model=\"vm.smootherMultiplier.modelSymbolId\" ng-options=\"modelSymbol.id as modelSymbol.name for modelSymbol in vm.modelsymbols | orderBy:\'id\'\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.modelSymbol.$invalid\"><p class=\"help-block\" ng-show=\"editForm.modelSymbol.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"portalApp.smootherMultiplier.timeseries\" for=\"field_timeseries\">Timeseries</label><select class=\"form-control\" id=\"field_timeseries\" name=\"timeseries\" ng-model=\"vm.smootherMultiplier.timeseriesId\" ng-options=\"timeseries.id as timeseries.name for timeseries in vm.timeseries | orderBy:\'id\'\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.timeseries.$invalid\"><p class=\"help-block\" ng-show=\"editForm.timeseries.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/smoother-multiplier/smoother-multipliers.html","<div><h2 translate=\"portalApp.smootherMultiplier.home.title\">Smoother Multipliers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"smoother-multiplier.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.smootherMultiplier.home.createLabel\">Create new Smoother Multiplier</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.smootherMultiplier.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.smootherMultiplier.modelSymbol\">Model Symbol</span></th><th><span translate=\"portalApp.smootherMultiplier.timeseries\">Timeseries</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"smootherMultiplier in vm.smootherMultipliers track by smootherMultiplier.id\"><td><a ui-sref=\"smoother-multiplier-detail({id:smootherMultiplier.id})\">{{smootherMultiplier.id}}</a></td><td><a ui-sref=\"model-symbol-detail({id:smootherMultiplier.modelSymbolId})\">{{smootherMultiplier.modelSymbolName}}</a></td><td><a ui-sref=\"timeseries-detail({id:smootherMultiplier.timeseriesId})\">{{smootherMultiplier.timeseriesName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"smoother-multiplier-detail({id:smootherMultiplier.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"smoother-multiplier.edit({id:smootherMultiplier.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"smoother-multiplier.delete({id:smootherMultiplier.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/round/round-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.round.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.round.delete.question\" translate-values=\"{id: \'{{vm.round.id}}\'}\">Are you sure you want to delete this Round?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/round/round-detail.html","<div><h2><span translate=\"portalApp.round.detail.title\">Round</span> {{vm.round.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.round.roundCode\">Round Code</span></dt><dd><span>{{vm.round.roundCode}}</span></dd><dt><span translate=\"portalApp.round.blacklisted\">Blacklisted</span></dt><dd><span>{{vm.round.blacklisted}}</span></dd><dt><span translate=\"portalApp.round.created\">Created</span></dt><dd><span>{{vm.round.created | date:\'mediumDate\'}}</span></dd><dt><span translate=\"portalApp.round.lastHist\">Last Hist</span></dt><dd><span>{{vm.round.lastHist | date:\'mediumDate\'}}</span></dd><dt><span translate=\"portalApp.round.lastFore\">Last Fore</span></dt><dd><span>{{vm.round.lastFore | date:\'mediumDate\'}}</span></dd><dt><span translate=\"portalApp.round.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.round.productId})\">{{vm.round.productId}}</a></dd><dt><span translate=\"portalApp.round.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.round.countryId})\">{{vm.round.countryCode}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/round/round-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRoundLabel\" translate=\"portalApp.round.home.createOrEditLabel\">Create or edit a Round</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.round.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.round.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.round.roundCode\" for=\"field_roundCode\">Round Code</label><input type=\"text\" class=\"form-control\" name=\"roundCode\" id=\"field_roundCode\" ng-model=\"vm.round.roundCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.round.blacklisted\" for=\"field_blacklisted\">Blacklisted</label><input type=\"checkbox\" class=\"form-control\" name=\"blacklisted\" id=\"field_blacklisted\" ng-model=\"vm.round.blacklisted\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.round.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.round.created\" is-open=\"vm.datePickerOpenStatus.created\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.round.lastHist\" for=\"field_lastHist\">Last Hist</label><div class=\"input-group\"><input id=\"field_lastHist\" type=\"text\" class=\"form-control\" name=\"lastHist\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.round.lastHist\" is-open=\"vm.datePickerOpenStatus.lastHist\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastHist\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.round.lastFore\" for=\"field_lastFore\">Last Fore</label><div class=\"input-group\"><input id=\"field_lastFore\" type=\"text\" class=\"form-control\" name=\"lastFore\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.round.lastFore\" is-open=\"vm.datePickerOpenStatus.lastFore\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastFore\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"portalApp.round.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.round.productId\" ng-options=\"product.id as product.id for product in vm.products\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.round.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.round.countryId\" ng-options=\"country.id as country.code for country in vm.countries\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/round/rounds.html","<div><h2 translate=\"portalApp.round.home.title\">Rounds</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"round.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.round.home.createLabel\">Create new Round</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.round.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.reset()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"roundCode\"><span translate=\"portalApp.round.roundCode\">Round Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"blacklisted\"><span translate=\"portalApp.round.blacklisted\">Blacklisted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"created\"><span translate=\"portalApp.round.created\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastHist\"><span translate=\"portalApp.round.lastHist\">Last Hist</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastFore\"><span translate=\"portalApp.round.lastFore\">Last Fore</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productId\"><span translate=\"portalApp.round.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryCode\"><span translate=\"portalApp.round.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"vm.page >= vm.links[\'last\']\"><tr ng-repeat=\"round in vm.rounds track by round.id\"><td><a ui-sref=\"round-detail({id:round.id})\">{{round.id}}</a></td><td>{{round.roundCode}}</td><td>{{round.blacklisted}}</td><td>{{round.created | date:\'mediumDate\'}}</td><td>{{round.lastHist | date:\'mediumDate\'}}</td><td>{{round.lastFore | date:\'mediumDate\'}}</td><td><a ui-sref=\"product-detail({id:round.productId})\">{{round.productId}}</a></td><td><a ui-sref=\"country-detail({id:round.countryId})\">{{round.countryCode}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"round-detail({id:round.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"round.edit({id:round.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"round.delete({id:round.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/revision/revision-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.revision.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.revision.delete.question\" translate-values=\"{id: \'{{vm.revision.id}}\'}\">Are you sure you want to delete this Revision?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/revision/revision-detail.html","<div><h2><span translate=\"portalApp.revision.detail.title\">Revision</span> {{vm.revision.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.revision.description\">Description</span></dt><dd><span>{{vm.revision.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/revision/revision-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRevisionLabel\" translate=\"portalApp.revision.home.createOrEditLabel\">Create or edit a Revision</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.revision.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.revision.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.revision.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.revision.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/revision/revisions.html","<div><h2 translate=\"portalApp.revision.home.title\">Revisions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"revision.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.revision.home.createLabel\">Create new Revision</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.revision.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.reset()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"portalApp.revision.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"vm.page >= vm.links[\'last\']\"><tr ng-repeat=\"revision in vm.revisions track by revision.id\"><td><a ui-sref=\"revision-detail({id:revision.id})\">{{revision.id}}</a></td><td>{{revision.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"revision-detail({id:revision.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"revision.edit({id:revision.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"revision.delete({id:revision.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/subscription/subscription-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.subscription.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.subscription.delete.question\" translate-values=\"{id: \'{{vm.subscription.id}}\'}\">Are you sure you want to delete this Subscription?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/subscription/subscription-detail.html","<div><h2><span translate=\"portalApp.subscription.detail.title\">Subscription</span> {{vm.subscription.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.subscription.startDate\">Start Date</span></dt><dd><span>{{vm.subscription.startDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"portalApp.subscription.endDate\">End Date</span></dt><dd><span>{{vm.subscription.endDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"portalApp.subscription.userGroup\">User Group</span></dt><dd><a ui-sref=\"user-group-detail({id:vm.subscription.userGroupId})\">{{vm.subscription.userGroupName}}</a></dd><dt><span translate=\"portalApp.subscription.application\">Application</span></dt><dd><a ui-sref=\"application-detail({id:vm.subscription.applicationId})\">{{vm.subscription.applicationName}}</a></dd><dt><span translate=\"portalApp.subscription.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.subscription.countryId})\">{{vm.subscription.countryCode}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/subscription/subscription-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySubscriptionLabel\" translate=\"portalApp.subscription.home.createOrEditLabel\">Create or edit a Subscription</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.subscription.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.subscription.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.subscription.startDate\" for=\"field_start_date\">Start Date</label><div class=\"input-group\"><input id=\"field_start_date\" type=\"text\" class=\"form-control\" name=\"startDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.subscription.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.subscription.endDate\" for=\"field_end_date\">End Date</label><div class=\"input-group\"><input id=\"field_end_date\" type=\"text\" class=\"form-control\" name=\"endDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.subscription.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"portalApp.subscription.userGroup\" for=\"field_userGroup\">User Group</label><select class=\"form-control\" id=\"field_userGroup\" name=\"userGroup\" ng-model=\"vm.subscription.userGroupId\" ng-options=\"userGroup.id as userGroup.name for userGroup in vm.usergroups\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.subscription.application\" for=\"field_application\">Application</label><select class=\"form-control\" id=\"field_application\" name=\"application\" ng-model=\"vm.subscription.applicationId\" ng-options=\"application.id as application.name for application in vm.applications\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.subscription.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.subscription.countryId\" ng-options=\"country.id as country.code for country in vm.countries\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/subscription/subscriptions.html","<div><h2 translate=\"portalApp.subscription.home.title\">Subscriptions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"subscription.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.subscription.home.createLabel\">Create new Subscription</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.subscription.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"portalApp.subscription.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endDate\"><span translate=\"portalApp.subscription.endDate\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userGroupName\"><span translate=\"portalApp.subscription.userGroup\">User Group</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"applicationName\"><span translate=\"portalApp.subscription.application\">Application</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryCode\"><span translate=\"portalApp.subscription.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"subscription in vm.subscriptions track by subscription.id\"><td><a ui-sref=\"subscription-detail({id:subscription.id})\">{{subscription.id}}</a></td><td>{{subscription.startDate | date:\'mediumDate\'}}</td><td>{{subscription.endDate | date:\'mediumDate\'}}</td><td><a ui-sref=\"user-group-detail({id:subscription.userGroupId})\">{{subscription.userGroupName}}</a></td><td><a ui-sref=\"application-detail({id:subscription.applicationId})\">{{subscription.applicationName}}</a></td><td><a ui-sref=\"country-detail({id:subscription.countryId})\">{{subscription.countryCode}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"subscription-detail({id:subscription.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"subscription.edit({id:subscription.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"subscription.delete({id:subscription.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/result-report/result-report-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.resultReport.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.resultReport.delete.question\" translate-values=\"{id: \'{{vm.resultReport.id}}\'}\">Are you sure you want to delete this Result Report?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/result-report/result-report-detail.html","<div><h2><span translate=\"portalApp.resultReport.detail.title\">Result Report</span> {{vm.resultReport.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.resultReport.reportText\">Report Text</span></dt><dd><span>{{vm.resultReport.reportText}}</span></dd><dt><span translate=\"portalApp.resultReport.reportPdf\">Report Pdf</span></dt><dd><div ng-if=\"vm.resultReport.reportPdf\"><a ng-click=\"vm.openFile(vm.resultReport.reportPdfContentType, vm.resultReport.reportPdf)\" translate=\"entity.action.open\">open</a> {{vm.resultReport.reportPdfContentType}}, {{vm.byteSize(vm.resultReport.reportPdf)}}</div></dd><dt><span translate=\"portalApp.resultReport.result\">Result</span></dt><dd><a ui-sref=\"result-detail({id:vm.resultReport.resultId})\">{{vm.resultReport.resultAction_code}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/result-report/result-report-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myResultReportLabel\" translate=\"portalApp.resultReport.home.createOrEditLabel\">Create or edit a Result Report</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.resultReport.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.resultReport.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.resultReport.reportText\" for=\"field_reportText\">Report Text</label><textarea class=\"form-control\" name=\"reportText\" id=\"field_reportText\" ng-model=\"vm.resultReport.reportText\">\n        </div>\n        <div class=\"form-group\" ngf-drop ngf-change=\"vm.setReportPdf($file, vm.resultReport)\">\n            <label class=\"control-label\" translate=\"portalApp.resultReport.reportPdf\" for=\"field_reportPdf\">Report Pdf</label>\n            <div>\n                <div ng-if=\"vm.resultReport.reportPdf\" class=\"help-block clearfix\">\n                    <a class=\"pull-left\" ng-click=\"vm.openFile(vm.resultReport.reportPdfContentType, vm.resultReport.reportPdf)\" translate=\"entity.action.open\">open</a><br>\n                    <span class=\"pull-left\">{{vm.resultReport.reportPdfContentType}}, {{vm.byteSize(vm.resultReport.reportPdf)}}</span>\n                    <button ng-click=\"vm.resultReport.reportPdf=null;vm.resultReport.reportPdfContentType=null;\" class=\"btn btn-default btn-xs pull-right\">\n                        <span class=\"glyphicon glyphicon-remove\"></span>\n                    </button>\n                </div>\n                <button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setReportPdf($file, vm.resultReport)\" translate=\"entity.action.addblob\">\n                    Add blob\n                </button>\n            </div>\n            <input type=\"hidden\" class=\"form-control\" name=\"reportPdf\" id=\"field_reportPdf\" ng-model=\"vm.resultReport.reportPdf\">\n            <input type=\"hidden\" class=\"form-control\" name=\"reportPdfContentType\" id=\"field_reportPdfContentType\" ng-model=\"vm.resultReport.reportPdfContentType\">\n        </div>\n\n        <div class=\"form-group\">\n            <label translate=\"portalApp.resultReport.result\" for=\"field_result\">Result</label>\n            <select class=\"form-control\" id=\"field_result\" name=\"result\" ng-model=\"vm.resultReport.resultId\" ng-options=\"result.id as result.action_code for result in vm.results\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">\n            <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>");
$templateCache.put("app/entities/result-report/result-reports.html","<div><h2 translate=\"portalApp.resultReport.home.title\">Result Reports</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"result-report.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.resultReport.home.createLabel\">Create new Result Report</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.resultReport.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.resultReport.reportText\">Report Text</span></th><th><span translate=\"portalApp.resultReport.reportPdf\">Report Pdf</span></th><th><span translate=\"portalApp.resultReport.result\">Result</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"resultReport in vm.resultReports track by resultReport.id\"><td><a ui-sref=\"result-report-detail({id:resultReport.id})\">{{resultReport.id}}</a></td><td>{{resultReport.reportText}}</td><td><a ng-if=\"resultReport.reportPdf\" ng-click=\"vm.openFile(resultReport.reportPdfContentType, resultReport.reportPdf)\" translate=\"entity.action.open\">open</a> <span ng-if=\"resultReport.reportPdf\">{{resultReport.reportPdfContentType}}, {{vm.byteSize(resultReport.reportPdf)}}</span></td><td><a ui-sref=\"result-detail({id:resultReport.resultId})\">{{resultReport.resultAction_code}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"result-report-detail({id:resultReport.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"result-report.edit({id:resultReport.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"result-report.delete({id:resultReport.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/timeseries/timeseries-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.timeseries.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.timeseries.delete.question\" translate-values=\"{id: \'{{vm.timeseries.id}}\'}\">Are you sure you want to delete this Timeseries?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/timeseries/timeseries-detail.html","<div><h2><span translate=\"portalApp.timeseries.detail.title\">Timeseries</span> {{vm.timeseries.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.timeseries.name\">Name</span></dt><dd><span>{{vm.timeseries.name}}</span></dd><dt><span translate=\"portalApp.timeseries.description\">Description</span></dt><dd><span>{{vm.timeseries.description}}</span></dd><dt><span translate=\"portalApp.timeseries.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.timeseries.countryId})\">{{vm.timeseries.countryId}}</a></dd><dt><span translate=\"portalApp.timeseries.frequency\">Frequency</span></dt><dd><a ui-sref=\"frequency-detail({id:vm.timeseries.frequencyId})\">{{vm.timeseries.frequencyId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/timeseries/timeseries-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTimeseriesLabel\" translate=\"portalApp.timeseries.home.createOrEditLabel\">Create or edit a Timeseries</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.timeseries.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.timeseries.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.timeseries.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.timeseries.name\" ng-maxlength=\"63\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"63\">This field cannot be longer than 63 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.timeseries.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.timeseries.description\" ng-maxlength=\"500\"><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"500\">This field cannot be longer than 500 characters.</p></div></div><div class=\"form-group\"><label translate=\"portalApp.timeseries.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.timeseries.countryId\" ng-options=\"country.id as country.id for country in vm.countries\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.timeseries.frequency\" for=\"field_frequency\">Frequency</label><select class=\"form-control\" id=\"field_frequency\" name=\"frequency\" ng-model=\"vm.timeseries.frequencyId\" ng-options=\"frequency.id as frequency.id for frequency in vm.frequencies\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/timeseries/timeseries.html","<div><h2 translate=\"portalApp.timeseries.home.title\">Timeseries</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"timeseries.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.timeseries.home.createLabel\">Create new Timeseries</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.timeseries.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.reset()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.timeseries.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"portalApp.timeseries.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryId\"><span translate=\"portalApp.timeseries.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"frequencyId\"><span translate=\"portalApp.timeseries.frequency\">Frequency</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"vm.page >= vm.links[\'last\']\"><tr ng-repeat=\"timeseries in vm.timeseries track by timeseries.id\"><td><a ui-sref=\"timeseries-detail({id:timeseries.id})\">{{timeseries.id}}</a></td><td>{{timeseries.name}}</td><td>{{timeseries.description}}</td><td><a ui-sref=\"country-detail({id:timeseries.countryId})\">{{timeseries.countryId}}</a></td><td><a ui-sref=\"frequency-detail({id:timeseries.frequencyId})\">{{timeseries.frequencyId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"timeseries-detail({id:timeseries.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"timeseries.edit({id:timeseries.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"timeseries.delete({id:timeseries.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/timeseries-data/timeseries-data-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.timeseriesData.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.timeseriesData.delete.question\" translate-values=\"{id: \'{{vm.timeseriesData.id}}\'}\">Are you sure you want to delete this Timeseries Data?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/timeseries-data/timeseries-data-detail.html","<div><h2><span translate=\"portalApp.timeseriesData.detail.title\">Timeseries Data</span> {{vm.timeseriesData.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.timeseriesData.period\">Period</span></dt><dd><span>{{vm.timeseriesData.period}}</span></dd><dt><span translate=\"portalApp.timeseriesData.date\">Date</span></dt><dd><span>{{vm.timeseriesData.date | date:\'medium\'}}</span></dd><dt><span translate=\"portalApp.timeseriesData.value\">Value</span></dt><dd><span>{{vm.timeseriesData.value}}</span></dd><dt><span translate=\"portalApp.timeseriesData.object_count\">Object Count</span></dt><dd><span>{{vm.timeseriesData.object_count}}</span></dd><dt><span translate=\"portalApp.timeseriesData.object_values\">Object Values</span></dt><dd><div ng-if=\"vm.timeseriesData.object_values\">{{vm.timeseriesData.object_type}}, {{vm.byteSize(vm.timeseriesData.object_values)}}</div></dd><dt><span translate=\"portalApp.timeseriesData.timeseries\">Timeseries</span></dt><dd><a ui-sref=\"timeseries-detail({id:vm.timeseriesData.timeseriesId})\">{{vm.timeseriesData.timeseriesName}}</a></dd><dt><span translate=\"portalApp.timeseriesData.revision_from\">Revision From</span></dt><dd><span ng-repeat=\"revision_from in vm.timeseriesData.revision_froms\"><a ui-sref=\"revision-detail({id: {{revision_from.id}}})\">{{revision_from.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"portalApp.timeseriesData.revision_to\">Revision To</span></dt><dd><span ng-repeat=\"revision_to in vm.timeseriesData.revision_tos\"><a ui-sref=\"revision-detail({id: {{revision_to.id}}})\">{{revision_to.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/timeseries-data/timeseries-data-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTimeseriesDataLabel\" translate=\"portalApp.timeseriesData.home.createOrEditLabel\">Create or edit a Timeseries Data</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.timeseriesData.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.timeseriesData.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.timeseriesData.period\" for=\"field_period\">Period</label><input type=\"text\" class=\"form-control\" name=\"period\" id=\"field_period\" ng-model=\"vm.timeseriesData.period\" ng-maxlength=\"7\"><div ng-show=\"editForm.period.$invalid\"><p class=\"help-block\" ng-show=\"editForm.period.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"7\">This field cannot be longer than 7 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.timeseriesData.date\" for=\"field_date\">Date</label><div class=\"input-group\"><input id=\"field_date\" type=\"text\" class=\"form-control\" name=\"date\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.timeseriesData.date\" is-open=\"vm.datePickerOpenStatus.date\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'date\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.timeseriesData.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.timeseriesData.value\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.timeseriesData.object_count\" for=\"field_object_count\">Object Count</label><input type=\"number\" class=\"form-control\" name=\"object_count\" id=\"field_object_count\" ng-model=\"vm.timeseriesData.object_count\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.timeseriesData.object_type\" for=\"field_object_type\">Object Type</label><input type=\"text\" class=\"form-control\" name=\"object_type\" id=\"field_object_type\" ng-model=\"vm.timeseriesData.object_type\" ng-maxlength=\"25\"><div ng-show=\"editForm.object_type.$invalid\"><p class=\"help-block\" ng-show=\"editForm.object_type.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"25\">This field cannot be longer than 25 characters.</p></div></div><div class=\"form-group\" ngf-drop ngf-change=\"\"><label class=\"control-label\" translate=\"portalApp.timeseriesData.object_values\" for=\"field_object_values\">Object Values</label><div><div ng-if=\"vm.timeseriesData.object_values\" class=\"help-block clearfix\"><span class=\"pull-left\">{{vm.timeseriesData.object_type}}, {{vm.byteSize(vm.timeseriesData.object_values)}}</span> <button ng-click=\"\" class=\"btn btn-default btn-xs pull-right disabled\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block disabled\" ngf-change=\"\" translate=\"entity.action.addblob\">Add blob</button></div><input type=\"hidden\" class=\"form-control\" name=\"object_values\" id=\"field_object_values\" ng-model=\"vm.timeseriesData.object_values\"></div><div class=\"form-group\"><label translate=\"portalApp.timeseriesData.timeseries\" for=\"field_timeseries\">Timeseries</label><select class=\"form-control\" id=\"field_timeseries\" name=\"timeseries\" ng-model=\"vm.timeseriesData.timeseriesId\" ng-options=\"timeseries.id as timeseries.name for timeseries in vm.timeseries\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"portalApp.timeseriesData.revision_from\" for=\"field_revision_from\">Revision From</label><select class=\"form-control\" id=\"field_revision_from\" multiple=\"multiple\" name=\"revision_from\" ng-model=\"vm.timeseriesData.revision_froms\" ng-options=\"revision as revision.id for revision in vm.revisions track by revision.id\"></select></div><div class=\"form-group\"><label translate=\"portalApp.timeseriesData.revision_to\" for=\"field_revision_to\">Revision To</label><select class=\"form-control\" id=\"field_revision_to\" multiple=\"multiple\" name=\"revision_to\" ng-model=\"vm.timeseriesData.revision_tos\" ng-options=\"revision as revision.id for revision in vm.revisions track by revision.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/timeseries-data/timeseries-data.html","<div><h2 translate=\"portalApp.timeseriesData.home.title\">Timeseries Data</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"timeseries-data.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.timeseriesData.home.createLabel\">Create new Timeseries Data</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.timeseriesData.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.reset()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"period\"><span translate=\"portalApp.timeseriesData.period\">Period</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"date\"><span translate=\"portalApp.timeseriesData.date\">Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"portalApp.timeseriesData.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"object_count\"><span translate=\"portalApp.timeseriesData.object_count\">Object Count</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"object_type\"><span translate=\"portalApp.timeseriesData.object_type\">Object Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"object_values\"><span translate=\"portalApp.timeseriesData.object_values\">Object Values</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"timeseriesName\"><span translate=\"portalApp.timeseriesData.timeseries\">Timeseries</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"vm.page >= vm.links[\'last\']\"><tr ng-repeat=\"timeseriesData in vm.timeseriesData track by timeseriesData.id\"><td><a ui-sref=\"timeseries-data-detail({id:timeseriesData.id})\">{{timeseriesData.id}}</a></td><td>{{timeseriesData.period}}</td><td>{{timeseriesData.date | date:\'medium\'}}</td><td>{{timeseriesData.value}}</td><td>{{timeseriesData.object_count}}</td><td>{{timeseriesData.object_type}}</td><td><span ng-if=\"timeseriesData.object_values\">{{timeseriesData.object_type}}, {{vm.byteSize(timeseriesData.object_values)}}</span></td><td><a ui-sref=\"timeseries-detail({id:timeseriesData.timeseriesId})\">{{timeseriesData.timeseriesName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"timeseries-data-detail({id:timeseriesData.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"timeseries-data.edit({id:timeseriesData.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"timeseries-data.delete({id:timeseriesData.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/translation/translation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.translation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.translation.delete.question\" translate-values=\"{id: \'{{vm.translation.id}}\'}\">Are you sure you want to delete this Translation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/translation/translation-detail.html","<div><h2><span translate=\"portalApp.translation.detail.title\">Translation</span> {{vm.translation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.translation.keyPhrase\">Key Phrase</span></dt><dd><span>{{vm.translation.keyPhrase}}</span></dd><dt><span translate=\"portalApp.translation.languageKey\">Language Key</span></dt><dd><span>{{vm.translation.languageKey}}</span></dd><dt><span translate=\"portalApp.translation.translation\">Translation</span></dt><dd><span>{{vm.translation.translation}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/translation/translation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTranslationLabel\" translate=\"portalApp.translation.home.createOrEditLabel\">Create or edit a Translation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.translation.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.translation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.translation.keyPhrase\" for=\"field_keyPhrase\">Key Phrase</label><input type=\"text\" class=\"form-control\" name=\"keyPhrase\" id=\"field_keyPhrase\" ng-model=\"vm.translation.keyPhrase\" required ng-maxlength=\"65535\"><div ng-show=\"editForm.keyPhrase.$invalid\"><p class=\"help-block\" ng-show=\"editForm.keyPhrase.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.keyPhrase.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"65535\">This field cannot be longer than 65535 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.translation.languageKey\" for=\"field_languageKey\">Language Key</label><input type=\"text\" class=\"form-control\" name=\"languageKey\" id=\"field_languageKey\" ng-model=\"vm.translation.languageKey\" required ng-minlength=\"2\" ng-maxlength=\"5\"><div ng-show=\"editForm.languageKey.$invalid\"><p class=\"help-block\" ng-show=\"editForm.languageKey.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.languageKey.$error.minlength\" translate=\"entity.validation.minlength\" translate-value-min=\"2\">This field is required to be at least 2 characters.</p><p class=\"help-block\" ng-show=\"editForm.languageKey.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"5\">This field cannot be longer than 5 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.translation.translation\" for=\"field_translation\">Translation</label><input type=\"text\" class=\"form-control\" name=\"translation\" id=\"field_translation\" ng-model=\"vm.translation.translation\" required ng-maxlength=\"65535\"><div ng-show=\"editForm.translation.$invalid\"><p class=\"help-block\" ng-show=\"editForm.translation.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.translation.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"65535\">This field cannot be longer than 65535 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/translation/translations.html","<div><h2 translate=\"portalApp.translation.home.title\">Translations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"translation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.translation.home.createLabel\">Create new Translation</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.translation.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"portalApp.translation.keyPhrase\">Key Phrase</span></th><th><span translate=\"portalApp.translation.languageKey\">Language Key</span></th><th><span translate=\"portalApp.translation.translation\">Translation</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"translation in vm.translations track by translation.id\"><td><a ui-sref=\"translation-detail({id:translation.id})\">{{translation.id}}</a></td><td>{{translation.keyPhrase}}</td><td>{{translation.languageKey}}</td><td>{{translation.translation}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"translation-detail({id:translation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"translation.edit({id:translation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"translation.delete({id:translation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/user-group/user-group-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.userGroup.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"portalApp.userGroup.delete.question\" translate-values=\"{id: \'{{vm.userGroup.id}}\'}\">Are you sure you want to delete this User Group?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/user-group/user-group-detail.html","<div><h2><span translate=\"portalApp.userGroup.detail.title\">User Group</span> {{vm.userGroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"portalApp.userGroup.name\">Name</span></dt><dd><span>{{vm.userGroup.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/user-group/user-group-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserGroupLabel\" translate=\"portalApp.userGroup.home.createOrEditLabel\">Create or edit a User Group</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.userGroup.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.userGroup.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"portalApp.userGroup.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.userGroup.name\" required ng-maxlength=\"255\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/user-group/user-groups.html","<div><h2 translate=\"portalApp.userGroup.home.title\">User Groups</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"user-group.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"portalApp.userGroup.home.createLabel\">Create new User Group</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'portalApp.userGroup.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"portalApp.userGroup.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"userGroup in vm.userGroups track by userGroup.id\"><td><a ui-sref=\"user-group-detail({id:userGroup.id})\">{{userGroup.id}}</a></td><td>{{userGroup.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-group-detail({id:userGroup.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-group.edit({id:userGroup.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-group.delete({id:userGroup.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-6\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\"><span translate=\"error.403\">You are not authorized to access the page.</span><br><br><a ui-sref=\"home\" translate=\"error.back\">Back</a></div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-6\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}<br><br><a ui-sref=\"home\" translate=\"error.back\">Back</a></div></div></div></div></div>");
$templateCache.put("app/layouts/footer/footer.html","<hr><div><div class=\"row\"><div class=\"footer-version\">OGResearch YCM Portal {{vm.applicationVersion}}</div></div><div class=\"row\"><div class=\"ogresearch-footer\"><p translate=\"footer\" translate-values=\"{ year: \'{{vm.year}}\' }\">Copyright © {{ vm.year }} OGResearch, s.r.o. All rights reserved.</p></div></div></div>");
$templateCache.put("app/layouts/navbar/navbar.html","<nav class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-click=\"vm.toggleNavbar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand logo\" href=\"#/\" ng-click=\"vm.collapseNavbar()\"><img class=\"logo-img\" src=\"content/images/logo-ogr-gw.svg\"></a></div><div class=\"navbar-collapse\" uib-collapse=\"vm.isNavbarCollapsed\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav navbar-nav navbar-right\"><!--<li ng-class=\"{active: (vm.$state.includes(\'main\') && !vm.$state.params.countryId && !vm.$state.params.roundId)}\"\n                    ng-switch-when=\"true\">\n                    <a ui-sref=\"main\" ng-click=\"vm.collapseNavbar()\">\n                        <span class=\"glyphicon glyphicon-home\"></span>\n                        <span class=\"hidden-sm\" translate=\"global.menu.overview\">Overview</span>\n                    </a>\n                </li>--><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"glyphicon glyphicon-th-list\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"timeseries\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.timeseries\">Timeseries</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"country\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.country\">Country</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"frequency\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.frequency\">Frequency</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"timeseries-data\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.timeseriesData\">Timeseries Data</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"revision\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.revision\">Revision</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"round\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.round\">Round</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.product\">Product</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"application\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.application\">Application</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"application-journal\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.applicationJournal\">Application Journal</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"result\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.result\">Result</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"result-series\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.resultSeries\">Result Series</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"result-report\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.resultReport\">Result Report</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"translation\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.translation\">Translation</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"user-group\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.userGroup\">User Group</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"subscription\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.subscription\">Subscription</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"application-feature\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.applicationFeature\">Application Features</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"account-menu\"><span><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-sm\" translate=\"global.menu.account.main\">Account </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\">--><li ui-sref-active=\"active\"><a ui-sref=\"settings\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-wrench\"></span>&nbsp; <span translate=\"global.menu.account.settings\">Settings</span></a></li><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\">--><li ui-sref-active=\"active\"><a ui-sref=\"data_protection_policy\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-file\"></span> <span>Data Protection Policy</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-lock\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\">--><li ui-sref-active=\"active\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"glyphicon glyphicon-log-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li><!--<li ui-sref-active=\"active\" ng-switch-when=\"false\">\n                            <a href=\"\" ng-click=\"vm.login()\" id=\"login\">\n                                <span class=\"glyphicon glyphicon-log-in\"></span>&nbsp;\n                                <span translate=\"global.menu.account.login\">Sign in</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active=\"active\" ng-switch-when=\"false\">\n                            <a ui-sref=\"register\" ng-click=\"vm.collapseNavbar()\">\n                                <span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp;\n                                <span translate=\"global.menu.account.register\">Register</span>\n                            </a>\n                        </li>--></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"application-feature-user-group-map\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-cloud\"></span>&nbsp; <span translate=\"global.menu.entities.applicationFeatureUserGroupMap\">Application Feature User Group Mapping</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"application-feature-entity-map\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-cloud\"></span>&nbsp; <span translate=\"global.menu.entities.applicationFeatureEntityMap\">Application Feature Entity Mapping</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"statistics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.statistics\">Users Statistics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"companies-statistics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.companies-statistics\">Companies Statistics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><!--<li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\">\n                    <a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\">\n                        <span>\n                            <span class=\"glyphicon glyphicon-flag\"></span>\n                            <span class=\"hidden-sm\" translate=\"global.menu.language\">Language</span>\n                            <b class=\"caret\"></b>\n                        </span>\n                    </a>\n                    <ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\">\n                        <li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\">\n                            <a href=\"\" ng-click=\"languageVm.changeLanguage(language);vm.collapseNavbar();\">{{language |\n                                findLanguageFromKey}}</a>\n                        </li>\n                    </ul>\n                </li>--></ul></div></div></nav>");
$templateCache.put("app/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");}]);})();